function initSystemSettings($el) {
	pjqIsSub = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.SETTINGS_LOCK);

	window.settings = null;
	window.companyInfo = null;
	window.planroomSettings = null;
	window.orderingSettings = null;
	window.addressBookSettings = null;
	window.pjqHidden = 'pjq-settings-hidden';
	window.planroomSettingsInit = false;
	window.abSettingsInit = false;
	window.abGroupsGridInit = false;
	window.abRegionsGridInit = false;
	window.cfDatePickerInit = false;
	window.cfChoiceDeleteArray = [];
	window.newRowCounter = 0;
	window.newNodeCounter = 0;
	window.uploadContext = null;
	window.userImagePath = null;
	window.menuXML = null;
	window.linkProcoreStatus = null;
	window.linkProcoreButton = null;
	window.unlinkProcoreButton = null;
	window.lastCustomFieldId = null;

	window.validator = jQuery("Form[name='Form']").validate({
		onsubmit: false,
		onkeyup: false,
		showErrors: function (errorMap, errorList) {
			for (var i = 0; errorList[i]; i++) {
				var element = this.errorList[i].element;
				//solves the problem with brute force
				//remove existing error label and thus force plugin to recreate it
				//recreation == call to errorplacement function
				this.errorsFor(element).remove();
			}
			this.defaultShowErrors();
		},
		errorPlacement: function (error, element) {
			error.html('<br />' + error.text());
			if (element.attr('tagName') == 'select' || element.hasClass('pjq-numeric-field-width'))
				error.appendTo(element.parent().parent());
			else
				error.appendTo(element.parent());
		},
		errorClass: "pjq-errortext",
		ignore: "pjq-validate-ignore"
	});

	PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PJQSETTINGS, 'Master', {isOldModule: true}), $el, {}, function () {
		let rfiNameOverride = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.RFI_NAME_OVERRIDE);
		if (_.size(rfiNameOverride) > 0) {
			$('.rfi-span').html(rfiNameOverride);
		}

		jQuery('#mainSettingsTabs').tabs({
			active: 0
		}).addClass('ui-tabs-vertical');
		jQuery(".ui-tabs-vertical .ui-tabs-nav").removeClass("ui-tabs-nav").addClass("ui-tabs-nav-vert");
		jQuery('#planroomSettingsSubTabs , #profileSettingsSubTabs , #addressBookSettingsSubTabs , #submallSettingsSubTabs').tabs({
			active: 0
		});
		var actionButtons = jQuery('.buttonContainer');
		settingsSaveBtn = jQuery('#settingsSave');
		jQuery('#settingsSave').button();
		jQuery('#settingsSave').button('disable');
		jQuery('#settingsCancel').button();
		jQuery('#settingsCancel').button('disable');

		jQuery(".formatPhone").on('change', function () {
			jQuery(this).val(FormatPhoneHelper(jQuery(this).val()));
		});

		jQuery('#profilePaymentExpiresYear').on('change', function () {
			if (jQuery(this).val() == (new Date).getFullYear().toString()) {
				jQuery('#profilePaymentExpiresMonth').find('option').each(function () {
					if (parseInt(jQuery(this).val()) < (new Date).getMonth())
						jQuery(this).hide();
				});
				if (parseInt(jQuery('#profilePaymentExpiresMonth').val()) < (new Date).getMonth()) {
					var month = '';
					if ((new Date).getMonth().toString().length == 1)
						month = '0' + (new Date).getMonth().toString();
					else
						month = (new Date).getMonth().toString();

					jQuery('#profilePaymentExpiresMonth').val(month);
				}
			}
			else {
				jQuery('#profilePaymentExpiresMonth').find('option').show();
			}
		})
		jQuery(".validateCard").on('keyup change', function () {
			var cNum = jQuery(this).val().replace(new RegExp('-', 'g'), '');
			if ((cNum.length != 16 && cNum.length != 15) || !ValidateLuhnValue(cNum)) {
				jQuery(this).siblings('.validateCardSuccess').hide()
				jQuery(this).siblings('.validateCardFail').show();
			}
			else {
				jQuery(this).siblings('.validateCardFail').hide();
				jQuery(this).siblings('.validateCardSuccess').show();
			}
		});

		PanteraScript.PanteraScriptService.GetPJQSettingsSettings(pjqSessionId, GetPJQSettingsSettings, onScriptError);
		PanteraScript.PanteraScriptService.GetCompanyInfoSettings(pjqSessionId, GetCompanyInfo, onScriptError);
		PanteraScript.PanteraScriptService.GetPaymentInfoSettings(pjqSessionId, GetPaymentInfo, onScriptError);
		if (typeof fbApiKey !== 'undefined' && fbApiKey != 0) {
			FB.init({
				appId: fbApiKey,
				xfbml: true,
				version: 'v2.2'
			});
			PanteraScript.PanteraScriptService.GetPanteraUserSocialMediaStatus(pjqSessionId, GetSocialMediaStatus, onScriptError);
		}
		else {
			jQuery('#socialMediaContainer').hide();
		}

		if (!pjqIsSub) {
			PanteraScript.PanteraScriptService.GetPlanroomGeneralSettings(pjqSessionId, GetPlanroomSettings, onScriptError);
			PanteraScript.PanteraScriptService.GetPlanroomAddressBookSettings(pjqSessionId, GetAddressBookSettings, onScriptError);
		}
		else {
			jQuery('#li-main-planroom-settings').hide();
			jQuery('#li-main-addressbook-settings').hide();
		}

		var settingsTabSelect = jQuery('#mainSettingsTabs').find('ul').first();
		settingsTabSelect.after(jQuery('.buttonContainer'));
		jQuery('.buttonContainer').width(settingsTabSelect.width());
		jQuery('.buttonContainer').css('top', settingsTabSelect.height() + 20);

		jQuery.ajax({
			url: "/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=GridMenu&customFieldid=0",
			type: 'GET',
			dataType: 'text',
			timeout: 2000,
			error: function () {
			},
			success: function (xml) {
				menuXML = xml;
			}
		});

		jQuery("#customFieldDefaultValue-DATE, #customFieldDefaultValue-DATETIMEDATE").mask('99/99/9999', {
			placeholder: ""
		});

		jQuery('#profileSettingsSubTabs').on('tabsactivate', function (event, ui) {
			actionButtons.removeClass(pjqHidden);
		});

		jQuery('#mainSettingsTabs').on('tabsactivate', function (event, ui) {
			var activeTab = jQuery('#mainSettingsTabs').tabs('option', 'active');
			if (activeTab == 0) {
				activeTab = jQuery('#profileSettingsSubTabs').tabs('option', 'active');
				if (activeTab == 3) {
					actionButtons.addClass(pjqHidden);
				}
				else {
					actionButtons.removeClass(pjqHidden);
				}
			}
			else if (activeTab == 1) {
				activeTab = jQuery('#planroomSettingsSubTabs').tabs('option', 'active');
				if (activeTab == 2 || activeTab == 3) {
					actionButtons.addClass(pjqHidden);
				}
				else {
					actionButtons.removeClass(pjqHidden);
				}
			}
			else if (activeTab == 2) {
				activeTab = jQuery('#addressBookSettingsSubTabs').tabs('option', 'active');
				if (activeTab == 1 || activeTab == 2 || activeTab == 3 || activeTab == 4) {
					actionButtons.addClass(pjqHidden);
				}
				else {
					actionButtons.removeClass(pjqHidden);
				}
			}
		});
		if (!pjqIsSub) {
			jQuery('#profileSettingsSubTabs').on('tabsactivate', function (event, ui) {
				activeTab = jQuery('#profileSettingsSubTabs').tabs('option', 'active');
			})
			jQuery('#planroomSettingsSubTabs').on('tabsactivate', function (event, ui) {
				if (!planroomSettingsInit) {
					PanteraScript.PanteraScriptService.GetPlanroomOrderingSettings(pjqSessionId, GetPlanroomOrdering, onScriptError);
					GetPlanroomProjectCustomFields();
					GetPlanroomProjectStatusList();
					GetPlanroomMessageStatusList();
					GetRFISettings();
					if (settings.IsFieldReportEnabled)
						GetFieldReportSettings();
					if (settings.IsSubmittalEnabled)
						PanteraScript.PanteraScriptService.GetPlanroomSubmittalSettings(pjqSessionId, GetSubmittalSettings, onScriptError);
					if (settings.IsPunchlistEnabled)
						GetPunchlistSettings();
					if (settings.UserSeatLimit > 0)
						GetUserSeatsSettings();
					planroomSettingsInit = true;
				}
			});
			jQuery('#addressBookSettingsSubTabs').on('tabsactivate', function (event, ui) {
				if (!abSettingsInit) {
					GetAddressBookCompanyCustomFields();
					GetAddressBookContactCustomFields();
					GetAddressBookGroups();
					GetAddressBookRegions();
					abSettingsInit = true;
				}
			});
			jQuery('#abGroupsLevels').change(function () {
				CreateDialog(null, 'updateGroupsLevels');
			});
			CheckForDefaultTab();
		}
	});
}

function ProfileCountryChanged() {
	jQuery('#profileZip').val('');
	if (jQuery('#profileCountry').val() == 'US') {
		jQuery('#profileZip').mask("99999");
	}
	else {
		jQuery('#profileZip').mask('a9a-9a9');
	}
}

var regionsGridRowCount;
var groupsGridRowCount;

function GetPJQSettingsSettings(response) {
	settings = jQuery.parseJSON(response);
	if (settings.IsFieldReportEnabled)
		jQuery('#li-planroom-fieldreport-settings').show();
	if (settings.IsSubmittalEnabled)
		jQuery('#li-planroom-submittal-settings').show();
	if (settings.IsPunchlistEnabled)
		jQuery('#li-planroom-punchlist-settings').show();
	if (settings.UserSeatLimit > 0)
		jQuery('#li-planroom-user-seats').show();
	if (!settings.IsOldRegions)
		jQuery('#li-planroom-addressbookregions-settings').hide();

	uploadContext = settings.UploadContext;
	groupsGridRowCount = settings.GroupsGridRowCount;
	regionsGridRowCount = settings.RegionsGridRowCount;
	userImagePath = settings.UserImagePath;
}

var profCompName, profContName, profAdd1, profAdd2, profCity, profState, profZip, profCountry, profPhone, profExt,
	profFax, profEmail;

function GetCompanyInfo(response) {
	jQuery('.addLogoButton').button();
	jQuery('.changeLogoButton').button();
	jQuery('#passwordResetButton').button();

	companyInfo = jQuery.parseJSON(response);

	profCompName = jQuery('#profileCompanyName');
	profCompName.val(companyInfo.CompanyName);

	profContName = jQuery('#profileContactName');
	profContName.val(companyInfo.ContactName);

	profAdd1 = jQuery('#profileAddress1');
	profAdd1.val(companyInfo.Address1);

	profAdd2 = jQuery('#profileAddress2');
	profAdd2.val(companyInfo.Address2);

	profCity = jQuery('#profileCity');
	profCity.val(companyInfo.City);

	profState = jQuery('#profileState');
	profState.val(companyInfo.State);

	profCountry = jQuery('#profileCountry');
	if (companyInfo.Zip == "Canada") {
		profCountry.val("CA");
		jQuery('#profileZip').mask("A9A-9A9", {
			placeholder: ""
		});
	}
	else {
		profCountry.val("US");
		jQuery('#profileZip').mask("99999", {
			placeholder: ""
		});
	}

	profZip = jQuery('#profileZip');
	profZip.val(companyInfo.Zip);

	profPhone = jQuery('#profilePhone');
	profPhone.mask('(999) 999-9999', {
		placeholder: ""
	});
	profPhone.val(FormatPhoneHelper(companyInfo.PhoneNumber));

	profExt = jQuery('#profileExtension');
	profExt.val(companyInfo.PhoneExtension);

	profFax = jQuery('#profileFax');
	profFax.mask('(999) 999-9999', {
		placeholder: ""
	});
	profFax.val(FormatPhoneHelper(companyInfo.FaxNumber));

	profEmail = jQuery('#profileEmail');
	profEmail.val(companyInfo.Email);

	jQuery('#profileCompanyInfoSettingsTab').removeClass(pjqHidden);

	jQuery('td.settingsInput input, td.settingsInput textarea, td.settingsInput select, #profilePageSettingsTab input, #profilePageSettingsTab textarea').on({
		change: function () {
			SaveLockNav(jQuery(this));
			SetSaveState(jQuery(this));
		},
		keydown: function () {
			SaveLockNav(jQuery(this));
			SetSaveState(jQuery(this));
		}
	});
	SaveUnlockNav();

	if (companyInfo.IsProcoreAvailable) {
		jQuery('#externalAppsContainer').show();
		linkProcoreStatus = jQuery('#procoreStatus');
		linkProcoreButton = jQuery('#linkProcore');
		unlinkProcoreButton = jQuery('#unlinkProcore');
		linkProcoreButton.button();
		unlinkProcoreButton.button();
		if (companyInfo.ProCoreAccessRefreshToken.length > 0) {
			unlinkProcoreButton.removeClass(pjqHidden);

			linkProcoreStatus.text('Linked');
			linkProcoreStatus.css('color', '#2BCA00');
		}
		else {
			linkProcoreButton.removeClass(pjqHidden);

			linkProcoreStatus.text('Not Linked');
			linkProcoreStatus.css('color', '#FF2C2C');
		}
	}
}


var paymentInfo = null;

function GetPaymentInfo(response) {
	paymentInfo = jQuery.parseJSON(response);
	if (!pjqIsSub && paymentInfo.BillingInfoId == 0) {
		return;
	}
	jQuery('#li-profile-payment-settings').show();
	jQuery("#copyPaymentFromCompany").button();
	var expDate = new Date();
	if (jQuery('#profilePaymentExpiresYear').children('option').length == 0) {
		for (var i = 0; i < 20; i++) {
			var optionyear = (expDate.getFullYear() + i);
			jQuery('#profilePaymentExpiresYear').append('<option value="' + optionyear + '">' + optionyear + '</option>')
		}
	}
	jQuery('#profilePaymentCompanyName').val(paymentInfo.PaymentCompanyName);
	jQuery('#profilePaymentCardholderName').val(paymentInfo.CardholderName);
	jQuery('#profilePaymentAddress1').val(paymentInfo.PaymentAddress1);
	jQuery('#profilePaymentAddress2').val(paymentInfo.PaymentAddress2);
	jQuery('#profilePaymentCity').val(paymentInfo.PaymentCity);
	jQuery('#profilePaymentState').val(paymentInfo.PaymentState);
	if (paymentInfo.PaymentCountry.length == 0)
		paymentInfo.PaymentCountry = 'US';
	jQuery('#profilePaymentCountry').val(paymentInfo.PaymentCountry);
	jQuery('#profilePaymentZip').val(paymentInfo.PaymentZip);
	jQuery('#profilePaymentPhone').mask('(999) 999-9999', {
		placeholder: ""
	});
	jQuery('#profilePaymentPhone').val(FormatPhoneHelper(paymentInfo.PaymentPhoneNumber));
	jQuery('#profilePaymentExtension').val(paymentInfo.PaymentPhoneExtension);
	jQuery('#profilePaymentCardNumber').val(paymentInfo.CardNumber).trigger('keyup');
	jQuery("#profilePaymentCardNumber").mask('9999-9999-9999-999?9');
	if (paymentInfo.CardExpiresMonth.length == 0)
		paymentInfo.CardExpiresMonth = '01';
	jQuery('#profilePaymentExpiresMonth').val(paymentInfo.CardExpiresMonth);
	if (paymentInfo.CardExpiresYear.length == 0)
		paymentInfo.CardExpiresYear = expDate.getFullYear().toString();
	else if (paymentInfo.CardExpiresYear.length == 2)
		paymentInfo.CardExpiresYear = '20' + paymentInfo.CardExpiresYear.toString();
	jQuery('#profilePaymentExpiresYear').val(paymentInfo.CardExpiresYear.toString());
	jQuery('#profilePaymentCVV').val(paymentInfo.CardCVV);
}

var compType, trades, regions, avgjsize, isUnion, isNonUnion, isPrevWge, isDBE, isDVBE, isMBE, isWBE, isPubSect,
	isPrivSect, insuranceAmt, yearEst, founder, emplCount;

function WrongFileTypeDialog(type) {
	var fileTypeDialog = jQuery('#fileTypeDialog');
	fileTypeDialog.removeClass(pjqHidden);
	var fileTypeDialogText;
	if (type == 'pdf') {
		fileTypeDialogText = "Uploaded file type not supported. Only PDF files allowed!";
	}
	else {
		fileTypeDialogText = "Uploaded file type not supported. Only image files allowed!";
	}
	fileTypeDialog.text(fileTypeDialogText);
	fileTypeDialog.dialog({
		title: "Unsupported File Type",
		modal: true,
		resizable: false,
		width: 350,
		buttons: [{
			text: "Ok",
			click: function () {
				jQuery(this).dialog('destroy');
			}
		}]
	})
}

var isEnableProjCopy, isRequireAcceptDecline, isRequireInfoUpdate, isLockoutAcceptDecline, projectMaxAge,
	defaultITBView, rowsPerPageITB, isITBMovePageSelect, isITBShowMessageFail, isITBEnableAttach, defaultITBTimezone,
	isITBEnableFax, isITBEmail, isITBFaxNoEmail, isITBFaxEmailFails, isITBFax, defaultResponseType;

function GetPlanroomSettings(response) {
	planroomSettings = jQuery.parseJSON(response);

	isEnableProjCopy = jQuery('#planroomEnableCopy');
	isEnableProjCopy.prop('checked', planroomSettings.IsEnableProjectCopy);

	isRequireAcceptDecline = jQuery('#planroomRequireAcceptDecline');
	isRequireAcceptDecline.prop('checked', planroomSettings.IsRequireSubAcceptDecline);

	isRequireInfoUpdate = jQuery('#planroomRequireContactUpdate');
	isRequireInfoUpdate.prop('checked', planroomSettings.IsRequireSubUpdateInfo);

	isLockoutAcceptDecline = jQuery('#planroomLockoutAcceptDecline');
	isLockoutAcceptDecline.prop('checked', planroomSettings.IsLockoutAcceptDecline);

	projectMaxAge = jQuery('#planroomProjectMaxAge');
	projectMaxAge.val(planroomSettings.HideProjectMaxAge);

	defaultITBView = jQuery('#planroomITBView');
	if (!planroomSettingsInit) {

		if (planroomSettings.IsEnableProjectScope) {
			defaultITBView.append('<option value="view_scope">View by Scope</option>');
		}
	}
	defaultITBView.val(planroomSettings.ITBDefaultView);

	rowsPerPageITB = jQuery('#planroomITBRowsPerPage');
	rowsPerPageITB.val(planroomSettings.ITBRowsPerPage);

	isITBMovePageSelect = jQuery('#planroomMoveITBPager');
	isITBMovePageSelect.prop('checked', planroomSettings.IsITBMovePageSelectorTop);

	isITBShowMessageFail = jQuery('#planroomShowMessageFailure');
	isITBShowMessageFail.prop('checked', planroomSettings.IsITBShowMessageFailure);

	isITBEnableAttach = jQuery('#planroomEnableAttachments');
	isITBEnableAttach.prop('checked', planroomSettings.IsITBEnableAttachments);

	defaultITBTimezone = jQuery('#planroomTimezone');
	defaultITBTimezone.val(planroomSettings.ITBDefaultTimeZone);

	isITBEnableFax = planroomSettings.IsITBEnableFax;

	if (isITBEnableFax) {
		jQuery('.itbChoices').closest('tr').removeClass(pjqHidden);
		isITBEmail = jQuery("#itbEmail");
		isITBFaxNoEmail = jQuery("#itbFaxNoEmail");
		isITBFaxEmailFails = jQuery("#itbFaxEmailFails");
		isITBFax = jQuery("#itbFax");

		if ((planroomSettings.IsITBSendEmail || planroomSettings.IsITBSendFaxIfNoEmail || planroomSettings.IsITBSendFaxIfEmailFails) ||
			(!planroomSettings.IsITBSendFaxIfNoEmail && !planroomSettings.IsITBSendFaxIfEmailFails && !planroomSettings.IsITBSendFax))
			isITBEmail.prop('checked', true);
		if (planroomSettings.IsITBSendFax) {
			isITBFax.prop('checked', true);
		}
		else {
			if (planroomSettings.IsITBSendFaxIfNoEmail)
				isITBFaxNoEmail.prop('checked', true);
			if (planroomSettings.IsITBSendFaxIfEmailFails)
				isITBFaxEmailFails.prop('checked', true);
		}
		if (jQuery('#planroomGeneralSettingsTab').hasClass(pjqHidden)) {
			jQuery('.itbChoices').find('input').on('change', function () {
				itbChoicesChange(this);
			});
		}
	}


	/*
  isITBSendEmail = jQuery('#planroomEmailOnly');
  isITBSendEmail.prop('checked', planroomSettings.IsITBSendEmail);

  isITBSendFax = jQuery('#planroomFaxOnly');
  isITBSendFax.prop('checked', planroomSettings.IsITBSendFax);

  isITBSendEmailNoFax = jQuery('#planroomFaxIfNoEmail');
  isITBSendEmailNoFax.prop('checked', planroomSettings.IsITBSendFaxIfNoEmail);

  */
	defaultResponseType = jQuery('#projectMessagingDefaultResponseType');
	defaultResponseType.val(planroomSettings.ProjectMessagingDefaultResponseType);

	jQuery('#planroomGeneralSettingsTab').removeClass(pjqHidden);
	SaveUnlockNav();
}

var deliverBy, largeFormatCount, largeFormatSize, largeFormatPaper, largeFormatBinding, smallFormatCount,
	smallFormatPaper, smallFormatBinding;

function GetPlanroomOrdering(response) {
	orderingSettings = jQuery.parseJSON(response);

	deliverBy = jQuery('#planroomOrderingDeliverBy');
	deliverBy.val(orderingSettings.DeliverBy);

	largeFormatCount = jQuery('#planroomOrderingLargeFormatCopyCount');
	largeFormatCount.val(orderingSettings.LargeFormatCopyCount);

	largeFormatSize = jQuery('#planroomOrderingLargeFormatSize');
	largeFormatSize.val(orderingSettings.LargeFormatPrintSize);

	largeFormatPaper = jQuery('#planroomOrderingLargeFormatPaper');
	largeFormatPaper.val(orderingSettings.LargeFormatPaper);

	largeFormatBinding = jQuery('#planroomOrderingLargeFormatBinding');
	largeFormatBinding.val(orderingSettings.LargeFormatBinding);

	smallFormatCount = jQuery('#planroomOrderingSmallFormatCopyCount');
	smallFormatCount.val(orderingSettings.SmallformatCopyCount);

	smallFormatPaper = jQuery('#planroomOrderingSmallFormatPaper');
	smallFormatPaper.val(orderingSettings.SmallFormatPaper);

	smallFormatBinding = jQuery('#planroomOrderingSmallFormatBinding');
	smallFormatBinding.val(orderingSettings.SmallFormatBinding);

	jQuery('#planroomOrderingSettingsTab').removeClass(pjqHidden);
	SaveUnlockNav();
}

var rowsPerPage, isCoreInfoReq, isShowUnionStatus, isEditUnionStatus, isShowSector, isEditSector, isShowMinorityStatus,
	isEditMinorityStatus, addressBookGroupLevels, editContactStatuses;

function GetAddressBookSettings(response) {
	addressBookSettings = jQuery.parseJSON(response);

	rowsPerPage = jQuery('#abRowsPerPage');
	rowsPerPage.val(addressBookSettings.RowsPerPage);

	isCoreInfoReq = jQuery('#abCoreInfo');
	isCoreInfoReq.prop("checked", addressBookSettings.CoreInfo);

	isShowUnionStatus = jQuery('#abUnionStatusShowInAb');
	isShowUnionStatus.prop("checked", addressBookSettings.IsUnionStatusShowInAb);

	isEditUnionStatus = jQuery('#abUnionStatusAllowUpdate');
	isEditUnionStatus.prop("checked", addressBookSettings.IsUnionStatusAllowContactUpdate);

	isShowSector = jQuery('#abSectorsShowInAb');
	isShowSector.prop("checked", addressBookSettings.IsSectorTypesShowInAb);

	isEditSector = jQuery('#abSectorsAllowUpdate');
	isEditSector.prop("checked", addressBookSettings.IsSectorTypesAllowContactUpdate);

	isShowMinorityStatus = jQuery('#abMinorityStatusShowInAb');
	isShowMinorityStatus.prop("checked", addressBookSettings.IsMinTypesShowInAb);

	isEditMinorityStatus = jQuery('#abMinorityStatusAllowUpdate');
	isEditMinorityStatus.prop("checked", addressBookSettings.IsMinTypesAllowContactUpdate);

	addressBookGroupLevels = jQuery('#abGroupsLevels');
	addressBookGroupLevels.data('oldVal', !addressBookSettings.GroupLevels);
	if (addressBookSettings.GroupLevels == null || addressBookSettings.GroupLevels == 0) {
		addressBookGroupLevels.val(1);
	}
	else {
		addressBookGroupLevels.val(addressBookSettings.GroupLevels);
	}


	if (!addressBookSettings.IsLegacyProjectWall) {
		//isEditUnionStatus.prop("checked", false).hide();
		//isEditMinorityStatus.prop("checked", false).hide();
		isEditSector.prop("checked", false).hide();
		jQuery('.legacyUpdate').addClass(pjqHidden);
	}
	else {
		isShowUnionStatus.change(function () {
			var thisVal = IsChecked(jQuery(this));
			if (!thisVal) {
				isEditUnionStatus.prop("checked", thisVal);
			}
			isEditUnionStatus.attr("disabled", !thisVal);
		})
		isShowSector.change(function () {
			var thisVal = IsChecked(jQuery(this));
			if (!thisVal) {
				isEditSector.prop("checked", thisVal);
			}
			isEditSector.attr("disabled", !thisVal);
		})
		isShowMinorityStatus.change(function () {
			var thisVal = IsChecked(jQuery(this));
			if (!thisVal) {
				isEditMinorityStatus.prop("checked", thisVal);
			}
			isEditMinorityStatus.attr("disabled", !thisVal);
		})
		isShowUnionStatus.trigger('change');
		isShowSector.trigger('change');
		isShowMinorityStatus.trigger('change');
	}

	jQuery('#addressBookDefaultSettingsTab').removeClass(pjqHidden);
	SaveUnlockNav();
}

var projectCustomFieldGrid;

function GetPlanroomProjectCustomFields() {
	projectCustomFieldGridMenu = new dhtmlXMenuObject('gridMenu');
	projectCustomFieldGridMenu.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/");
	projectCustomFieldGridMenu.renderAsContextMenu();
	projectCustomFieldGridMenu.attachEvent("onClick", function (id, zoneId) {
		onGridMenuButtonClick(projectCustomFieldGrid, zoneId, id);
	});
	projectCustomFieldGridMenu.loadXMLString(menuXML);

	projectCustomFieldGrid = new dhtmlXGridObject('projectCustomFieldsGrid');
	projectCustomFieldGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	projectCustomFieldGrid.setSkin(pjqGridTheme);
	projectCustomFieldGrid.enableAutoHeight(true);
	//projectCustomFieldGrid.enableAutoWidth(true);
	projectCustomFieldGrid.enableDragAndDrop(true);
	projectCustomFieldGrid.setDragBehavior('complex');
	projectCustomFieldGrid.enableMultiselect(true);
	projectCustomFieldGrid.enableContextMenu(projectCustomFieldGridMenu);
	projectCustomFieldGrid.load("/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=ProjCustFields&customFieldid=0", "xml");
	projectCustomFieldGrid.init();
	projectCustomFieldGrid.attachEvent("onEditCell", function (stage, rId, cInd, nValue, oValue) {
		if (stage == 1) {
			UpdateProjectCustomField(false, true, rId);
		}
		return true;
	});
	projectCustomFieldGrid.attachEvent("onRowDblClicked", function (rId, cInd) {
		CreateAddEditCustomFieldForm(projectCustomFieldGrid, 'edit', rId);
	});
	projectCustomFieldGrid.attachEvent("onXLE", function (grid_obj, count) {
		jQuery('.projectCustomFieldsGridContainer').removeClass(pjqHidden);
		CheckCustomFieldGridRowsCount(projectCustomFieldGrid);
	});

	projectCustomFieldGrid.attachEvent("onBeforeContextMenu", function (id, ind, obj) {
		projectCustomFieldGrid.selectRowById(id, false, false, true);
		return true;
	});
	projectCustomFieldGrid.attachEvent("onRowSelect", function (id, ind) {
		EnableToolBarButton(tbProjectCustomFieldGrid, 'edit');
		EnableToolBarButton(tbProjectCustomFieldGrid, 'delete');
	});
	projectCustomFieldGrid.attachEvent("onDrop", function (id, ind, obj) {
		ChangeSortByOrder(projectCustomFieldGrid, 4);
		UpdateProjectCustomField(true, false);
	});
	projectCustomFieldGrid.attachEvent("onRowAdded", function (rId, rObj, rXml) {
		CheckCustomFieldGridRowsCount(projectCustomFieldGrid);
	});


	tbProjectCustomFieldGrid = new dhtmlXToolbarObject("projectCustomFieldToolbar");
	tbProjectCustomFieldGrid.setSkin("dhx_web");
	tbProjectCustomFieldGrid.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
	tbProjectCustomFieldGrid.addButton('add', 0, 'Add', "new.gif", "new_dis.gif");
	tbProjectCustomFieldGrid.addButton('edit', 1, 'Edit', "Edit.jpg", "EditD.jpg");
	tbProjectCustomFieldGrid.addButton('delete', 4, 'Delete', "Delete.png", "DeleteD.png");
	tbProjectCustomFieldGrid.disableItem('edit');
	tbProjectCustomFieldGrid.disableItem('delete');
	tbProjectCustomFieldGrid.attachEvent("onClick", function (id) {
		switch (id) {
			case 'add':
				CreateAddEditCustomFieldForm(projectCustomFieldGrid, 'add');
				break;
			case 'edit':
				CreateAddEditCustomFieldForm(projectCustomFieldGrid, 'edit', projectCustomFieldGrid.getSelectedRowId());
				break;
			case 'delete':
				var selRow = projectCustomFieldGrid.getSelectedRowId();
				var projCFCName;
				var deleteType;
				if (selRow.indexOf(',') == -1) {
					projCFCName = projectCustomFieldGrid.cells(selRow, 0).getValue();
					deleteType = 'delete';
				}
				else {
					deleteType = 'deleteMultiple';
					projCFCName = null;
				}
				CreateDialog(projectCustomFieldGrid, deleteType, projCFCName, selRow);
				break;
		}
	})
	jQuery('#planroomProjectCustomFieldsSettingsTab').removeClass(pjqHidden);
	jQuery(window).resize(function () {
		projectCustomFieldGrid.setSizes();
	});

}

var projectCustomFieldChoicesGrid;

function GetProjectCustomFieldChoices(customFieldId) {
	projectCustomFieldChoicesGridMenu = new dhtmlXMenuObject('gridMenu');
	projectCustomFieldChoicesGridMenu.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/");
	projectCustomFieldChoicesGridMenu.renderAsContextMenu();
	projectCustomFieldChoicesGridMenu.attachEvent("onClick", function (id, zoneId) {
		onGridMenuButtonClick(projectCustomFieldChoicesGrid, zoneId, id);
	});
	projectCustomFieldChoicesGridMenu.loadXMLString(menuXML);

	projectCustomFieldChoicesGrid = new dhtmlXGridObject('projectCFChoicesGrid');
	projectCustomFieldChoicesGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	projectCustomFieldChoicesGrid.setSkin(pjqGridTheme);
	projectCustomFieldChoicesGrid.enableAutoHeight(true);
	//projectCustomFieldChoicesGrid.enableAutoWidth(true);
	projectCustomFieldChoicesGrid.enableDragAndDrop(true);
	projectCustomFieldChoicesGrid.setDragBehavior('complex');
	projectCustomFieldChoicesGrid.enableMultiselect(true);
	projectCustomFieldChoicesGrid.enableContextMenu(projectCustomFieldChoicesGridMenu);
	projectCustomFieldChoicesGrid.load("/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=ProjCustomFieldChoices&customFieldid=" + customFieldId, "xml");
	projectCustomFieldChoicesGrid.init();
	projectCustomFieldChoicesGrid.attachEvent("onRowSelect", function (id, ind) {
		EnableToolBarButton(tbProjectCustomFieldChoicesGrid, 'delete');
	});
	projectCustomFieldChoicesGrid.attachEvent("onXLE", function (grid_obj, count) {
		jQuery('.projectCFChoicesGridContainer').removeClass(pjqHidden);
		UpdateCustomFieldChoicesDefaultValueDropDown(projectCustomFieldGrid, projectCustomFieldChoicesGrid, customFieldId);
	});
	projectCustomFieldChoicesGrid.attachEvent("onEditCell", function (stage, rId, cInd, nValue, oValue) {
		if (stage == 2) {
			return UpdateCustomFieldChoicesDefaultValueDropDown(projectCustomFieldGrid, projectCustomFieldChoicesGrid, customFieldId);
		}
	});
	projectCustomFieldChoicesGrid.attachEvent("onBeforeContextMenu", function (id, ind, obj) {
		projectCustomFieldChoicesGrid.selectRowById(id, false, false, true);
		return true;
	});
	projectCustomFieldChoicesGrid.attachEvent("onDrop", function (id, ind, obj) {
		ChangeSortByOrder(projectCustomFieldChoicesGrid, 1);
	});
	projectCustomFieldChoicesGrid.attachEvent("onEnter", function (rid, cInd) {
		projectCustomFieldChoicesGrid.editStop();
	});

	tbProjectCustomFieldChoicesGrid = new dhtmlXToolbarObject("projectCFChoicesToolbar");
	tbProjectCustomFieldChoicesGrid.setSkin("dhx_web");
	tbProjectCustomFieldChoicesGrid.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
	tbProjectCustomFieldChoicesGrid.addButton('add', 0, 'Add', "new.gif", "new_dis.gif");
	tbProjectCustomFieldChoicesGrid.addButton('delete', 4, 'Delete', "Delete.png", "DeleteD.png");
	tbProjectCustomFieldChoicesGrid.disableItem('delete');
	tbProjectCustomFieldChoicesGrid.attachEvent("onClick", function (id) {
		switch (id) {
			case 'add':
				AddNewGridRow(projectCustomFieldChoicesGrid);
				break;
			case 'delete':
				var selRow = projectCustomFieldChoicesGrid.getSelectedRowId();
				var projCFCName;
				var deleteType;
				if (selRow.indexOf(',') == -1 && selRow.indexOf('newRow') == -1) {
					cfChoiceDeleteArray.push(selRow);
				}
				else {
					tempCFArray = selRow.split(',');
					for (i = 0; i < tempCFArray.length; i++) {
						if (tempCFArray[i].indexOf('newRow') == -1) {
							cfChoiceDeleteArray.push(tempCFArray[i]);
						}
					}
				}
				DeleteGridRow(projectCustomFieldChoicesGrid, selRow, false);
				break;
		}
	});
}

var projectStatusGrid;

function GetPlanroomProjectStatusList() {
	projectStatusGridMenu = new dhtmlXMenuObject('gridMenu');
	projectStatusGridMenu.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/");
	projectStatusGridMenu.renderAsContextMenu();
	projectStatusGridMenu.attachEvent("onClick", function (id, zoneId) {
		onGridMenuButtonClick(projectStatusGrid, zoneId, id);
	});

	projectStatusGridMenu.loadXMLString(menuXML);

	projectStatusGrid = new dhtmlXGridObject('projectMessagingProjectStatusGrid');
	projectStatusGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	projectStatusGrid.setSkin(pjqGridTheme);
	projectStatusGrid.enableAutoHeight(true);
	//projectStatusGrid.enableAutoWidth(true);
	projectStatusGrid.enableContextMenu(projectStatusGridMenu);
	projectStatusGrid.load("/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=ProjStatusList&customFieldid=0", "xml");
	projectStatusGrid.enableDragAndDrop(true);
	projectStatusGrid.setDragBehavior('complex');
	projectStatusGrid.init();
	projectStatusGrid.attachEvent("onEditCell", function (stage, rId, cInd, nValue, oValue) {
		return SaveProjectStatusListGrid(stage, cInd, nValue, oValue);
	});
	projectStatusGrid.attachEvent("onCheck", function (rId, cInd, state) {
		SaveProjectStatusListGrid(2);
	});
	projectStatusGrid.attachEvent("onDrop", function (sId, tId, dId, sObj, tObj, sCol, tCol) {
		ChangeSortByOrder(projectStatusGrid, 2);
		SaveProjectStatusListGrid(2);
	});
	projectStatusGrid.attachEvent("onRowSelect", function (id, ind) {
		EnableToolBarButton(tbProjectStatusGrid, 'delete');
	});
	projectStatusGrid.attachEvent("onBeforeContextMenu", function (id, ind, obj) {
		projectStatusGrid.selectRowById(id, false, false, true);
		return true;
	});
	projectStatusGrid.attachEvent("onEnter", function (rid, cInd) {
		projectStatusGrid.editStop();
	});

	tbProjectStatusGrid = new dhtmlXToolbarObject("projectMessagingProjectStatusToolbar");
	tbProjectStatusGrid.setSkin("dhx_web");
	tbProjectStatusGrid.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
	tbProjectStatusGrid.addButton('add', 0, 'Add', "new.gif", "new_dis.gif");
	tbProjectStatusGrid.addButton('delete', 4, 'Delete', "Delete.png", "DeleteD.png");
	tbProjectStatusGrid.disableItem('delete');
	tbProjectStatusGrid.attachEvent("onClick", function (id) {
		switch (id) {
			case 'add':
				AddNewGridRow(projectStatusGrid);
				break;
			case 'delete':
				var projectStatusSelRow = projectStatusGrid.getSelectedRowId();
				var statusName = projectStatusGrid.cells(projectStatusSelRow, 0).getValue();
				CreateDialog(projectStatusGrid, 'delete', statusName, projectStatusSelRow);
				break;
		}
	});
	jQuery('.projectMessagingProjectStatusGridContainer').removeClass(pjqHidden);
	jQuery(window).resize(function () {
		projectStatusGrid.setSizes();
	});
}

var messageStatusGrid;

function GetPlanroomMessageStatusList() {
	messageStatusGridMenu = new dhtmlXMenuObject('gridMenu');
	messageStatusGridMenu.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/");
	messageStatusGridMenu.renderAsContextMenu();
	messageStatusGridMenu.attachEvent("onClick", function (id, zoneId) {
		onGridMenuButtonClick(messageStatusGrid, zoneId, id);
	});
	messageStatusGridMenu.loadXMLString(menuXML);

	messageStatusGrid = new dhtmlXGridObject('projectMessagingMessageStatusGrid');
	messageStatusGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	messageStatusGrid.setSkin(pjqGridTheme);
	messageStatusGrid.enableAutoHeight(true);
	//messageStatusGrid.enableAutoWidth(true);
	messageStatusGrid.enableContextMenu(messageStatusGridMenu);
	messageStatusGrid.load("/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=MesStatusList&customFieldid=0", "xml");
	messageStatusGrid.enableDragAndDrop(true);
	messageStatusGrid.setDragBehavior('complex');
	messageStatusGrid.init();
	messageStatusGrid.attachEvent("onEditCell", function (stage, rId, cInd, nValue, oValue) {
		return SaveMessageStatusListGrid(stage, cInd, nValue, oValue);
	});
	messageStatusGrid.attachEvent("onCheck", function (rId, cInd, state) {
		SaveMessageStatusListGrid(2);
	});
	messageStatusGrid.attachEvent("onDrop", function (sId, tId, dId, sObj, tObj, sCol, tCol) {
		ChangeSortByOrder(messageStatusGrid, 2);
		SaveMessageStatusListGrid(2);
	});
	messageStatusGrid.attachEvent("onRowSelect", function (id, ind) {
		EnableToolBarButton(tbMessageStatusGrid, 'delete');
	});
	messageStatusGrid.attachEvent("onBeforeContextMenu", function (id, ind, obj) {
		messageStatusGrid.selectRowById(id, false, false, true);
		return true;
	});
	messageStatusGrid.attachEvent("onEnter", function (rid, cInd) {
		messageStatusGrid.editStop();
	});

	tbMessageStatusGrid = new dhtmlXToolbarObject("projectMessagingMessageStatusToolbar");
	tbMessageStatusGrid.setSkin("dhx_web");
	tbMessageStatusGrid.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
	tbMessageStatusGrid.addButton('add', 0, 'Add', "new.gif", "new_dis.gif");
	tbMessageStatusGrid.addButton('delete', 4, 'Delete', "Delete.png", "DeleteD.png");
	tbMessageStatusGrid.disableItem('delete');
	tbMessageStatusGrid.attachEvent("onClick", function (id) {
		switch (id) {
			case 'add':
				AddNewGridRow(messageStatusGrid);
				break;
			case 'delete':
				var messageStatusSelRow = messageStatusGrid.getSelectedRowId();
				var messageStatusName = messageStatusGrid.cells(messageStatusSelRow, 0).getValue();
				CreateDialog(messageStatusGrid, 'delete', messageStatusName, messageStatusSelRow);
				break;
		}
	});
	jQuery('.projectMessagingMessageStatusGridContainer').removeClass(pjqHidden);
	jQuery('#planroomProjectMessagingSettingsTab').removeClass(pjqHidden);
	jQuery(window).resize(function () {
		messageStatusGrid.setSizes();
	});
}

var addressBookCompanyCustomFieldGrid;

function GetAddressBookCompanyCustomFields() {
	addressBookCompanyCustomFieldGridMenu = new dhtmlXMenuObject('gridMenu');
	addressBookCompanyCustomFieldGridMenu.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/");
	addressBookCompanyCustomFieldGridMenu.renderAsContextMenu();
	addressBookCompanyCustomFieldGridMenu.attachEvent("onClick", function (id, zoneId) {
		onGridMenuButtonClick(addressBookCompanyCustomFieldGrid, zoneId, id);
	});
	addressBookCompanyCustomFieldGridMenu.loadXMLString(menuXML);

	addressBookCompanyCustomFieldGrid = new dhtmlXGridObject('addressBookCompanyCustomFieldGrid');
	addressBookCompanyCustomFieldGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	addressBookCompanyCustomFieldGrid.setSkin(pjqGridTheme);
	addressBookCompanyCustomFieldGrid.enableAutoHeight(true);
	//addressBookCompanyCustomFieldGrid.enableAutoWidth(true);
	addressBookCompanyCustomFieldGrid.enableDragAndDrop(true);
	addressBookCompanyCustomFieldGrid.setDragBehavior('complex');
	addressBookCompanyCustomFieldGrid.enableMultiselect(true);
	addressBookCompanyCustomFieldGrid.enableContextMenu(addressBookCompanyCustomFieldGridMenu);
	addressBookCompanyCustomFieldGrid.load("/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=AbCompCustFields&customFieldid=0", "xml");
	addressBookCompanyCustomFieldGrid.init();
	addressBookCompanyCustomFieldGrid.attachEvent("onRowSelect", function (id, ind) {
		var selectedIds = addressBookCompanyCustomFieldGrid.getSelectedRowId();
		if (selectedIds.indexOf(',') == -1) {
			EnableToolBarButton(tbAddressBookCompanyCustomFieldGrid, 'edit');
		}
		else {
			DisableToolBarButton(tbAddressBookCompanyCustomFieldGrid, 'edit');
		}
		EnableToolBarButton(tbAddressBookCompanyCustomFieldGrid, 'delete');
	});
	addressBookCompanyCustomFieldGrid.attachEvent("onBeforeContextMenu", function (id, ind, obj) {
		addressBookCompanyCustomFieldGrid.selectRowById(id, false, false, true);
		return true;
	});
	addressBookCompanyCustomFieldGrid.attachEvent("onXLE", function (grid_obj, count) {
		jQuery('.addressBookCompanyCFGridContainer').removeClass(pjqHidden);
		CheckCustomFieldGridRowsCount(addressBookCompanyCustomFieldGrid);
	});
	addressBookCompanyCustomFieldGrid.attachEvent("onDrop", function (id, ind, obj) {
		ChangeSortByOrder(addressBookCompanyCustomFieldGrid, 5);
		UpdateAddressBookCustomField(addressBookCompanyCustomFieldGrid, true, false);
	});
	addressBookCompanyCustomFieldGrid.attachEvent("onRowDblClicked", function (rId, cInd) {
		CreateAddEditCustomFieldForm(addressBookCompanyCustomFieldGrid, 'edit', rId);
	});
	addressBookCompanyCustomFieldGrid.attachEvent("onEditCell", function (stage, rId, cInd, nValue, oValue) {
		if (stage == 1) {
			UpdateAddressBookCustomField(addressBookCompanyCustomFieldGrid, false, true, rId);
		}
		return true;
	})
	addressBookCompanyCustomFieldGrid.attachEvent("onEnter", function (rid, cInd) {
		addressBookCompanyCustomFieldGrid.editStop();
	});
	addressBookCompanyCustomFieldGrid.attachEvent("onRowAdded", function (rId, rObj, rXml) {
		CheckCustomFieldGridRowsCount(addressBookCompanyCustomFieldGrid);
	});


	tbAddressBookCompanyCustomFieldGrid = new dhtmlXToolbarObject("addressBookCompanyCustomFieldToolbar");
	tbAddressBookCompanyCustomFieldGrid.setSkin("dhx_web");
	tbAddressBookCompanyCustomFieldGrid.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
	tbAddressBookCompanyCustomFieldGrid.addButton('add', 0, 'Add', "new.gif", "new_dis.gif");
	tbAddressBookCompanyCustomFieldGrid.addButton('edit', 1, 'Edit', "Edit.jpg", "EditD.jpg");
	tbAddressBookCompanyCustomFieldGrid.addButton('delete', 4, 'Delete', "Delete.png", "DeleteD.png");
	tbAddressBookCompanyCustomFieldGrid.disableItem('edit');
	tbAddressBookCompanyCustomFieldGrid.disableItem('delete');
	tbAddressBookCompanyCustomFieldGrid.attachEvent("onClick", function (id) {
		switch (id) {
			case 'add':
				CreateAddEditCustomFieldForm(addressBookCompanyCustomFieldGrid, 'add');
				break;
			case 'edit':
				CreateAddEditCustomFieldForm(addressBookCompanyCustomFieldGrid, 'edit', addressBookCompanyCustomFieldGrid.getSelectedRowId());
				break;
			case 'delete':
				var selRow = addressBookCompanyCustomFieldGrid.getSelectedRowId();
				var compCFName;
				var deleteType;
				if (selRow.indexOf(',') == -1) {
					compCFName = addressBookCompanyCustomFieldGrid.cells(selRow, 0).getValue();
					deleteType = 'delete';
				}
				else {
					deleteType = 'deleteMultiple';
					compCFName = null;
				}
				CreateDialog(addressBookCompanyCustomFieldGrid, deleteType, compCFName, selRow);
				break;
		}
	});
	jQuery('#addressBookCompanyCustomFieldsSettingsTab').removeClass(pjqHidden);
	jQuery(window).resize(function () {
		addressBookCompanyCustomFieldGrid.setSizes();
	});
}

var addressBookCompanyCustomFieldChoicesGrid;

function GetAddressBookCompanyCustomFieldChoices(customFieldId) {
	addressBookCompanyCustomFieldChoicesGridMenu = new dhtmlXMenuObject('gridMenu');
	addressBookCompanyCustomFieldChoicesGridMenu.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/");
	addressBookCompanyCustomFieldChoicesGridMenu.renderAsContextMenu();
	addressBookCompanyCustomFieldChoicesGridMenu.attachEvent("onClick", function (id, zoneId) {
		onGridMenuButtonClick(addressBookCompanyCustomFieldChoicesGrid, zoneId, id);
	});
	addressBookCompanyCustomFieldChoicesGridMenu.loadXMLString(menuXML);

	addressBookCompanyCustomFieldChoicesGrid = new dhtmlXGridObject('addressBookCompanyCFChoicesGrid');
	addressBookCompanyCustomFieldChoicesGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	addressBookCompanyCustomFieldChoicesGrid.setSkin(pjqGridTheme);
	addressBookCompanyCustomFieldChoicesGrid.enableAutoHeight(true);
	addressBookCompanyCustomFieldChoicesGrid.enableAutoWidth(true);
	addressBookCompanyCustomFieldChoicesGrid.enableDragAndDrop(true);
	addressBookCompanyCustomFieldChoicesGrid.setDragBehavior('complex');
	addressBookCompanyCustomFieldChoicesGrid.enableMultiselect(true);
	addressBookCompanyCustomFieldChoicesGrid.enableContextMenu(addressBookCompanyCustomFieldChoicesGridMenu);
	addressBookCompanyCustomFieldChoicesGrid.load("/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=AbCompCustFieldChoices&customFieldid=0" + customFieldId, "xml");
	addressBookCompanyCustomFieldChoicesGrid.init();
	addressBookCompanyCustomFieldChoicesGrid.attachEvent("onRowSelect", function (id, ind) {
		EnableToolBarButton(tbAddressBookCompanyCustomFieldChoicesGrid, 'delete');
	});
	addressBookCompanyCustomFieldChoicesGrid.attachEvent("onXLE", function (grid_obj, count) {
		jQuery('#addressBookCompanyCFChoicesGridContainer').removeClass(pjqHidden);
		UpdateCustomFieldChoicesDefaultValueDropDown(addressBookCompanyCustomFieldGrid, addressBookCompanyCustomFieldChoicesGrid, customFieldId);
	});
	addressBookCompanyCustomFieldChoicesGrid.attachEvent("onEditCell", function (stage, rId, cInd, nValue, oValue) {
		if (stage == 2) {
			return UpdateCustomFieldChoicesDefaultValueDropDown(addressBookCompanyCustomFieldGrid, addressBookCompanyCustomFieldChoicesGrid, customFieldId);
		}
	});
	addressBookCompanyCustomFieldChoicesGrid.attachEvent("onBeforeContextMenu", function (id, ind, obj) {
		addressBookCompanyCustomFieldChoicesGrid.selectRowById(id, false, false, true);
		return true;
	});
	addressBookCompanyCustomFieldChoicesGrid.attachEvent("onDrop", function (id, ind, obj) {
		ChangeSortByOrder(addressBookCompanyCustomFieldChoicesGrid, 1);
	});
	addressBookCompanyCustomFieldChoicesGrid.attachEvent("onEnter", function (rid, cInd) {
		addressBookCompanyCustomFieldChoicesGrid.editStop();
	});

	tbAddressBookCompanyCustomFieldChoicesGrid = new dhtmlXToolbarObject("addressBookCompanyCFChoicesToolbar");
	tbAddressBookCompanyCustomFieldChoicesGrid.setSkin("dhx_web");
	tbAddressBookCompanyCustomFieldChoicesGrid.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
	tbAddressBookCompanyCustomFieldChoicesGrid.addButton('add', 0, 'Add', "new.gif", "new_dis.gif");
	tbAddressBookCompanyCustomFieldChoicesGrid.addButton('delete', 4, 'Delete', "Delete.png", "DeleteD.png");
	tbAddressBookCompanyCustomFieldChoicesGrid.disableItem('delete');
	tbAddressBookCompanyCustomFieldChoicesGrid.attachEvent("onClick", function (id) {
		switch (id) {
			case 'add':
				AddNewGridRow(addressBookCompanyCustomFieldChoicesGrid);
				break;
			case 'delete':
				var selRow = addressBookCompanyCustomFieldChoicesGrid.getSelectedRowId();
				if (selRow.indexOf(',') == -1 && selRow.indexOf('newRow') == -1) {
					cfChoiceDeleteArray.push(selRow);
				}
				else {
					tempCFArray = selRow.split(',');
					for (i = 0; i < tempCFArray.length; i++) {
						if (tempCFArray[i].indexOf('newRow') == -1) {
							cfChoiceDeleteArray.push(tempCFArray[i]);
						}
					}
				}
				DeleteGridRow(addressBookCompanyCustomFieldChoicesGrid, selRow, false);
				break;
		}
	});
	var rowPerPageDD = jQuery('#addressBookCompanyCFChoicesPaging').find('.dhx_toolbar_arw');
	rowPerPageDD.hide();
	rowPerPageDD.prev('div').hide();
}

var addressBookContactCustomFieldsGrid;

function GetAddressBookContactCustomFields() {
	addressBookContactCustomFieldGridMenu = new dhtmlXMenuObject('gridMenu');
	addressBookContactCustomFieldGridMenu.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/");
	addressBookContactCustomFieldGridMenu.renderAsContextMenu();
	addressBookContactCustomFieldGridMenu.attachEvent("onClick", function (id, zoneId) {
		onGridMenuButtonClick(addressBookContactCustomFieldGrid, zoneId, id);
	});
	addressBookContactCustomFieldGridMenu.loadXMLString(menuXML);

	addressBookContactCustomFieldGrid = new dhtmlXGridObject('addressBookContactCustomFieldGrid');
	addressBookContactCustomFieldGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	addressBookContactCustomFieldGrid.setSkin(pjqGridTheme);
	addressBookContactCustomFieldGrid.enableAutoHeight(true);
	//addressBookContactCustomFieldGrid.enableAutoWidth(true);
	addressBookContactCustomFieldGrid.enableDragAndDrop(true);
	addressBookContactCustomFieldGrid.setDragBehavior('complex');
	addressBookContactCustomFieldGrid.enableMultiselect(true);
	addressBookContactCustomFieldGrid.enableContextMenu(addressBookContactCustomFieldGridMenu);
	addressBookContactCustomFieldGrid.load("/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=AbContCustFields&customFieldid=0", "xml");
	addressBookContactCustomFieldGrid.init();
	addressBookContactCustomFieldGrid.attachEvent("onRowSelect", function (id, ind) {
		var selectedIds = addressBookContactCustomFieldGrid.getSelectedRowId();
		if (selectedIds.indexOf(',') == -1) {
			EnableToolBarButton(tbAddressBookContactCustomFieldGrid, 'edit');
		}
		else {
			DisableToolBarButton(tbAddressBookContactCustomFieldGrid, 'edit');
		}
		EnableToolBarButton(tbAddressBookContactCustomFieldGrid, 'delete');
	});
	addressBookContactCustomFieldGrid.attachEvent("onBeforeContextMenu", function (id, ind, obj) {
		addressBookContactCustomFieldGrid.selectRowById(id, false, false, true);
		return true;
	});
	addressBookContactCustomFieldGrid.attachEvent("onXLE", function (grid_obj, count) {
		jQuery('.addressBookContactCFGridContainer').removeClass(pjqHidden);
		CheckCustomFieldGridRowsCount(addressBookContactCustomFieldGrid);
	});
	addressBookContactCustomFieldGrid.attachEvent("onDrop", function (id, ind, obj) {
		ChangeSortByOrder(addressBookContactCustomFieldGrid, 5);
		UpdateAddressBookCustomField(addressBookContactCustomFieldGrid, true, false);
	});
	addressBookContactCustomFieldGrid.attachEvent("onRowDblClicked", function (rId, cInd) {
		CreateAddEditCustomFieldForm(addressBookContactCustomFieldGrid, 'edit', rId);
	});
	addressBookContactCustomFieldGrid.attachEvent("onEditCell", function (stage, rId, cInd, nValue, oValue) {
		if (stage == 1) {
			UpdateAddressBookCustomField(addressBookContactCustomFieldGrid, false, true, rId);
		}
		return true;
	})
	addressBookContactCustomFieldGrid.attachEvent("onEnter", function (rid, cInd) {
		addressBookContactCustomFieldGrid.editStop();
	});
	addressBookContactCustomFieldGrid.attachEvent("onRowAdded", function (rId, rObj, rXml) {
		CheckCustomFieldGridRowsCount(addressBookContactCustomFieldGrid);
	});


	tbAddressBookContactCustomFieldGrid = new dhtmlXToolbarObject("addressBookContactCustomFieldToolbar");
	tbAddressBookContactCustomFieldGrid.setSkin("dhx_web");
	tbAddressBookContactCustomFieldGrid.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
	tbAddressBookContactCustomFieldGrid.addButton('add', 0, 'Add', "new.gif", "new_dis.gif");
	tbAddressBookContactCustomFieldGrid.addButton('edit', 1, 'Edit', "Edit.jpg", "EditD.jpg");
	tbAddressBookContactCustomFieldGrid.addButton('delete', 4, 'Delete', "Delete.png", "DeleteD.png");
	tbAddressBookContactCustomFieldGrid.disableItem('edit');
	tbAddressBookContactCustomFieldGrid.disableItem('delete');
	tbAddressBookContactCustomFieldGrid.attachEvent("onClick", function (id) {
		switch (id) {
			case 'add':
				CreateAddEditCustomFieldForm(addressBookContactCustomFieldGrid, 'add');
				break;
			case 'edit':
				CreateAddEditCustomFieldForm(addressBookContactCustomFieldGrid, 'edit', addressBookContactCustomFieldGrid.getSelectedRowId());
				break;
			case 'delete':
				var selRow = addressBookContactCustomFieldGrid.getSelectedRowId();
				var contCFName;
				var deleteType;
				if (selRow.indexOf(',') == -1) {
					contCFName = addressBookContactCustomFieldGrid.cells(selRow, 0).getValue();
					deleteType = 'delete';
				}
				else {
					deleteType = 'deleteMultiple';
					contCFName = null;
				}
				CreateDialog(addressBookContactCustomFieldGrid, deleteType, contCFName, selRow);
				break;
		}
	});
	jQuery('#addressBookContactCustomFieldsSettingsTab').removeClass(pjqHidden);
	jQuery(window).resize(function () {
		addressBookContactCustomFieldGrid.setSizes();
	});

}

var addressBookContactCustomFieldChoicesGrid;

function GetAddressBookContactCustomFieldChoices(customFieldId) {
	addressBookContactCustomFieldChoicesGridMenu = new dhtmlXMenuObject('gridMenu');
	addressBookContactCustomFieldChoicesGridMenu.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/");
	addressBookContactCustomFieldChoicesGridMenu.renderAsContextMenu();
	addressBookContactCustomFieldChoicesGridMenu.attachEvent("onClick", function (id, zoneId) {
		onGridMenuButtonClick(addressBookContactCustomFieldChoicesGrid, zoneId, id);
	});
	addressBookContactCustomFieldChoicesGridMenu.loadXMLString(menuXML);

	addressBookContactCustomFieldChoicesGrid = new dhtmlXGridObject('addressBookContactCFChoicesGrid');
	addressBookContactCustomFieldChoicesGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	addressBookContactCustomFieldChoicesGrid.setSkin(pjqGridTheme);
	addressBookContactCustomFieldChoicesGrid.enableAutoHeight(true);
	//addressBookContactCustomFieldChoicesGrid.enableAutoWidth(true);
	addressBookContactCustomFieldChoicesGrid.enableDragAndDrop(true);
	addressBookContactCustomFieldChoicesGrid.setDragBehavior('complex');
	addressBookContactCustomFieldChoicesGrid.enableMultiselect(true);
	addressBookContactCustomFieldChoicesGrid.enableContextMenu(addressBookContactCustomFieldChoicesGridMenu);
	addressBookContactCustomFieldChoicesGrid.load("/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=AbContCustFieldChoices&customFieldid=" + customFieldId, "xml");
	addressBookContactCustomFieldChoicesGrid.init();
	addressBookContactCustomFieldChoicesGrid.attachEvent("onRowSelect", function (id, ind) {
		EnableToolBarButton(tbAddressBookContactCustomFieldChoicesGrid, 'delete');
	});
	addressBookContactCustomFieldChoicesGrid.attachEvent("onXLE", function (grid_obj, count) {
		jQuery('#addressBookContactCFChoicesGridContainer').removeClass(pjqHidden);
		UpdateCustomFieldChoicesDefaultValueDropDown(addressBookContactCustomFieldGrid, addressBookContactCustomFieldChoicesGrid, customFieldId);
	});
	addressBookContactCustomFieldChoicesGrid.attachEvent("onEditCell", function (stage, rId, cInd, nValue, oValue) {
		if (stage == 2) {
			return UpdateCustomFieldChoicesDefaultValueDropDown(addressBookContactCustomFieldGrid, addressBookContactCustomFieldChoicesGrid, customFieldId);
		}
	});
	addressBookContactCustomFieldChoicesGrid.attachEvent("onBeforeContextMenu", function (id, ind, obj) {
		addressBookContactCustomFieldChoicesGrid.selectRowById(id, false, false, true);
		return true;
	});
	addressBookContactCustomFieldChoicesGrid.attachEvent("onDrop", function (id, ind, obj) {
		ChangeSortByOrder(addressBookContactCustomFieldChoicesGrid, 1);
	});
	addressBookContactCustomFieldChoicesGrid.attachEvent("onEnter", function (rid, cInd) {
		addressBookContactCustomFieldChoicesGrid.editStop();
	});


	tbAddressBookContactCustomFieldChoicesGrid = new dhtmlXToolbarObject("addressBookContactCFChoicesToolbar");
	tbAddressBookContactCustomFieldChoicesGrid.setSkin("dhx_web");
	tbAddressBookContactCustomFieldChoicesGrid.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
	tbAddressBookContactCustomFieldChoicesGrid.addButton('add', 0, 'Add', "new.gif", "new_dis.gif");
	tbAddressBookContactCustomFieldChoicesGrid.addButton('delete', 4, 'Delete', "Delete.png", "DeleteD.png");
	tbAddressBookContactCustomFieldChoicesGrid.disableItem('delete');
	tbAddressBookContactCustomFieldChoicesGrid.attachEvent("onClick", function (id) {
		switch (id) {
			case 'add':
				AddNewGridRow(addressBookContactCustomFieldChoicesGrid);
				break;
			case 'delete':
				var selRow = addressBookContactCustomFieldChoicesGrid.getSelectedRowId();
				if (selRow.indexOf(',') == -1 && selRow.indexOf('newRow') == -1) {
					cfChoiceDeleteArray.push(selRow);
				}
				else {
					tempCFArray = selRow.split(',');
					for (i = 0; i < tempCFArray.length; i++) {
						if (tempCFArray[i].indexOf('newRow') == -1) {
							cfChoiceDeleteArray.push(tempCFArray[i]);
						}
					}
				}
				DeleteGridRow(addressBookContactCustomFieldChoicesGrid, selRow, false);
				break;
		}
	});
	jQuery('#addressBookContactCFChoicesGridContainer').removeClass(pjqHidden);
}

var addressBookGroupsGrid;

function GetAddressBookGroups(response) {
	if (response != null && addressBookGroupsGrid != null) {
		SettingSavedCallback(response);
		addressBookGroupsGrid.destructor();
	}
	GetAddressBookGroupsGroupsTree(response);
	addressBookGroupsGridMenu = new dhtmlXMenuObject('gridMenu');
	addressBookGroupsGridMenu.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/");
	addressBookGroupsGridMenu.renderAsContextMenu();
	addressBookGroupsGridMenu.attachEvent("onClick", function (id, zoneId) {
		onGridMenuButtonClick(addressBookGroupsGrid, zoneId, id);
	});
	addressBookGroupsGridMenu.loadXMLString(menuXML);

	addressBookGroupsGrid = new dhtmlXGridObject('addressBookGroupsGrid');
	addressBookGroupsGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	addressBookGroupsGrid.setSkin(pjqGridTheme);
	addressBookGroupsGrid.enablePaging(true, groupsGridRowCount, 3, "addressBookGroupsGridPaging", true, null);
	addressBookGroupsGrid.setPagingSkin("toolbar", "dhx_web");
	addressBookGroupsGrid.enableAutoHeight(true);
	//addressBookGroupsGrid.enableAutoWidth(true);
	addressBookGroupsGrid.enableContextMenu(addressBookGroupsGridMenu);
	addressBookGroupsGrid.load("/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=AbGroups&customFieldid=0", "xml");
	if (addressBookSettings.IsCSICodeEnabled)
		addressBookGroupsGrid.setColTypes("edtxt,edtxt,ed,edn,ro,ro");
	else
		addressBookGroupsGrid.setColTypes("edtxt,edtxt,edn,ro,ro");
	addressBookGroupsGrid.enableDragAndDrop(true);
	addressBookGroupsGrid.setDragBehavior('complex');
	addressBookGroupsGrid.enableMultiselect(true);
	addressBookGroupsGrid.init();
	addressBookGroupsGrid.attachEvent("onXLE", function (grid_obj, count) {
		jQuery('.addressBookGroupsGridContainer').removeClass(pjqHidden);
		UpdateGridCombos(addressBookGroupsGrid);
		CheckGroupsHaveParents();
		FormatGroupContainers();
		if (addressBookGroupLevels.val() == 1) {
			if (addressBookSettings.IsCSICodeEnabled)
				addressBookGroupsGrid.setColTypes("edtxt,edtxt,ed,edn,ro,ro");
			else
				addressBookGroupsGrid.setColTypes("edtxt,edtxt,edn,ro,ro");
		}
		else {
			if (addressBookSettings.IsCSICodeEnabled)
				addressBookGroupsGrid.setColTypes("edtxt,combo,ed,edn,ro,ro");
			else
				addressBookGroupsGrid.setColTypes("edtxt,combo,edn,ro,ro");
		}
		abGroupsGridInit = true;
	});

	addressBookGroupsGrid.attachEvent("onDrop", function (rId, tId, dId, sObj, tObj, sCol, tCol) {
		ChangeSortByOrder(addressBookGroupsGrid, (addressBookSettings.IsCSICodeEnabled ? 3 : 2));
		UpdateAddressBookGroup(rId, 0, 2);
	});
	addressBookGroupsGrid.attachEvent("onRowSelect", function (id, ind) {
		var selRows = addressBookGroupsGrid.getSelectedRowId();
		EnableToolBarButton(tbAddressBookGroupsGrid, 'delete');
		if (addressBookGroupsGrid.getSelectedRowId().indexOf(',') != -1) {
			tbAddressBookGroupsGrid.enableItem('merge');
		}
		else {
			tbAddressBookGroupsGrid.disableItem('merge');
		}
	});
	addressBookGroupsGrid.attachEvent("onEditCell", function (stage, rId, cInd, nValue, oValue) {
		if (isNaN(rId)) {
			return AddAddressBookGroup(rId, stage);
		}
		else {
			return UpdateAddressBookGroup(rId, cInd, stage, oValue, nValue);
		}
	});
	addressBookGroupsGrid.attachEvent("onPaging", function (count) {
		var currentGroupGridRowCount = addressBookGroupsGrid.rowsBufferOutSize;
		if (abGroupsGridInit) {
			PanteraScript.PanteraScriptService.UpdatePJQSettingsSettings(pjqSessionId, 'AbGroupsGridRowsPerPage', currentGroupGridRowCount, SettingSavedCallback, onScriptError);
		}
	});
	addressBookGroupsGrid.attachEvent("onBeforeContextMenu", function (id, ind, obj) {
		addressBookGroupsGrid.selectRowById(id, false, false, true);
		return true;
	});
	addressBookGroupsGrid.attachEvent("onEnter", function (rid, cInd) {
		addressBookGroupsGrid.editStop();
	});


	tbAddressBookGroupsGrid = new dhtmlXToolbarObject("addressBookGroupsToolbar");
	tbAddressBookGroupsGrid.setSkin("dhx_web");
	tbAddressBookGroupsGrid.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
	tbAddressBookGroupsGrid.addButton('add', 0, 'Add', "new.gif", "new_dis.gif");
	tbAddressBookGroupsGrid.addButton('delete', 4, 'Delete', "Delete.png", "DeleteD.png");
	tbAddressBookGroupsGrid.addButton('sortAlpha', 10, 'Sort Alphabetically', "SortAlpha.png", "SortAlphaD.png");
	tbAddressBookGroupsGrid.addButton('merge', 11, 'Merge', "Merge.png", "MergeD.png");
	tbAddressBookGroupsGrid.disableItem('merge');
	tbAddressBookGroupsGrid.disableItem('delete');
	tbAddressBookGroupsGrid.attachEvent("onClick", function (id) {
		switch (id) {
			case 'add':
				AddNewGridRow(addressBookGroupsGrid);
				break;
			case 'sortAlpha':
				SortAddressBookGroupsAlphanumeric();
				break;
			case 'merge':
				InitMergeDialog('groups');
				break;
			case 'delete':
				var addressBookGroupGridSelRow = addressBookGroupsGrid.getSelectedRowId();
				var groupName;
				var deleteType;
				if (addressBookGroupGridSelRow.indexOf(',') == -1) {
					groupName = addressBookGroupsGrid.cells(addressBookGroupGridSelRow, 0).getValue();
					deleteType = 'delete';
				}
				else {
					deleteType = 'deleteMultiple';
					groupName = null;
				}
				CreateDialog(addressBookGroupsGrid, deleteType, groupName, addressBookGroupGridSelRow);
				break;
		}
	});
	jQuery(window).resize(function () {
		addressBookGroupsGrid.setSizes();
	});

	InitDirectoryGroupLinking();
}

var addressBookGroupsGroupsTree = null;

function GetAddressBookGroupsGroupsTree(response) {
	if (response != null && addressBookGroupsGroupsTree != null) {
		addressBookGroupsGroupsTree.destructor();
		addressBookGroupsGroupsTree = null;
		tbAddressBookGroupsGroupsTree.unload();
		tbAddressBookGroupsGroupsTree = null;
	}
	if (addressBookGroupLevels.val() > 1) {
		addressBookGroupsGroupsTree = new dhtmlXTreeObject("abGroupsTree", "100%", "100%", "abGroupsTree");
		addressBookGroupsGroupsTree.enableDragAndDrop(true, false);
		addressBookGroupsGroupsTree.setDragBehavior('complex');
		addressBookGroupsGroupsTree.setDragBehavior('sibling');
		addressBookGroupsGroupsTree.enableItemEditor(true);
		addressBookGroupsGroupsTree.setListDelimeter('|');
		addressBookGroupsGroupsTree.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxtree/imgs/');
		addressBookGroupsGroupsTree.setStdImages('groupChild.png', 'groupParent.png', 'groupParent.png');
		addressBookGroupsGroupsTree.loadXML("/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=AbGroupsGroupsTree&customFieldid=0");
		addressBookGroupsGroupsTree.attachEvent("onSelect", function (id) {
			EnableToolBarButton(tbAddressBookGroupsGroupsTree, 'delete');
			var itemLevel = addressBookGroupsGroupsTree.getLevel(id);
			EnableToolBarButton(tbAddressBookGroupsGroupsTree, 'edit');
			if (itemLevel == 1 && addressBookGroupLevels.val() == 3) {
				EnableToolBarButton(tbAddressBookGroupsGroupsTree, 'addChild');
				tbAddressBookGroupsGroupsTree.showItem('addChild');
				tbAddressBookGroupsGroupsTree.hideItem('addSibling');
			}
			else if (itemLevel > 1 && addressBookGroupLevels.val() == 3) {
				tbAddressBookGroupsGroupsTree.hideItem('addChild');
				tbAddressBookGroupsGroupsTree.showItem('addSibling');
			}
		});
		addressBookGroupsGroupsTree.attachEvent("onEdit", function (state, id, tree, value) {
			return UpdateAddressBookGroupsGroups(state, id);
		});
		addressBookGroupsGroupsTree.attachEvent("onDrop", function (sId, tId, dId, sObj, tObj, sCol, tCol) {
			DisableToolBarButton(tbAddressBookGroupsGroupsTree, 'edit');
			DisableToolBarButton(tbAddressBookGroupsGroupsTree, 'delete');
			tbAddressBookGroupsGroupsTree.hideItem('addChild');
			tbAddressBookGroupsGroupsTree.hideItem('addSibling');
			UpdateAddressBookGroupsGroups(3, null);
		})
		addressBookGroupsGroupsTree.attachEvent("onXLE", function (grid_obj, count) {
			jQuery('.addressBookGroupsTreeContainer').removeClass(pjqHidden);
		});

		tbAddressBookGroupsGroupsTree = new dhtmlXToolbarObject("abGroupsTreeToolbar");
		tbAddressBookGroupsGroupsTree.setSkin("dhx_web");
		tbAddressBookGroupsGroupsTree.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
		if (addressBookGroupLevels.val() == 3) {
			tbAddressBookGroupsGroupsTree.addButton('addParent', 0, 'Add Parent', "new.gif", "new_dis.gif");
			tbAddressBookGroupsGroupsTree.addButton('addChild', 1, 'Add Child', "new.gif", "new_dis.gif");
			tbAddressBookGroupsGroupsTree.addButton('addSibling', 1, 'Add Sibling', "new.gif", "new_dis.gif");
			tbAddressBookGroupsGroupsTree.hideItem('addChild');
			tbAddressBookGroupsGroupsTree.hideItem('addSibling');
		}
		else {
			tbAddressBookGroupsGroupsTree.addButton('addParent', 0, 'Add', "new.gif", "new_dis.gif");
		}
		tbAddressBookGroupsGroupsTree.addButton('edit', 4, 'Edit', "copy.gif", "copy_dis.gif");
		DisableToolBarButton(tbAddressBookGroupsGroupsTree, 'edit');
		tbAddressBookGroupsGroupsTree.addButton('delete', 4, 'Delete', "Delete.png", "DeleteD.png");
		DisableToolBarButton(tbAddressBookGroupsGroupsTree, 'delete');
		tbAddressBookGroupsGroupsTree.attachEvent("onClick", function (id) {
			switch (id) {
				case 'addParent':
					AddNewTreeNode(addressBookGroupsGroupsTree, 'parent');
					break;
				case 'addChild':
					AddNewTreeNode(addressBookGroupsGroupsTree, 'child', addressBookGroupsGroupsTree.getSelectedItemId());
					break;
				case 'addSibling':
					var parentId = addressBookGroupsGroupsTree.getParentId(addressBookGroupsGroupsTree.getSelectedItemId());
					AddNewTreeNode(addressBookGroupsGroupsTree, 'sibling', parentId);
					break;
				case 'edit':
					EditTreeNode(addressBookGroupsGroupsTree, addressBookGroupsGroupsTree.getSelectedItemId())
					break;
				case 'delete':
					var selItemId = addressBookGroupsGroupsTree.getSelectedItemId();
					var groupsGroupName = addressBookGroupsGroupsTree.getItemText(selItemId);
					CreateDialog(addressBookGroupsGroupsTree, 'delete', groupsGroupName, selItemId);
					break;
			}
		});
	}
	jQuery('#addressBookGroupsSettingsTab').removeClass(pjqHidden);
}

function GetAddressBookRegions() {
	addressBookRegionsGridMenu = new dhtmlXMenuObject('gridMenu');
	addressBookRegionsGridMenu.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/");
	addressBookRegionsGridMenu.renderAsContextMenu();
	addressBookRegionsGridMenu.attachEvent("onClick", function (id, zoneId) {
		onGridMenuButtonClick(addressBookRegionsGrid, zoneId, id);
	});
	addressBookRegionsGridMenu.loadXMLString(menuXML);

	addressBookRegionsGrid = new dhtmlXGridObject('addressBookRegionsGrid');
	addressBookRegionsGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	addressBookRegionsGrid.setSkin(pjqGridTheme);
	addressBookRegionsGrid.enablePaging(true, regionsGridRowCount, 3, "addressBookRegionsGridPaging", true);
	addressBookRegionsGrid.enableDragAndDrop(true);
	addressBookRegionsGrid.setDragBehavior('complex');
	addressBookRegionsGrid.enableMultiselect(true);
	addressBookRegionsGrid.setPagingSkin("toolbar", "dhx_web");
	addressBookRegionsGrid.enableAutoHeight(true);
	//addressBookRegionsGrid.enableAutoWidth(true);
	addressBookRegionsGrid.enableContextMenu(addressBookRegionsGridMenu);
	addressBookRegionsGrid.load("/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=AbRegions&customFieldid=0", "xml");
	abRegionsGridInit = true;
	addressBookRegionsGrid.init();
	addressBookRegionsGrid.attachEvent("onXLE", function (grid_obj, count) {
		jQuery('.addressBookRegionsGridContainer').removeClass(pjqHidden);
		UpdateGridCombos(addressBookRegionsGrid);
	});
	addressBookRegionsGrid.attachEvent("onDrop", function (sId, tId, dId, sObj, tObj, sCol, tCol) {
		ChangeSortByOrder(addressBookRegionsGrid, 2);
		UpdateAddressBookRegion('allRegions');
	});
	addressBookRegionsGrid.attachEvent("onRowSelect", function (id, ind) {
		var selRows = addressBookRegionsGrid.getSelectedRowId();
		EnableToolBarButton(tbAddressBookRegionsGrid, 'delete');
		if (addressBookRegionsGrid.getSelectedRowId().indexOf(',') != -1) {
			tbAddressBookRegionsGrid.enableItem('merge');
		}
		else {
			tbAddressBookRegionsGrid.disableItem('merge');
		}
	});
	addressBookRegionsGrid.attachEvent("onEditCell", function (stage, rId, cInd, nValue, oValue) {
		if (isNaN(rId)) {
			return AddAddressBookRegion(rId, stage);
		}
		else {
			return UpdateAddressBookRegion(rId, cInd, stage, oValue, nValue);
		}
	});
	addressBookRegionsGrid.attachEvent("onPaging", function (count) {
		var currentRegionGridRowCount = addressBookRegionsGrid.rowsBufferOutSize;
		if (abRegionsGridInit) {
			PanteraScript.PanteraScriptService.UpdatePJQSettingsSettings(pjqSessionId, 'AbRegionsGridRowsPerPage', currentRegionGridRowCount, SettingSavedCallback, onScriptError);
		}
	})
	addressBookRegionsGrid.attachEvent("onBeforeContextMenu", function (id, ind, obj) {
		addressBookRegionsGrid.selectRowById(id, false, false, true);
		return true;
	});
	addressBookRegionsGrid.attachEvent("onEnter", function (rid, cInd) {
		addressBookRegionsGrid.editStop();
	});


	tbAddressBookRegionsGrid = new dhtmlXToolbarObject("addressBookRegionsToolbar");
	tbAddressBookRegionsGrid.setSkin("dhx_web");
	tbAddressBookRegionsGrid.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
	tbAddressBookRegionsGrid.addButton('add', 0, 'Add', "new.gif", "new_dis.gif");
	tbAddressBookRegionsGrid.addButton('delete', 4, 'Delete', "Delete.png", "DeleteD.png");
	tbAddressBookRegionsGrid.disableItem('delete');
	tbAddressBookRegionsGrid.addButton('merge', 11, 'Merge', "Merge.png", "MergeD.png");
	tbAddressBookRegionsGrid.disableItem('merge');
	if (addressBookGroupLevels.val() == 3)
		tbAddressBookRegionsGrid.hideItem('merge');
	else
		tbAddressBookRegionsGrid.showItem('merge');

	tbAddressBookRegionsGrid.attachEvent("onClick", function (id) {
		switch (id) {
			case 'add':
				AddNewGridRow(addressBookRegionsGrid);
				break;
			case 'merge':
				InitMergeDialog('regions');
				break;
			case 'delete':
				var addressBookRegionGridSelRow = addressBookRegionsGrid.getSelectedRowId();
				var deleteType;
				var groupName = null;
				if (addressBookRegionGridSelRow.indexOf(',') == -1) {
					deleteType = 'delete'
					groupName = addressBookRegionsGrid.cells(addressBookRegionGridSelRow, 0).getValue();
				}
				else {
					deleteType = 'deleteMultiple';
				}
				CreateDialog(addressBookRegionsGrid, deleteType, groupName, addressBookRegionGridSelRow);
				break;
		}
	});
	jQuery('#addressBookRegionsSettingsTab').removeClass(pjqHidden);
	jQuery(window).resize(function () {
		addressBookRegionsGrid.setSizes();
	});
}

function GroupLevelsChanged() {
	var oldLevelNumber = addressBookGroupLevels.data('oldVal');
	var newLevelNumber = addressBookGroupLevels.val();
	if (oldLevelNumber != newLevelNumber) {
		for (var i = 0; i < addressBookGroupsGrid.getRowsNum(); i++) {
			addressBookGroupsGrid.cells2(i, 1).setValue("");
			if (abGroupsGridInit) {
				UpdateAddressBookGroup('allgroups');
			}
		}
	}

	if (addressBookGroupLevels.val() == 3)
		tbAddressBookRegionsGrid.hideItem('merge');
	else
		tbAddressBookRegionsGrid.showItem('merge');

	addressBookGroupLevels.data('oldVal', addressBookGroupLevels.val());
}

function CreateDialog(obj, type, val, id) {
	var diagText = "";
	var title = "";
	var diagInput = "";
	if (type == 'delete' | type == 'deleteMultiple') {
		title = 'Deletion';
		switch (obj) {
			case fieldReportsGrid:
				diagText = 'Are you sure you want to delete the Field Report "<b>' + val + '</b>"?';
				InitConfirmDeclineDialog(obj, diagText, type, title, id);
				break;
			case projectStatusGrid:
				diagText = 'Are you sure you want to delete the Project Status "<b>' + val + '</b>"?';
				InitConfirmDeclineDialog(obj, diagText, type, title, id);
				break;
			case messageStatusGrid:
				diagText = ('Are you sure you want to delete the Message Status "<b>' + val + '</b>"?');
				InitConfirmDeclineDialog(obj, diagText, type, title, id);
				break;
			case addressBookGroupsGrid:
				var diagText;
				if (type == 'delete') {
					diagText = ('Are you sure you want to delete the Group "<b>' + val + '</b>"?');
				}
				else if (type == 'deleteMultiple') {
					diagText = ('Are you sure you want to delete the selected groups?');
				}
				InitConfirmDeclineDialog(obj, diagText, type, title, id);
				break;
			case addressBookGroupsGroupsTree:
				if (addressBookGroupLevels.val() == 3 && obj.getLevel(id) == 0) {
					diagText = ('Are you sure you want to delete the Group "<b>' + val + '</b>"?<br /><b>NOTE: THIS WILL ALSO DELETE ALL OF ITS SUBGROUPS!</b>');
					InitNotifyDialog(obj, diagText, type, title, id);
				}
				else {
					diagText = ('Are you sure you want to delete the Group container "<b>' + val + '</b>"?');
				}
				InitConfirmDeclineDialog(obj, diagText, type, title, id);
				break;
			case addressBookRegionsGrid:
				if (type == 'delete') {
					diagText = ('Are you sure you want to delete the Region "<b>' + val + '</b>"?');
				}
				else if (type == 'deleteMultiple') {
					diagText = ('Are you sure you want to delete the selected regions?');
				}
				InitConfirmDeclineDialog(obj, diagText, type, title, id);
				break;
			case projectCustomFieldGrid:
			case addressBookCompanyCustomFieldGrid:
			case addressBookContactCustomFieldGrid:
			case fieldReportCustomFieldsGrid:
			case cftCustomFieldsGrid:
			case submittalCustomFieldsGrid:
			case punchlistCustomFieldsGrid:
				if (type == 'delete') {
					diagText = ('Are you sure you want to delete the custom field "<b>' + val + '</b>"?');
				}
				else if (type == 'deleteMultiple') {
					diagText = ('Are you sure you want to delete the selected custom fields?');
				}
				InitConfirmDeclineDialog(obj, diagText, type, title, id);
				break;
			case submittalItemTypesGrid:
				diagText = ('Are you sure you want to delete the submittal item type "<b>' + val + '</b>"?');
				InitConfirmDeclineDialog(obj, diagText, type, title, id);
				break;
			case rfiCannedTextGrid:
				diagText = 'Are you sure you want to delete this RFI response?';
				InitConfirmDeclineDialog(obj, diagText, type, title, id);
				break;
			case userSeatsVendorGrid:
				var plural = '';
				if (userSeatsVendorGrid.getCheckedRows(0).indexOf(',') != -1)
					plural = 's';
				diagText = 'Are you sure you want to delete the checked User Seat' + plural + '?';
				InitConfirmDeclineDialog(obj, diagText, type, title, id);
				break;

		}
	}
	else if (type == 'duplicateEntryDelete' | type == 'duplicateEntryNotify') {
		switch (obj) {
			case addressBookGroupsGroupsTree:
				title = 'Duplicate Group Container';
				diagText = ('Group container name <b>"' + val + '</b>" already exists!');
				InitNotifyDialog(obj, diagText, title);
				if (type == 'duplicateEntryDelete') {
					obj.deleteItem(id);
					DisableToolBarButton(tbAddressBookGroupsGroupsTree, 'edit');
					DisableToolBarButton(tbAddressBookGroupsGroupsTree, 'delete');
					tbAddressBookGroupsGroupsTree.hideItem('addChild');
					tbAddressBookGroupsGroupsTree.hideItem('addSibling');
				}
				break;
			case addressBookGroupsGrid:
				title = 'Duplicate Group';
				diagText = ('Group name <b>"' + val + '</b>" already exists!');
				InitNotifyDialog(obj, diagText, title);
				if (type == 'duplicateEntryDelete') {
					DeleteGridRow(obj, id);
				}
				break;
			case addressBookRegionsGrid:
				title = 'Duplicate Region';
				diagText = ('Region name <b>"' + val + '</b>" already exists!');
				InitNotifyDialog(obj, diagText, title);
				if (type == 'duplicateEntryDelete') {
					DeleteGridRow(obj, id);
				}
				break;
		}
	}
	else if (type == 'updateGroupsLevels') {
		title = "Update Group Levels";
		diagText = ('Are you sure you want to change the total group levels?');
		if (addressBookGroupLevels.data('oldval') != 1) {
			diagText += '<br /><br /><b>NOTE: THIS WILL DELETE ALL GROUP CONTAINERS CURRENTLY SET!</b>';
		}
		InitConfirmDeclineDialog(obj, diagText, type, title, id);
	}
}

function InitConfirmDeclineDialog(obj, dialogText, type, title, id) {
	var dialogBox = jQuery('#dialogBox');

	dialogBox.html(dialogText);
	dialogBox.dialog({
		dialogClass: "no-close",
		title: "Confirm " + title,
		modal: true,
		closeOnEscape: false,
		resizable: false,
		buttons: [{
			text: "Confirm",
			click: function () {
				ConfirmDialog(obj, type, id);
				jQuery(this).dialog('destroy');
				dialogBox.html("");
			}
		}, {
			text: "Decline",
			click: function () {
				DeclineDialog(obj, type, id)
				jQuery(this).dialog('destroy');
				dialogBox.text("");
			}
		}]
	})
}

function InitNotifyDialog(obj, dialogText, title) {
	var dialogBox = jQuery('#dialogBox');
	dialogBox.html(dialogText);
	dialogBox.dialog({
		dialogClass: "no-close",
		title: "Notification:  " + title,
		modal: true,
		closeOnEscape: false,
		resizable: false,
		height: 250,
		width: 350,
		buttons: [{
			text: "Ok",
			click: function () {
				jQuery(this).dialog('destroy');
				dialogBox.html("");
			}
		}]
	})
}

function ConfirmDialog(obj, type, id) {
	switch (type) {
		case 'delete':
		case 'deleteMultiple':
			if (obj == addressBookGroupsGroupsTree) {
				var groupString = "";
				var parentName;
				var thisChildName;
				var itemLevel = obj.getLevel(id);
				if (itemLevel == 1) {
					var childGroupIds = addressBookGroupsGroupsTree.getSubItems(id).split('|');
					var childGroupsCt = childGroupIds.length;
					parentName = obj.getItemText(id);
					var tempString;
					for (i = 0; i < childGroupsCt; i++) {
						thisChildName = addressBookGroupsGroupsTree.getItemText(childGroupIds[i]);
						tempString = parentName + " > " + thisChildName + "|";
						groupString += tempString;
					}
				}
				else if (itemLevel == 2) {
					parentName = obj.getItemText(obj.getParentId(id));
					thisChildName = obj.getItemText(id);
					groupString = parentName + " > " + thisChildName;
				}
				UpdateAddressBookGroupParents(itemLevel, groupString);
				DeleteTreeItem(obj, id);
				DisableToolBarButton(tbAddressBookGroupsGroupsTree, 'delete');
				UpdateAddressBookGroup('allgroups');
			}
			else if (obj == addressBookGroupsGrid
				|| obj == addressBookRegionsGrid
				|| obj == messageStatusGrid
				|| obj == projectStatusGrid
				|| obj == projectCustomFieldGrid
				|| obj == addressBookCompanyCustomFieldGrid
				|| obj == addressBookContactCustomFieldGrid
				|| obj == rfiCannedTextGrid
				|| obj == fieldReportsGrid
				|| obj == fieldReportCustomFieldsGrid
				|| obj == cftCustomFieldsGrid
				|| obj == submittalCustomFieldsGrid
				|| obj == punchlistCustomFieldsGrid) {
				DeleteGridRow(obj, id);
				if (obj == addressBookGroupsGrid) {
					DisableToolBarButton(tbAddressBookGroupsGrid, 'delete');
				}
				else if (obj == addressBookRegionsGrid) {
					DisableToolBarButton(tbAddressBookRegionsGrid, 'delete');
				}
				else if (obj == messageStatusGrid) {
					DisableToolBarButton(tbMessageStatusGrid, 'delete');
				}
				else if (obj == projectStatusGrid) {
					DisableToolBarButton(tbProjectStatusGrid, 'delete');
				}
				else if (obj == projectCustomFieldGrid) {
					DisableToolBarButton(tbProjectCustomFieldGrid, 'delete');
				}
				else if (obj == addressBookCompanyCustomFieldGrid) {
					DisableToolBarButton(tbAddressBookCompanyCustomFieldGrid, 'delete');
				}
				else if (obj == addressBookContactCustomFieldGrid) {
					DisableToolBarButton(tbAddressBookContactCustomFieldGrid, 'delete');
				}
				else if (obj == rfiCannedTextGrid) {
					DisableToolBarButton(tbRFICannedTextGrid, 'delete');
				}
				else if (obj == fieldReportsGrid) {
					DisableToolBarButton(tbFieldReports, 'delete');
				}
				else if (obj == fieldReportCustomFieldsGrid) {
					DisableToolBarButton(tbFieldReportCustomFields, 'delete');
				}
				else if (obj == cftCustomFieldsGrid) {
					DisableToolBarButton(tbCFTCustomFields, 'delete');
				}
				else if (obj == submittalCustomFieldsGrid) {
					DisableToolBarButton(tbSubmittalCustomFields, 'delete');
				}
				else if (obj == punchlistCustomFieldsGrid) {
					DisableToolBarButton(tbPunchlistCustomFields, 'delete');
				}
			}
			else if (obj == submittalItemTypesGrid) {
				DeleteGridRow(obj, id);
				DisableToolBarButton(tbSubmittalItemTypes, 'delete');
			}
			else if (obj == userSeatsVendorGrid) {
				DeleteGridRow(obj, id);
				DisableToolBarButton(userSeatsVendorToolbar, 'remove');
			}
			break;
		case 'updateGroupsLevels':
			if (abSettingsInit) {
				if (addressBookGroupLevels.val() == 1) {
					jQuery('.addressBookGroupsTreeContainer').removeClass(pjqHidden);
				}
				PanteraScript.PanteraScriptService.UpdateAddressBookGroupLevels(pjqSessionId, addressBookGroupLevels.val(), GetAddressBookGroups, onScriptError);
			}
			break;
	}
}

function DeclineDialog(obj, type, id) {
	switch (type) {
		case 'delete':
			break;
		case 'updateGroupsLevels':
			addressBookGroupLevels.val(addressBookGroupLevels.data('oldVal'));
			break;
	}
}

var customFieldDialog = null;

function CreateAddEditCustomFieldForm(grid, mode, rowId) {
	isManageCustomFieldTable = false;
	if (!cfDatePickerInit) {
		jQuery('#customFieldDefaultValue-DATE, #customFieldDefaultValue-DATETIMEDATE').datepicker({
			showOn: "button",
			numberOfMonths: 1,
			showButtonPanel: true,
			buttonImage: "/i/calendar.png",
			buttonImageOnly: true,
			width: 400
		});
		jQuery('#customFieldDefaultValue-DATETIMETIME').timepicker({
			showOn: 'button',
			showPeriod: true,
			button: '.ui-timepicker-trigger'
		});
		cfDatePickerInit = true;
	}
	var thisCFFormType;
	if (grid == projectCustomFieldGrid) {
		thisCFFormType = jQuery('#projectCustomFieldType');
	}
	else if (grid == addressBookCompanyCustomFieldGrid | grid == addressBookContactCustomFieldGrid) {
		thisCFFormType = jQuery('#abCustomFieldType');
	}
	else if (grid == fieldReportCustomFieldsGrid) {
		thisCFFormType = jQuery('#fieldReportCustomFieldType');
	}
	else if (grid == cftCustomFieldsGrid) {
		thisCFFormType = jQuery('#customFieldTableCustomFieldType');
	}
	else if (grid == submittalCustomFieldsGrid) {
		thisCFFormType = jQuery('#submittalCustomFieldType');
		jQuery('#submittalcfIsEditableNonAdmin').off().on('click', function () {
			if (jQuery('#submittalcfIsEditableNonAdmin').prop('checked')) {
				jQuery('#submittalcfIsVisibleNonAdmin').prop('checked', true);
				jQuery('#submittalcfIsVisibleNonAdmin').prop('disabled', true);
			}
			else {
				jQuery('#submittalcfIsVisibleNonAdmin').prop('disabled', false);
			}
		});

	}
	else if (grid == punchlistCustomFieldsGrid) {
		thisCFFormType = jQuery('#punchlistCustomFieldType');
		jQuery('#punchlistcfIsEditableNonAdmin').off().on('click', function () {
			if (jQuery('#punchlistcfIsEditableNonAdmin').prop('checked')) {
				jQuery('#punchlistcfIsVisibleNonAdmin').prop('checked', true);
				jQuery('#punchlistcfIsVisibleNonAdmin').prop('disabled', true);
			}
			else {
				jQuery('#punchlistcfIsVisibleNonAdmin').prop('disabled', false);
			}
		});
	}

	if (grid == fieldReportCustomFieldsGrid) {
		var tags = [];
		for (var i = 0; i < fieldReportCustomFieldsGrid.getRowsNum(); i++) {
			var category = fieldReportCustomFieldsGrid.cells2(i, 1).getValue();
			if (category.length > 0 && tags.indexOf(category) == -1) {
				tags.push(category);
			}
		}
		jQuery("#customFieldCategory").autocomplete({
			source: tags
		});
		jQuery("#customFieldCategoryRow").show();
	}
	else {
		jQuery("#customFieldCategoryRow").hide();
	}

	thisCFFormType.closest('tr').removeClass(pjqHidden);
	var dialogBox = dialogBox = jQuery('#customFieldDialogForm');
	var thisDWidth;
	customFieldConstraintDeleteList = [];

	if (mode == 'edit') {
		if (grid == fieldReportCustomFieldsGrid) {
			thisCFFormType.val(grid.cells(rowId, 2).getValue());
		}
		else {
			thisCFFormType.val(grid.cells(rowId, 1).getValue());
		}
		thisCFFormType.attr('disabled', true);
		thisCFFormType.addClass('inputDisabled');
		thisDWidth = LoadCustomFieldFormByType(grid, thisCFFormType.val(), mode);
		PopulateCustomFieldForm(grid, rowId, thisCFFormType.val());
		jQuery('#customFieldName').off();
		jQuery('#customFieldName').keyup(function () {
			CheckDuplicateCustomFieldName(grid, rowId)
		});
	}
	else if (mode == 'add') {
		var newSortOrder = grid.getRowsNum() + 1;
		var sortOrderField = jQuery('#customFieldSortOrder');
		thisDWidth = LoadCustomFieldFormByType(grid, thisCFFormType.val(), mode);
		for (i = 0; i < (grid.getRowsNum() + 1); i++) {
			jQuery('#customFieldSortOrder').append('<option value="' + (i + 1) + '">' + (i + 1) + '</option>')
		}
		sortOrderField.val(newSortOrder);
		thisCFFormType.off();
		thisCFFormType.change(function () {
			LoadCustomFieldFormByType(grid, jQuery(this).val(), 'add');
		})
		jQuery('#customFieldName').off();
		jQuery('#customFieldName').keyup(function () {
			CheckDuplicateCustomFieldName(grid)
		});
	}
	jQuery('#customFieldDefaultValue-INT ').keyup(function () {
		jQuery(this).val(jQuery(this).val().replace(/[^\d]/g, ''));
	});
	jQuery('#customFieldMinVal').keyup(function () {
		jQuery(this).val(jQuery(this).val().replace(/[^\d]/g, ''));
	});
	jQuery('#customFieldMaxVal').keyup(function () {
		jQuery(this).val(jQuery(this).val().replace(/[^\d]/g, ''));
	});
	customFieldDialog = dialogBox;

	var dlgButtons = [{
		text: "Save",
		click: function () {
			if (mode == 'add') {
				if (ValidateCustomFieldForm()) {
					if (thisCFFormType.val() == 'CUSTOMFIELDTABLE')
						isManageCustomFieldTable = true;
					if (grid == projectCustomFieldGrid) {
						AddProjectCustomField(thisCFFormType.val());
					}
					else if (grid == addressBookCompanyCustomFieldGrid | grid == addressBookContactCustomFieldGrid) {
						AddAddressBookCustomField(grid, thisCFFormType.val())
					}
					else if (grid == fieldReportCustomFieldsGrid) {
						AddFieldReportCustomField(thisCFFormType.val().toUpperCase());
					}
					else if (grid == submittalCustomFieldsGrid) {
						AddSubmittalCustomField(thisCFFormType.val().toUpperCase());
					}
					else if (grid == punchlistCustomFieldsGrid) {
						AddPunchlistCustomField(thisCFFormType.val().toUpperCase());
					}
					else if (grid == cftCustomFieldsGrid) {
						AddCustomFieldTableCustomField(thisCFFormType.val().toUpperCase());
					}
					jQuery(this).dialog('destroy');
					ResetCustomFieldForm();
				}
			}
			else if (mode == 'edit') {
				if (ValidateCustomFieldForm()) {
					if (grid == projectCustomFieldGrid) {
						if (cfChoiceDeleteArray.length != 0) {
							customFieldDialog = dialogBox;
							CreateDeleteCustomFieldChoicesDialog(grid, rowId, thisCFFormType.val().toUpperCase());
						}
						else {
							UpdateProjectCustomField(false, false, rowId, thisCFFormType.val().toUpperCase());
							ResetCustomFieldForm();
						}
					}
					else if (grid == addressBookCompanyCustomFieldGrid | grid == addressBookContactCustomFieldGrid) {
						if (cfChoiceDeleteArray.length != 0) {
							customFieldDialog = dialogBox;
							CreateDeleteCustomFieldChoicesDialog(grid, rowId, thisCFFormType.val());
						}
						else {
							UpdateAddressBookCustomField(grid, false, false, rowId, thisCFFormType.val());
							ResetCustomFieldForm();
						}
					}
					else if (grid == fieldReportCustomFieldsGrid) {
						if (cfChoiceDeleteArray.length != 0) {
							customFieldDialog = dialogBox;
							CreateDeleteCustomFieldChoicesDialog(grid, rowId, thisCFFormType.val().toUpperCase());
						}
						else {
							UpdateFieldReportCustomField(false, false, rowId, thisCFFormType.val().toUpperCase());
							ResetCustomFieldForm();
						}
					}
					else if (grid == submittalCustomFieldsGrid) {
						if (cfChoiceDeleteArray.length != 0) {
							customFieldDialog = dialogBox;
							CreateDeleteCustomFieldChoicesDialog(grid, rowId, thisCFFormType.val().toUpperCase());
						}
						else {
							UpdateSubmittalCustomField(false, false, rowId, thisCFFormType.val().toUpperCase());
							ResetCustomFieldForm();
						}
					}
					else if (grid == punchlistCustomFieldsGrid) {
						if (cfChoiceDeleteArray.length != 0) {
							customFieldDialog = dialogBox;
							CreateDeleteCustomFieldChoicesDialog(grid, rowId, thisCFFormType.val().toUpperCase());
						}
						else {
							UpdatePunchlistCustomField(false, false, rowId, thisCFFormType.val().toUpperCase());
							ResetCustomFieldForm();
						}
					}
					else if (grid == cftCustomFieldsGrid) {
						if (cfChoiceDeleteArray.length != 0) {
							customFieldDialog = dialogBox;
							CreateDeleteCustomFieldChoicesDialog(grid, rowId, thisCFFormType.val().toUpperCase());
						}
						else {
							UpdateCustomFieldTableCustomField(false, false, rowId, thisCFFormType.val().toUpperCase());
							ResetCustomFieldForm();
						}
					}
				}
			}

		}
	}, {
		text: "Cancel",
		click: function () {
			jQuery(this).dialog('destroy');
			cfChoiceDeleteArray = [];
			ResetCustomFieldForm();
		}
	}];

	if (thisCFFormType.val() == 'CUSTOMFIELDTABLE') {
		dlgButtons.unshift({
			text: "Manage Columns",
			click: function () {
				isManageCustomFieldTable = true;
				if (mode == 'add') {
					if (ValidateCustomFieldForm()) {
						if (grid == fieldReportCustomFieldsGrid) {
							AddFieldReportCustomField(thisCFFormType.val().toUpperCase());
						}
						jQuery(this).dialog('destroy');
						ResetCustomFieldForm();
					}
				}
				else if (mode == 'edit') {
					if (ValidateCustomFieldForm()) {
						if (grid == fieldReportCustomFieldsGrid) {
							UpdateFieldReportCustomField(false, false, rowId, thisCFFormType.val().toUpperCase());
							ResetCustomFieldForm();
						}
					}
				}
			}
		});
	}

	var thisDHeight = 'auto';
	if (grid == fieldReportCustomFieldsGrid)
		thisDHeight = 600;

	dialogBox.dialog({
		dialogClass: "no-close",
		title: "Add Custom Field",
		modal: true,
		closeOnEscape: false,
		resizable: false,
		width: thisDWidth,
		height: thisDHeight,
		buttons: dlgButtons
	})
}

var customFieldConstraintsToolbar = null, customFieldConstraintsGrid = null;

function LoadCustomFieldFormByType(grid, currentCFFormType, mode) {
	var dialogWidth = 350;
	var dialogBox = jQuery('#customFieldDialogForm').closest('.ui-dialog');
	jQuery('#customFieldSwitchedDialogForm').children('table[id*="customField-"], div[id*="customField-"]').addClass(pjqHidden);
	jQuery('#projcfIsMultChoice, #fieldReportcfIsMultChoice, #submittalcfIsMultChoice, #punchlistcfIsMultChoice').closest('tr').addClass(pjqHidden);
	switch (grid) {
		case projectCustomFieldGrid:
			jQuery('#projectCFDefaultSettingsTable').removeClass(pjqHidden);
			if (currentCFFormType == 'INT') {
				dialogWidth = 400;
			}
			else if (currentCFFormType == 'CHOICE') {
				jQuery('#projcfIsMultChoice').closest('tr').removeClass(pjqHidden);
				dialogWidth = 450;
				if (mode == 'add') {
					GetProjectCustomFieldChoices(0);
				}
			}
			else if (currentCFFormType == 'MONEY') {
				jQuery('#customFieldDefaultValue-MONEY').keyup(function () {
					jQuery(this).val(jQuery(this).val().replace(/[^\d]/g, ''));
					FormatCurrencyHelper(jQuery(this));
				})
			}
			dialogBox.width(dialogWidth);
			break;
		case addressBookCompanyCustomFieldGrid:
		case addressBookContactCustomFieldGrid:
			jQuery('#addressBookCFDefaultSettingsTable').removeClass(pjqHidden);
			jQuery('#abcfShowInList').closest('tr').removeClass(pjqHidden);
			if (currentCFFormType == 'INT') {
				dialogWidth = 400;
			}
			else if (currentCFFormType == 'CHOICE') {
				jQuery('#abcfIsMultChoice').closest('tr').removeClass(pjqHidden);
				dialogWidth = 450;
				if (mode == 'add') {
					if (grid == addressBookCompanyCustomFieldGrid) {
						GetAddressBookCompanyCustomFieldChoices(0);
					}
					else if (grid == addressBookContactCustomFieldGrid) {
						GetAddressBookContactCustomFieldChoices(0);
					}
				}
			}
			else {
				dialogWidth = 350;
			}
			if (grid == addressBookContactCustomFieldGrid) {
				jQuery('#abcfShowInParticipantList').closest('tr').removeClass(pjqHidden);
			}
			dialogBox.width(dialogWidth);
			break;
		case fieldReportCustomFieldsGrid:
			jQuery('#fieldReportCFDefaultSettingsTable').removeClass(pjqHidden);
			jQuery('#customFieldContstraintsContainer').removeClass(pjqHidden);
			jQuery('#customFieldConstraintsGrid').css('width', '100%');

			customFieldConstraintsToolbar = new dhtmlXToolbarObject("customFieldConstraintsToolbar");
			customFieldConstraintsToolbar.setSkin("dhx_web");
			customFieldConstraintsToolbar.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
			customFieldConstraintsToolbar.addButton('add', 0, 'Add', "new.gif", "new_dis.gif");
			customFieldConstraintsToolbar.addButton('delete', 4, 'Delete', "Delete.png", "DeleteD.png");
			customFieldConstraintsToolbar.disableItem('delete');
			customFieldConstraintsToolbar.attachEvent("onClick", function (id) {
				switch (id) {
					case 'add':
						var frd = parseInt(fieldReportCustomFieldsGrid.getUserData(null, 'FieldReportDefinitionId'));
						PanteraScript.PanteraScriptService.GetFieldReportCustomFieldInfo(pjqSessionId, frd, GetFieldReportCustomFieldInfoC, onScriptError);
						break;
					case 'delete':
						//CreateDialog(rfiCannedTextGrid, 'delete', "", rfiCannedTextGrid.getSelectedRowId());
						var rowId = customFieldConstraintsGrid.getSelectedRowId();
						if (rowId.toString().indexOf('newRow') == -1)
							customFieldConstraintDeleteList.push(rowId);

						customFieldConstraintsGrid.deleteRow(rowId);
						customFieldConstraintsToolbar.disableItem("delete");
						break;
				}
			})

			customFieldConstraintsGrid = new dhtmlXGridObject('customFieldConstraintsGrid');
			customFieldConstraintsGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
			customFieldConstraintsGrid.setSkin(pjqGridTheme);
			customFieldConstraintsGrid.enableAutoHeight(true);
			customFieldConstraintsGrid.enableAutoWidth(true);
			customFieldConstraintsGrid.enableEditEvents(true, true, true);
			customFieldConstraintsGrid.setHeader('Custom Field,Field Value');
			customFieldConstraintsGrid.setColTypes('coro,coro');
			customFieldConstraintsGrid.setInitWidthsP('50,50');
			customFieldConstraintsGrid.enableValidation(true, true);
			customFieldConstraintsGrid.setColValidators(["NotEmpty", "NotEmpty"]);

			customFieldConstraintsGrid.init();
			customFieldConstraintsGrid.attachEvent("onRowSelect", function (id, ind) {
				customFieldConstraintsToolbar.enableItem('delete');
			});

			var frd = parseInt(fieldReportCustomFieldsGrid.getUserData(null, 'FieldReportDefinitionId'));
			PanteraScript.PanteraScriptService.GetFieldReportCustomFieldInfo(pjqSessionId, frd, GetFieldReportCustomFieldInfo2C, onScriptError);

			customFieldConstraintsGrid.attachEvent("onEditCell", function (stage, rId, cInd, nValue, oValue) {
				if (stage == 2) {
					if (cInd == 0) {

						// get current value of 2nd column
						var oldValue = customFieldConstraintsGrid.cells(rId, 1).getValue();
						customFieldConstraintsGrid.cells(rId, 1).setValue('');

						// get the combo reference and clear it
						var combo = customFieldConstraintsGrid.getCustomCombo(rId, 1);
						combo.clear();
						combo.put('', 'Select...');

						for (var i = 0; i < customFieldInfo.length; i++) {
							if (customFieldInfo[i].FieldReportCustomFieldId == parseInt(customFieldConstraintsGrid.cells(rId, 0).getValue())) {
								if (customFieldInfo[i].FieldType == 'BOOL') {
									combo.put('True', 'Yes');
									combo.put('False', 'No');

									if (oldValue != 'True' && oldValue != 'False')
										oldValue = '';
								}
								else if (customFieldInfo[i].FieldType == 'CHOICE') {
									var oldValueFound = false;
									for (j = 0; j < customFieldInfo[i].ChoiceList.length; j++) {
										if (oldValue && customFieldInfo[i].ChoiceList[j].ChoiceId == parseInt(oldValue))
											oldValueFound = true;
										combo.put(customFieldInfo[i].ChoiceList[j].ChoiceId, customFieldInfo[i].ChoiceList[j].ChoiceName);

									}

									if (!oldValueFound)
										oldValue = '';
								}
							}
						}
						if (oldValue)
							customFieldConstraintsGrid.cells(rId, 1).setValue(oldValue);
					}
				}
				return true;
			});

			dialogWidth = 550;

			if (currentCFFormType == 'INT') {
				//dialogWidth = 400;
			}
			else if (currentCFFormType == 'CHOICE') {
				jQuery('#fieldReportcfIsMultChoice').closest('tr').removeClass(pjqHidden);
				jQuery('#fieldReportcfIsMultChoice').siblings('span').text('Allow Multiple Choices');
				//dialogWidth = 450;
				if (mode == 'add') {
					GetFieldReportCustomFieldChoices(0);
				}
			}
			else if (currentCFFormType == 'MONEY') {
				jQuery('#customFieldDefaultValue-MONEY').keyup(function () {
					jQuery(this).val(jQuery(this).val().replace(/[^\d]/g, ''));
					FormatCurrencyHelper(jQuery(this));
				})
			}
			else if (currentCFFormType == 'FILE') {
				jQuery('#fieldReportcfIsMultChoice').closest('tr').removeClass(pjqHidden);
				jQuery('#fieldReportcfIsMultChoice').siblings('span').text('Allow Multiple Files');
			}
			dialogBox.width(dialogWidth);
			break;
		case submittalCustomFieldsGrid:
			jQuery('#submittalCFDefaultSettingsTable').removeClass(pjqHidden);
			if (currentCFFormType == 'INT') {
				dialogWidth = 400;
			}
			else if (currentCFFormType == 'CHOICE') {
				jQuery('#submittalcfIsMultChoice').closest('tr').removeClass(pjqHidden);
				jQuery('#submittalcfIsMultChoice').siblings('span').text('Allow Multiple Choices');
				dialogWidth = 450;
				if (mode == 'add') {
					GetSubmittalCustomFieldChoices(0);
				}
			}
			else if (currentCFFormType == 'MONEY') {
				jQuery('#customFieldDefaultValue-MONEY').keyup(function () {
					jQuery(this).val(jQuery(this).val().replace(/[^\d]/g, ''));
					FormatCurrencyHelper(jQuery(this));
				})
			}
			else if (currentCFFormType == 'FILE') {
				jQuery('#submittalcfIsMultChoice').closest('tr').removeClass(pjqHidden);
				jQuery('#submittalcfIsMultChoice').siblings('span').text('Allow Multiple Files');
			}
			dialogBox.width(dialogWidth);
			break;
		case punchlistCustomFieldsGrid:
			jQuery('#punchlistCFDefaultSettingsTable').removeClass(pjqHidden);
			if (currentCFFormType == 'INT') {
				dialogWidth = 400;
			}
			else if (currentCFFormType == 'CHOICE') {
				jQuery('#punchlistcfIsMultChoice').closest('tr').removeClass(pjqHidden);
				jQuery('#punchlistcfIsMultChoice').siblings('span').text('Allow Multiple Choices');
				dialogWidth = 450;
				if (mode == 'add') {
					GetPunchlistCustomFieldChoices(0);
				}
			}
			else if (currentCFFormType == 'MONEY') {
				jQuery('#customFieldDefaultValue-MONEY').keyup(function () {
					jQuery(this).val(jQuery(this).val().replace(/[^\d]/g, ''));
					FormatCurrencyHelper(jQuery(this));
				})
			}
			dialogBox.width(dialogWidth);
			break;
		case cftCustomFieldsGrid:
			jQuery('#customFieldTableCFDefaultSettingsTable').removeClass(pjqHidden);
			if (currentCFFormType == 'INT') {
				dialogWidth = 400;
			}
			else if (currentCFFormType == 'CHOICE') {
				jQuery('#customFieldTablecfIsMultChoice').closest('tr').removeClass(pjqHidden);
				jQuery('#customFieldTablecfIsMultChoice').siblings('span').text('Allow Multiple Choices');
				dialogWidth = 450;
				if (mode == 'add') {
					GetCustomFieldTableCustomFieldChoices(0);
				}
			}
			else if (currentCFFormType == 'MONEY') {
				jQuery('#customFieldDefaultValue-MONEY').keyup(function () {
					jQuery(this).val(jQuery(this).val().replace(/[^\d]/g, ''));
					FormatCurrencyHelper(jQuery(this));
				})
			}
			dialogBox.width(dialogWidth);
			break;
	}
	jQuery('#customFieldDefaultValue-' + currentCFFormType).val('');
	jQuery('#customField-' + currentCFFormType).removeClass(pjqHidden);
	return dialogWidth;
}

function PopulateCustomFieldForm(grid, rowId, currentCFFormType) {
	jQuery('#customFieldName').val(grid.cells(rowId, 0).getValue());
	lastCustomFieldId = parseInt(rowId);
	var thisSortOrder = parseInt(grid.cells(rowId, grid.getColumnsNum() - 1).getValue());
	var isMult = grid.getUserData(rowId, 'isAllowMultChoice');
	isMult = isMult.toLowerCase() === 'true';
	if (grid == addressBookContactCustomFieldGrid) {
		var showInList = grid.getUserData(rowId, 'isShowInList');
		showInList = showInList.toLowerCase() === 'true';
		jQuery('#abcfShowInList').prop('checked', showInList);
		jQuery('#abcfIsMultChoice').prop('checked', isMult);
		jQuery('#abcfRSVPEditable').prop('checked', GridCboxIsChecked(grid.cells(rowId, 2).getValue()));
		jQuery('#abcfRSVPRequired').prop('checked', GridCboxIsChecked(grid.cells(rowId, 3).getValue()));
		jQuery('#abcfShowInParticipantList').prop('checked', GridCboxIsChecked(grid.cells(rowId, 4).getValue()));
		thisSortOrder = parseInt(grid.cells(rowId, 5).getValue());
	}
	else if (grid == addressBookCompanyCustomFieldGrid) {
		var showInList = grid.getUserData(rowId, 'isShowInList');
		showInList = showInList.toLowerCase() === 'true';
		jQuery('#abcfShowInList').prop('checked', showInList);
		jQuery('#abcfIsMultChoice').prop('checked', isMult);
		jQuery('#abcfRSVPEditable').prop('checked', GridCboxIsChecked(grid.cells(rowId, 2).getValue()));
		jQuery('#abcfRSVPRequired').prop('checked', GridCboxIsChecked(grid.cells(rowId, 3).getValue()));
		jQuery('#abcfShowInParticipantList').prop('checked', GridCboxIsChecked(grid.cells(rowId, 4).getValue()));
		thisSortOrder = parseInt(grid.cells(rowId, 5).getValue());
	}
	else if (grid == projectCustomFieldGrid) {
		jQuery('#projcfIsMultChoice').prop('checked', isMult);
		jQuery('#projcfRequired').prop('checked', GridCboxIsChecked(grid.cells(rowId, 2).getValue()));
		jQuery('#projcfVisible').prop('checked', GridCboxIsChecked(grid.cells(rowId, 3).getValue()));
	}
	else if (grid == fieldReportCustomFieldsGrid) {
		jQuery('#customFieldCategory').val(grid.cells(rowId, 1).getValue());
		jQuery('#fieldReportcfIsMultChoice').prop('checked', isMult);
		jQuery('#fieldReportcfRequired').prop('checked', GridCboxIsChecked(grid.cells(rowId, 3).getValue()));
		customFieldConstraintsGrid.load("/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=CustomFieldConstraints&context=FieldReport&customfieldid=" + rowId + '&x=' + (new Date), "xml");
		var frd = parseInt(fieldReportCustomFieldsGrid.getUserData(null, 'FieldReportDefinitionId'));
		PanteraScript.PanteraScriptService.GetFieldReportCustomFieldInfo(pjqSessionId, frd, GetFieldReportCustomFieldInfo2C, onScriptError);
		if (currentCFFormType == 'VENDOR-LIST') {
			var hideRows = grid.getUserData(rowId, 'hideRows');
			var hideRowsArr = hideRows.split('|');
			for (var i = 0; i < hideRowsArr.length; i++) {
				jQuery('#vendorlist_show_' + hideRowsArr[i]).prop('checked', false);
			}
		}
	}
	else if (grid == submittalCustomFieldsGrid) {
		jQuery('#submittalcfIsMultChoice').prop('checked', isMult);
		jQuery('#submittalcfIsEditableNonAdmin').prop('checked', !(grid.getUserData(rowId, 'isAdminEditOnly').toLowerCase() === "true") && (grid.getUserData(rowId, 'isVisibleNonAdmin').toLowerCase() === "true"));
		jQuery('#submittalcfIsVisibleNonAdmin').prop('checked', (grid.getUserData(rowId, 'isVisibleNonAdmin').toLowerCase() === "true"));
		if (jQuery('#submittalcfIsEditableNonAdmin').prop('checked')) {
			jQuery('#submittalcfIsVisibleNonAdmin').prop('checked', true);
			jQuery('#submittalcfIsVisibleNonAdmin').prop('disabled', true);
		}
		else {
			jQuery('#submittalcfIsVisibleNonAdmin').prop('disabled', false);
		}

		jQuery('#submittalcfRequired').prop('checked', GridCboxIsChecked(grid.cells(rowId, 2).getValue()));
	}
	else if (grid == punchlistCustomFieldsGrid) {
		jQuery('#punchlistcfIsMultChoice').prop('checked', isMult);
		jQuery('#punchlistcfIsEditableNonAdmin').prop('checked', !(grid.getUserData(rowId, 'isAdminEditOnly').toLowerCase() === "true") && (grid.getUserData(rowId, 'isVisibleNonAdmin').toLowerCase() === "true"));
		jQuery('#punchlistcfIsVisibleNonAdmin').prop('checked', (grid.getUserData(rowId, 'isVisibleNonAdmin').toLowerCase() === "true"));
		if (jQuery('#punchlistcfIsEditableNonAdmin').prop('checked')) {
			jQuery('#punchlistcfIsVisibleNonAdmin').prop('checked', true);
			jQuery('#punchlistcfIsVisibleNonAdmin').prop('disabled', true);
		}
		else {
			jQuery('#punchlistcfIsVisibleNonAdmin').prop('disabled', false);
		}

		jQuery('#punchlistcfRequired').prop('checked', GridCboxIsChecked(grid.cells(rowId, 2).getValue()));
	}
	else if (grid == cftCustomFieldsGrid) {
		jQuery('#customFieldTablecfIsMultChoice').prop('checked', isMult);
		jQuery('#customFieldTablecfWidthPercent').val(grid.cells(rowId, 2).getValue());
		jQuery('#customFieldTablecfRequired').prop('checked', GridCboxIsChecked(grid.cells(rowId, 3).getValue()));
		thisSortOrder = parseInt(grid.cells(rowId, 4).getValue());
	}

	for (i = 0; i < grid.getRowsNum(); i++) {
		jQuery('#customFieldSortOrder').append('<option value="' + (i + 1) + '">' + (i + 1) + '</option>')
	}
	jQuery('#customFieldSortOrder').val(thisSortOrder);
	if (currentCFFormType == 'CHOICE') {
		if (grid == projectCustomFieldGrid) {
			GetProjectCustomFieldChoices(rowId);
		}
		else if (grid == addressBookCompanyCustomFieldGrid) {
			GetAddressBookCompanyCustomFieldChoices(rowId);
		}
		else if (grid == addressBookContactCustomFieldGrid) {
			GetAddressBookContactCustomFieldChoices(rowId);
		}
		else if (grid == fieldReportCustomFieldsGrid) {
			GetFieldReportCustomFieldChoices(rowId);
		}
		else if (grid == submittalCustomFieldsGrid) {
			GetSubmittalCustomFieldChoices(rowId);
		}
		else if (grid == punchlistCustomFieldsGrid) {
			GetPunchlistCustomFieldChoices(rowId);
		}
		else if (grid == cftCustomFieldsGrid) {
			GetCustomFieldTableCustomFieldChoices(rowId);
		}
	}
	else if (currentCFFormType == 'DATETIME') {
		var tempDateTime = grid.getUserData(rowId, 'defaultValue');
		var tempDate = tempDateTime.substring(0, tempDateTime.indexOf(' '));
		var tempTime = tempDateTime.substring(tempDateTime.indexOf(' ') + 1, tempDateTime.length);
		jQuery('#customFieldDefaultValue-DATETIMEDATE').val(tempDate);
		jQuery('#customFieldDefaultValue-DATETIMETIME').val(tempTime);
	}
	else {
		jQuery('#customFieldDefaultValue-' + currentCFFormType).val(grid.getUserData(rowId, 'defaultValue'));
	}
	if (currentCFFormType == 'INT') {
		jQuery('#customFieldMinVal').val(grid.getUserData(rowId, 'minValue'));
		jQuery('#customFieldMaxVal').val(grid.getUserData(rowId, 'maxValue'));
	}
}

function UpdateCustomFieldChoicesDefaultValueDropDown(cfGrid, cfcGrid, cfId) {
	var choiceDefault = jQuery('#customFieldDefaultValue-CHOICE');
	var thisCFCName;
	choiceDefault.empty();
	choiceDefault.append('<option value="0">No Default</option>');
	for (i = 0; i < cfcGrid.getRowsNum(); i++) {
		thisCFCName = cfcGrid.cells2(i, 0).getValue();
		choiceDefault.append('<option value="' + cfcGrid.getRowId(i) + '">' + thisCFCName + '</option>').attr('value', thisCFCName);
	}
	var thisDefVal = cfGrid.getUserData(cfId, 'defaultValue');
	choiceDefault.val(thisDefVal);
	return true;
}

function ResetCustomFieldForm() {
	var cfForms = jQuery('#abCustomFieldType').add('#projectCustomFieldType').add('#fieldReportCustomFieldType').add('#submittalCustomFieldType').add('#punchlistCustomFieldType').add('#customFieldTableCustomFieldType');
	jQuery('#customFieldFormContainer').find('input').removeClass('pjq-input-error');
	jQuery('#customFieldFormContainer').find('.pjq-errortext').remove();
	jQuery('.projectCFChoicesGridContainer').addClass(pjqHidden);
	jQuery('#addressBookCompanyCFChoicesGridContainer').addClass(pjqHidden);
	jQuery('#addressBookContactCFChoicesGridContainer').addClass(pjqHidden);
	jQuery('#fieldReportCFChoicesGridContainer').addClass(pjqHidden);
	jQuery('#customFieldContstraintsContainer').addClass(pjqHidden);
	jQuery('#submittalCFChoicesGridContainer').addClass(pjqHidden);
	jQuery('#punchlistCFChoicesGridContainer').addClass(pjqHidden);
	jQuery('#customFieldTableCFChoicesGridContainer').addClass(pjqHidden);
	cfForms.closest('tr').removeClass(pjqHidden);
	cfForms.val('TEXT');
	cfForms.removeClass('inputDisabled');
	cfForms.attr('disabled', false);
	cfForms.closest('tr').addClass(pjqHidden);
	jQuery('#customFieldSwitchedDialogForm').children('table[id*="customField-"], div[id*="customField-"]').addClass(pjqHidden);
	jQuery('#cfChoicesGridContainer').children('div').addClass(pjqHidden);
	jQuery('#customFieldName').val('');
	jQuery('#customFieldName').css('background', 'inherit');
	jQuery('#customFieldCategory').val('');
	jQuery('#customFieldSortOrder').val('1');
	jQuery('#customFieldSortOrder').empty();
	jQuery('#customFieldMinVal').val("");
	jQuery('#customFieldMaxVal').val("");
	jQuery('#projcfIsMultChoice').prop('checked', false);
	jQuery('#abcfShowInList').prop('checked', false);
	jQuery('#abcfShowInList').closest('tr').addClass(pjqHidden);
	jQuery('#abcfIsMultChoice').prop('checked', false);
	jQuery('#abcfIsMultChoice').closest('tr').addClass(pjqHidden);
	jQuery('#projcfIsMultChoice').closest('tr').addClass(pjqHidden);
	jQuery('#projcfRequired').prop('checked', false);
	jQuery('#projcfVisible').prop('checked', false);
	jQuery('#abcfRSVPEditable').prop('checked', false);
	jQuery('#abcfRSVPRequired').prop('checked', false);
	jQuery('#abcfShowInParticipantList').prop('checked', false);
	jQuery('#abcfShowInParticipantList').closest('tr').addClass(pjqHidden)
	jQuery('#fieldReportcfIsMultChoice').closest('tr').addClass(pjqHidden);
	jQuery('#fieldReportcfIsMultChoice').prop('checked', false);
	jQuery('#fieldReportcfRequired').prop('checked', false);
	jQuery('#submittalcfIsMultChoice').closest('tr').addClass(pjqHidden);
	jQuery('#submittalcfIsMultChoice').prop('checked', false);
	jQuery('#submittalcfRequired').prop('checked', false);
	jQuery('#submittalcfIsEditableNonAdmin').prop('checked', false);
	jQuery('#submittalcfIsVisibleNonAdmin').prop('checked', false);
	jQuery('#submittalcfIsVisibleNonAdmin').prop('disabled', false);
	jQuery('#punchlistcfIsMultChoice').closest('tr').addClass(pjqHidden);
	jQuery('#punchlistcfIsMultChoice').prop('checked', false);
	jQuery('#punchlistcfRequired').prop('checked', false);
	jQuery('#punchlistcfIsEditableNonAdmin').prop('checked', false);
	jQuery('#punchlistcfIsVisibleNonAdmin').prop('checked', false);
	jQuery('#punchlistcfIsVisibleNonAdmin').prop('disabled', false);
	jQuery('#customFieldTablecfIsMultChoice').closest('tr').addClass(pjqHidden);
	jQuery('#customFieldTablecfIsMultChoice').prop('checked', false);
	jQuery('#customFieldTablecfRequired').prop('checked', false);
	jQuery('#customFieldTablecfWidthPercent').val('10');
	jQuery('#projectCFDefaultSettingsTable').addClass(pjqHidden);
	jQuery('#addressBookCFDefaultSettingsTable').addClass(pjqHidden);
	jQuery('#fieldReportCFDefaultSettingsTable').addClass(pjqHidden);
	jQuery('#submittalCFDefaultSettingsTable').addClass(pjqHidden);
	jQuery('#customFieldTableCFDefaultSettingsTable').addClass(pjqHidden);
	jQuery('#abCustomFieldTypeContainer').addClass(pjqHidden);
	jQuery('#projectCustomFieldTypeContainer').addClass(pjqHidden);
	jQuery('#fieldReportCustomFieldTypeContainer').addClass(pjqHidden);
	jQuery('#submittalCustomFieldTypeContainer').addClass(pjqHidden);
	jQuery('#punchlistCustomFieldTypeContainer').addClass(pjqHidden);
	jQuery('#customFieldTableCustomFieldTypeContainer').addClass(pjqHidden);
	jQuery('#customFieldDialogForm').siblings('.ui-dialog-buttonpane').find(".ui-button:first").button('enable');
}

function CreateDeleteCustomFieldChoicesDialog(grid, customFieldId, customFieldType) {
	var dialogBox = jQuery('#dialogBox');
	dialogBox.html("You have chosen to delete custom field choices.  Are you sure you want to save?");
	dialogBox.dialog({
		dialogClass: "no-close",
		title: "Confirm Deletion",
		modal: true,
		closeOnEscape: false,
		resizable: false,
		buttons: [{
			text: "Save",
			click: function () {
				ConfirmDeleteCustomFieldChoices(grid, customFieldId, customFieldType);
				dialogBox.dialog('destroy');
			}
		}, {
			text: "Cancel",
			click: function () {
				dialogBox.dialog('destroy');
			}
		}]
	})
}

function ConfirmDeleteCustomFieldChoices(grid, customFieldId, customFieldType) {
	switch (grid) {
		case projectCustomFieldGrid:
			for (i = 0; i < cfChoiceDeleteArray.length; i++) {
				PanteraScript.PanteraScriptService.DeleteProjectCustomFieldChoice(pjqSessionId, cfChoiceDeleteArray[i], DeleteCustomFieldChoiceC, onScriptError);
			}
			UpdateProjectCustomField(false, false, customFieldId, customFieldType);
			break;
		case addressBookCompanyCustomFieldGrid:
			for (i = 0; i < cfChoiceDeleteArray.length; i++) {
				PanteraScript.PanteraScriptService.DeleteCompanyCustomFieldChoice(pjqSessionId, cfChoiceDeleteArray[i], DeleteCustomFieldChoiceC, onScriptError);
			}
			UpdateAddressBookCustomField(grid, false, false, customFieldId, customFieldType);
			break;
		case addressBookContactCustomFieldGrid:
			for (i = 0; i < cfChoiceDeleteArray.length; i++) {
				PanteraScript.PanteraScriptService.DeleteContactCustomFieldChoice(pjqSessionId, cfChoiceDeleteArray[i], DeleteCustomFieldChoiceC, onScriptError);
			}
			UpdateAddressBookCustomField(grid, false, false, customFieldId, customFieldType);
			break;
		case fieldReportCustomFieldsGrid:
			for (i = 0; i < cfChoiceDeleteArray.length; i++) {
				PanteraScript.PanteraScriptService.DeleteFieldReportCustomFieldChoice(pjqSessionId, cfChoiceDeleteArray[i], DeleteCustomFieldChoiceC, onScriptError);
			}
			UpdateFieldReportCustomField(grid, false, false, customFieldId, customFieldType);
			break;

		case punchlistCustomFieldsGrid:
			for (i = 0; i < cfChoiceDeleteArray.length; i++) {
				PanteraScript.PanteraScriptService.DeletePunchlistCustomFieldChoice(pjqSessionId, cfChoiceDeleteArray[i], DeleteCustomFieldChoiceC, onScriptError);
			}
			UpdateFieldReportCustomField(grid, false, false, customFieldId, customFieldType);
			break;

		case cftCustomFieldsGrid:
			for (i = 0; i < cfChoiceDeleteArray.length; i++) {
				PanteraScript.PanteraScriptService.DeleteCustomFieldTableCustomFieldChoice(pjqSessionId, cfChoiceDeleteArray[i], DeleteCustomFieldChoiceC, onScriptError);
			}
			UpdateCustomFieldTableCustomField(grid, false, false, customFieldId, customFieldType);
			break;
	}
}

var cfcSavedCount = 0;

function DeleteCustomFieldChoiceC(response) {
	cfcSavedCount++;
	if (customFieldDialog != null && cfcSavedCount == cfChoiceDeleteArray.length) {
		customFieldDialog.dialog('destroy');
		customFieldDialog = null;
	}
	cfChoiceDeleteArray = [];
}

function UpdateGridCombos(grid) {
	switch (grid) {
		case addressBookGroupsGrid:
			var abGroupParentCombo = grid.getColumnCombo(1);
			if (addressBookGroupLevels.val() > 1) {
				abGroupParentCombo.loadXML("/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=GroupsGroupsGridCombo&customFieldid=0");
			}
			break;
		case addressBookRegionsGrid:
			var abRegionStateCombo = grid.getColumnCombo(2);
			abRegionStateCombo.loadXML("/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=RegionsStateGridCombo&customFieldid=0");
			break;
	}
}

function onGridMenuButtonClick(grid, zoneId, action) {
	var zoneArray = zoneId.split('_');
	var rClickedRowId = zoneArray[0];
	var rClickedCellInd = parseInt(zoneArray[1]);
	switch (action) {
		case 'add':
			if (grid == projectStatusGrid || grid == messageStatusGrid || grid == addressBookGroupsGrid || grid == addressBookRegionsGrid) {
				AddNewGridRow(grid);
			}
			else if (grid == addressBookCompanyCustomFieldGrid || grid == addressBookContactCustomFieldGrid || grid == projectCustomFieldGrid || grid == fieldReportCustomFieldsGrid || grid == punchlistCustomFieldsGrid || grid == cftCustomFieldsGrid) {
				CreateAddEditCustomFieldForm(grid, 'add');
			}
			else if (grid == rfiCannedTextGrid) {
				initRFIEditGrid();
			}
			break;
		case 'edit':
			if (grid == projectStatusGrid || grid == messageStatusGrid || grid == addressBookCompanyCustomFieldChoicesGrid || grid == addressBookContactCustomFieldChoicesGrid) {
				EditGridCell(grid, rClickedRowId, 0);
			}
			else if (grid == addressBookGroupsGrid || grid == addressBookRegionsGrid) {
				if (rClickedCellInd > 3) {
					EditGridCell(grid, rClickedRowId, rClickedCellInd);
				}
				else {
					EditGridCell(grid, rClickedRowId, 0);
				}
			}
			else if (grid == addressBookCompanyCustomFieldGrid || grid == addressBookContactCustomFieldGrid || grid == projectCustomFieldGrid || grid == fieldReportCustomFieldsGrid || grid == punchlistCustomFieldsGrid || grid == cftCustomFieldsGrid) {
				CreateAddEditCustomFieldForm(grid, 'edit', rClickedRowId);
			}
			else if (grid == rfiCannedTextGrid) {
				PanteraScript.PanteraScriptService.GetRFICannedText(pjqSessionId, parseInt(rClickedRowId), initRFIEditGrid, onScriptError);
			}
			break;
		case 'delete':
			CreateDialog(grid, 'delete', grid.cells(rClickedRowId, 0).getValue(), rClickedRowId);
			break;
	}
}

function AddNewGridRow(grid) {
	var newRowData;
	var newRowNumber = grid.getRowsNum();
	var sortOrder = newRowNumber + 1;
	var currentdate = new Date();
	var hours = currentdate.getHours();
	var minutes = currentdate.getMinutes();
	var minutesParsed = minutes > 9 ? minutes : "0" + minutes.toString();
	var seconds = currentdate.getSeconds();
	var secondsParsed = seconds > 9 ? seconds : "0" + seconds.toString();
	var ampm = hours >= 12 ? 'PM' : 'AM';
	var dateTime = (currentdate.getMonth() + 1) + "/" + currentdate.getDate() + "/" + currentdate.getFullYear() + " " + hours + ":" + minutesParsed + ":" + secondsParsed + " " + ampm;
	switch (grid) {
		case fieldReportsGrid:
			newRowData = ["", "", 1];
			break;
		case projectStatusGrid:
		case messageStatusGrid:
			newRowData = ["", 0, sortOrder];
			break;
		case addressBookGroupsGrid:
			if (addressBookSettings.IsCSICodeEnabled)
				newRowData = ["", "", "", sortOrder, dateTime, 0];
			else
				newRowData = ["", "", sortOrder, dateTime, 0];
			break;
		case addressBookRegionsGrid:
			newRowData = ["", sortOrder, dateTime];
			break;
		case projectCustomFieldChoicesGrid:
		case addressBookCompanyCustomFieldChoicesGrid:
		case addressBookContactCustomFieldChoicesGrid:
		case fieldReportCustomFieldChoicesGrid:
		case submittalCustomFieldChoicesGrid:
		case punchlistCustomFieldChoicesGrid:
		case customFieldTableCustomFieldChoicesGrid:
			newRowData = ["", sortOrder];
			break;
	}
	grid.addRow("newRow" + newRowCounter, newRowData);
	EditGridCell(grid);
	newRowCounter++;
}

function DeleteGridRow(grid, rowId, isAjaxDelete) {
	if (isAjaxDelete == null) {
		isAjaxDelete = true;
	}
	var isMultiple;
	var id;
	if (rowId.indexOf(',') > -1) {
		isMultiple = true;
		id = rowId.split(',');
	}
	else {
		isMultiple = false;
		id = rowId;
	}
	switch (grid) {
		case projectStatusGrid:
			grid.deleteSelectedRows();
			ChangeSortByOrder(grid, 2);
			SaveProjectStatusListGrid(2);
		case messageStatusGrid:
			grid.deleteSelectedRows();
			ChangeSortByOrder(grid, 2);
			SaveMessageStatusListGrid(2);
			break;
		case addressBookGroupsGrid:
			if (id.indexOf('new') == -1) {
				if (isMultiple) {
					for (i = 0; i < id.length; i++) {
						PanteraScript.PanteraScriptService.DeleteAddressBookGroup(pjqSessionId, id[i], SettingSavedCallback, onScriptError);
					}
				}
				else {
					PanteraScript.PanteraScriptService.DeleteAddressBookGroup(pjqSessionId, id, SettingSavedCallback, onScriptError);
				}
			}
			grid.deleteSelectedRows();
			ChangeSortByOrder(grid, 2);
			break;
		case addressBookRegionsGrid:
			if (id.indexOf('new') == -1) {
				if (isMultiple) {
					for (i = 0; i < id.length; i++) {
						PanteraScript.PanteraScriptService.DeleteAddressBookRegion(pjqSessionId, id[i], SettingSavedCallback, onScriptError);
					}
				}
				else {
					PanteraScript.PanteraScriptService.DeleteAddressBookRegion(pjqSessionId, id, SettingSavedCallback, onScriptError);
				}
			}
			grid.deleteSelectedRows();
			ChangeSortByOrder(grid, 1);
			break;
		case projectCustomFieldGrid:
			if (id.indexOf('new') == -1) {
				if (isMultiple) {
					for (i = 0; i < id.length; i++) {
						PanteraScript.PanteraScriptService.DeleteProjectCustomField(pjqSessionId, id[i], SettingSavedCallback, onScriptError);
					}
				}
				else {
					PanteraScript.PanteraScriptService.DeleteProjectCustomField(pjqSessionId, id, SettingSavedCallback, onScriptError);
				}
			}
			grid.deleteSelectedRows();
			ChangeSortByOrder(grid, 4);
			break;
		case projectCustomFieldChoicesGrid:
			if (id.indexOf('new') == -1 && isAjaxDelete) {
				if (isMultiple) {
					for (i = 0; i < id.length; i++) {
						PanteraScript.PanteraScriptService.DeleteProjectCustomFieldChoice(pjqSessionId, id[i], SettingSavedCallback, onScriptError);
					}
				}
				else {
					PanteraScript.PanteraScriptService.DeleteProjectCustomFieldChoice(pjqSessionId, id, SettingSavedCallback, onScriptError);
				}
			}
			grid.deleteSelectedRows();
			ChangeSortByOrder(grid, 1);
			UpdateCustomFieldChoicesDefaultValueDropDown(projectCustomFieldGrid, projectCustomFieldChoicesGrid, rowId);
			break;
		case addressBookCompanyCustomFieldGrid:
			if (id.indexOf('new') == -1) {
				if (isMultiple) {
					for (i = 0; i < id.length; i++) {
						PanteraScript.PanteraScriptService.DeleteCompanyCustomField(pjqSessionId, id[i], SettingSavedCallback, onScriptError);
					}
				}
				else {
					PanteraScript.PanteraScriptService.DeleteCompanyCustomField(pjqSessionId, id, SettingSavedCallback, onScriptError);
				}
			}
			grid.deleteSelectedRows();
			ChangeSortByOrder(grid, 4);
			break;
		case addressBookContactCustomFieldGrid:
			if (id.indexOf('new') == -1) {
				if (isMultiple) {
					for (i = 0; i < id.length; i++) {
						PanteraScript.PanteraScriptService.DeleteContactCustomField(pjqSessionId, id[i], SettingSavedCallback, onScriptError);
					}
				}
				else {
					PanteraScript.PanteraScriptService.DeleteContactCustomField(pjqSessionId, id, SettingSavedCallback, onScriptError);
				}
			}
			grid.deleteSelectedRows();
			ChangeSortByOrder(grid, 5);
			break;
		case addressBookCompanyCustomFieldChoicesGrid:
			if (id.indexOf('new') == -1 && isAjaxDelete) {
				if (isMultiple) {
					for (i = 0; i < id.length; i++) {
						PanteraScript.PanteraScriptService.DeleteCompanyCustomFieldChoice(pjqSessionId, id[i], SettingSavedCallback, onScriptError);
					}
				}
				else {
					PanteraScript.PanteraScriptService.DeleteCompanyCustomFieldChoice(pjqSessionId, id, SettingSavedCallback, onScriptError);
				}
			}
			grid.deleteSelectedRows();
			ChangeSortByOrder(grid, 1);
			UpdateCustomFieldChoicesDefaultValueDropDown(addressBookCompanyCustomFieldGrid, addressBookCompanyCustomFieldChoicesGrid, rowId);
			break;
		case addressBookContactCustomFieldChoicesGrid:
			if (id.indexOf('new') == -1 && isAjaxDelete) {
				if (isMultiple) {
					for (i = 0; i < id.length; i++) {
						PanteraScript.PanteraScriptService.DeleteContactCustomFieldChoice(pjqSessionId, id[i], SettingSavedCallback, onScriptError);
					}
				}
				else {
					PanteraScript.PanteraScriptService.DeleteContactCustomFieldChoice(pjqSessionId, id, SettingSavedCallback, onScriptError);
				}
			}
			grid.deleteSelectedRows();
			ChangeSortByOrder(grid, 1);
			UpdateCustomFieldChoicesDefaultValueDropDown(addressBookContactCustomFieldGrid, addressBookContactCustomFieldChoicesGrid, rowId);
			break;
		case rfiCannedTextGrid:
			if (id.indexOf('new') == -1 && isAjaxDelete) {
				PanteraScript.PanteraScriptService.DeleteRFICannedText(pjqSessionId, id, refreshRFIGrid, onScriptError);
			}
			break;
		case fieldReportsGrid:
			if (id.indexOf('new') == -1) {
				PanteraScript.PanteraScriptService.DeleteFieldReportDefinition(pjqSessionId, id, SettingSavedCallback, onScriptError);
			}
			grid.deleteSelectedRows();
			break;
		case fieldReportCustomFieldsGrid:
			if (id.indexOf('new') == -1) {
				if (isMultiple) {
					for (i = 0; i < id.length; i++) {
						PanteraScript.PanteraScriptService.DeleteFieldReportCustomField(pjqSessionId, id[i], SettingSavedCallback, onScriptError);
					}
				}
				else {
					PanteraScript.PanteraScriptService.DeleteFieldReportCustomField(pjqSessionId, id, SettingSavedCallback, onScriptError);
				}
			}
			grid.deleteSelectedRows();
			ChangeSortByOrder(grid, 3);
			break;
		case fieldReportCustomFieldChoicesGrid:
			if (id.indexOf('new') == -1 && isAjaxDelete) {
				if (isMultiple) {
					for (i = 0; i < id.length; i++) {
						PanteraScript.PanteraScriptService.DeleteFieldReportCustomFieldChoice(pjqSessionId, id[i], SettingSavedCallback, onScriptError);
					}
				}
				else {
					PanteraScript.PanteraScriptService.DeleteFieldReportCustomFieldChoice(pjqSessionId, id, SettingSavedCallback, onScriptError);
				}
			}
			grid.deleteSelectedRows();
			ChangeSortByOrder(grid, 1);
			UpdateCustomFieldChoicesDefaultValueDropDown(fieldReportCustomFieldsGrid, fieldReportCustomFieldChoicesGrid, rowId);
			break;
		case submittalCustomFieldsGrid:
			if (id.indexOf('new') == -1) {
				if (isMultiple) {
					for (i = 0; i < id.length; i++) {
						PanteraScript.PanteraScriptService.DeleteSubmittalCustomField(pjqSessionId, id[i], SettingSavedCallback, onScriptError);
					}
				}
				else {
					PanteraScript.PanteraScriptService.DeleteSubmittalCustomField(pjqSessionId, id, SettingSavedCallback, onScriptError);
				}
			}
			grid.deleteSelectedRows();
			ChangeSortByOrder(grid, 3);
			break;
		case submittalCustomFieldChoicesGrid:
			if (id.indexOf('new') == -1 && isAjaxDelete) {
				if (isMultiple) {
					for (i = 0; i < id.length; i++) {
						PanteraScript.PanteraScriptService.DeleteSubmittalCustomFieldChoice(pjqSessionId, id[i], SettingSavedCallback, onScriptError);
					}
				}
				else {
					PanteraScript.PanteraScriptService.DeleteSubmittalCustomFieldChoice(pjqSessionId, id, SettingSavedCallback, onScriptError);
				}
			}
			grid.deleteSelectedRows();
			ChangeSortByOrder(grid, 1);
			UpdateCustomFieldChoicesDefaultValueDropDown(submittalCustomFieldsGrid, submittalCustomFieldChoicesGrid, rowId);
			break;
		case submittalItemTypesGrid:
			if (id.indexOf('new') == -1) {
				PanteraScript.PanteraScriptService.DeleteSubmittalItemType(pjqSessionId, id, SettingSavedCallback, onScriptError);
			}
			grid.deleteSelectedRows();
			ChangeSortByOrder(grid, 1);

			break;

		case punchlistCustomFieldsGrid:
			if (id.indexOf('new') == -1) {
				if (isMultiple) {
					for (i = 0; i < id.length; i++) {
						PanteraScript.PanteraScriptService.DeletePunchlistCustomField(pjqSessionId, id[i], SettingSavedCallback, onScriptError);
					}
				}
				else {
					PanteraScript.PanteraScriptService.DeletePunchlistCustomField(pjqSessionId, id, SettingSavedCallback, onScriptError);
				}
			}
			grid.deleteSelectedRows();
			ChangeSortByOrder(grid, 3);
			break;

		case punchlistCustomFieldChoicesGrid:
			if (id.indexOf('new') == -1 && isAjaxDelete) {
				if (isMultiple) {
					for (i = 0; i < id.length; i++) {
						PanteraScript.PanteraScriptService.DeletePunchlistCustomFieldChoice(pjqSessionId, id[i], SettingSavedCallback, onScriptError);
					}
				}
				else {
					PanteraScript.PanteraScriptService.DeletePunchlistCustomFieldChoice(pjqSessionId, id, SettingSavedCallback, onScriptError);
				}
			}
			grid.deleteSelectedRows();
			ChangeSortByOrder(grid, 1);
			UpdateCustomFieldChoicesDefaultValueDropDown(punchlistCustomFieldsGrid, punchlistCustomFieldChoicesGrid, rowId);
			break;

		case cftCustomFieldsGrid:
			if (id.indexOf('new') == -1) {
				if (isMultiple) {
					for (i = 0; i < id.length; i++) {
						PanteraScript.PanteraScriptService.DeleteCustomFieldTableCustomField(pjqSessionId, id[i], SettingSavedCallback, onScriptError);
					}
				}
				else {
					PanteraScript.PanteraScriptService.DeleteCustomFieldTableCustomField(pjqSessionId, id, SettingSavedCallback, onScriptError);
				}
			}
			grid.deleteSelectedRows();
			ChangeSortByOrder(grid, 4);
			break;
		case customFieldTableCustomFieldChoicesGrid:
			if (id.indexOf('new') == -1 && isAjaxDelete) {
				if (isMultiple) {
					for (i = 0; i < id.length; i++) {
						PanteraScript.PanteraScriptService.DeleteCustomFieldTableCustomFieldChoice(pjqSessionId, id[i], SettingSavedCallback, onScriptError);
					}
				}
				else {
					PanteraScript.PanteraScriptService.DeleteCustomFieldTableCustomFieldChoice(pjqSessionId, id, SettingSavedCallback, onScriptError);
				}
			}
			grid.deleteSelectedRows();
			ChangeSortByOrder(grid, 1);
			UpdateCustomFieldChoicesDefaultValueDropDown(cftCustomFieldsGrid, customFieldTableCustomFieldChoicesGrid, rowId);
			break;
		case userSeatsVendorGrid:
			if (isMultiple) {
				for (i = 0; i < id.length; i++) {
					userSeatsVendorGrid.deleteRow(id[i]);
				}
			}
			else
				userSeatsVendorGrid.deleteRow(id);
			PanteraScript.PanteraScriptService.DeleteUserSeats(pjqSessionId, rowId, null, onScriptError);
			UserSeatTotalsCalculate();
			break;
	}
}

function EditGridCell(grid, rowIndex, colIndex) {
	if (colIndex == null) {
		colIndex = 0;
	}
	if (rowIndex == null) {
		grid.selectCell(grid.getRowsNum() - 1, 0);
		setTimeout(function () {
			grid.editCell();
		}, 300)
	}
	else {
		grid.selectCell(rowIndex, colIndex);
		setTimeout(function () {
			grid.editCell();
		}, 300)
	}
}

function InitDirectoryGroupLinking() {
	if (settings.IsDirectoryEnabled && settings.IsDocumentClerk) {
		var buttonText = "Link Groups";
		var statusText = "Not Linked";
		var statusColor = "#FF2C2C"
		if (settings.HasGroupsLinked) {
			buttonText = "Unlink All Groups";
			statusText = "Linked";
			statusColor = "#2BCA00";
		}

		jQuery('#directoryGroupLinkButton').button().off().on('click', function () {
			if (settings.HasGroupsLinked)
				PanteraScript.PanteraScriptService.UnlinkPrivateGroupsFromDirectoryGroups(pjqSessionId, UnlinkPrivateGroupsFromDirectoryGroupsC, onScriptError);
			else
				InitDirectoryGroupLinkDialog();
		});
		jQuery('#directoryGroupLinkButton').find('.ui-button-text').html(buttonText);
		jQuery('#directoryGroupLinkStatus').html(statusText).css('color', statusColor);
		jQuery('#directoryGroupLinkContainer').show();
	}
}

var groupLinkFileUpload = null;
var fileUploadData = [];
var uploadCounter = 1;
var uploadErrorCounter = 0;

function InitDirectoryGroupLinkDialog() {
	jQuery('#directoryGroupLinkDialog').dialog({
		title: "Directory Group Link Upload",
		modal: true,
		resizable: false,
		width: 400,
		height: 'auto',
		open: function () {
			jQuery('#directoryGroupLinkSuccessCloseButton').button().off().on('click', function () {
				jQuery('#directoryGroupLinkDialog').dialog('close');
			});
			var myURL = PJQ.app.options.uploadUrl + '/DesktopModules/PanteraModuleGlobal/FileUpload/FileTransferHandler.ashx?folder=0&uid=' + settings.UploadContext + '&sid=' + pjqSessionId;
			groupLinkFileUpload = jQuery('#directoryGroupLinkUpload').fileupload();
			groupLinkFileUpload.fileupload('option', {
				autoUpload: true,
				url: myURL,
				dropZone: groupLinkFileUpload
			});
			groupLinkFileUpload.bind('fileuploadadded', function (e, data) {
				var isUploadError = false;
				var fileTypes = new RegExp('^.*\.(xls|xlsx)$');
				for (var ft = 0; ft < data.files.length; ft++) {
					if (!fileTypes.test(data.files[ft].name.toLowerCase())) {
						isUploadError = true;
						uploadErrorCounter++;
					}
					else {
						fileUploadData.push(data);
					}
				}
				e.preventDefault();
				if (data.originalFiles.length == uploadCounter && fileUploadData.length > 0) {
					uploadCounter = 1;
					AddDirectoryGroupLinkUploadDialog(e, isUploadError);
				}
				else if (fileUploadData.length == 0 && data.originalFiles.length == uploadCounter) {
					uploadCounter = 1;
					AddDirectoryGroupLinkUploadTypeErrorDialog(e);
				}
				else {
					uploadCounter++;
				}
			});
			groupLinkFileUpload.bind('fileuploadstop', function (e) {
				PanteraScript.PanteraScriptService.AddDirectoryGroupLinkUpload(pjqSessionId, settings.UploadContext, jQuery('#isCopyDirectoryGroups').prop('checked'), AddDirectoryGroupLinkUploadC, onScriptError);
				jQuery('#directoryGroupLinkDialogUploadContainer').hide();
				jQuery('#directoryGroupLinkDialogLoadingContainer').show();
			});
		},
		close: function () {
			jQuery('#directoryGroupLinkDialogSuccessContainer').hide();
			jQuery('#directoryGroupLinkDialogUploadContainer').show();
		}
	})
}

function AddDirectoryGroupLinkUploadC(response) {
	groupLinkFileUpload.find('.files').empty();
	groupLinkFileUpload.find('.dropnotice').show();

	var linkResult = jQuery.parseJSON(response);
	if (linkResult.Result) {
		jQuery('#directoryGroupLinkDialogLoadingContainer').hide();
		jQuery('#directoryGroupLinkDialogSuccessContainer').show();
		settings.HasGroupsLinked = true;
		InitDirectoryGroupLinking();
		GetAddressBookGroups('notnull');
	}
	else {
		jQuery('#directoryGroupLinkDialog').dialog('close');
		//dialog for error
		var errorReason = "";
		if (linkResult.ResultNote == 'nofiles') {
			errorReason = 'No files were uploaded.  Please try again.';
		}
		else if (linkResult.ResultNote == 'wrongheaders') {
			errorReason = 'The uploaded file is not formatted correctly.  Please ensure column 1 has a header of <span style="font-weight:bold;">DirectoryGroupName</span> and column 2 a header of <span style="font-weight:bold;">PrivateGroupName</span>.';
		}
		else if (linkResult.ResultNote == 'wrongfiletype' || linkResult.ResultNote == 'excelreadfail') {
			errorReason = 'The file uploaded is not a valid excel document.';
		}
		else if (linkResult.ResultNote == 'nogroups') {
			errorReason = 'There were no groups to be linked in the uploaded document.';
		}
		InitNotifyDialog(null, errorReason, "Upload Error");
	}
}

function UnlinkPrivateGroupsFromDirectoryGroupsC(response) {
	if (response) {
		settings.HasGroupsLinked = false;
		InitDirectoryGroupLinking();
	}
	else {
		//dialog for error
	}
}

function AddDirectoryGroupLinkUploadDialog(event, isUploadError) {
	jQuery('#confirmFileUploadDialog').dialog({
		title: "Confirm File Upload",
		modal: true,
		resizable: false,
		dialogClass: 'confirmFileUploadDialog',
		width: 400,
		open: function (e, ui) {
			jQuery('.confirmFileUploadText').empty();
			jQuery('.allowedFileTypesContainer').hide();
			if (fileUploadData.length > 1) {
				jQuery('.confirmFileUploadText').text('Are you sure you want to upload these files?  The group linking will happen upon confirmation of this dialog.');
			}
			else {
				jQuery('.confirmFileUploadText').text('Are you sure you want to upload this file?  The group linking will happen upon confirmation of this dialog.');
			}
			if (isUploadError) {
				jQuery('.confirmFileUploadText').append('<div><span style="font-weight:bold;">Note:</span> ' + uploadErrorCounter + ' uploaded files have disallowed file types.  These have been removed.</div>');
				jQuery('.allowedFileTypeListConfirmDialog').text('xls,xlsx');
				jQuery('.allowedFileTypesConfirmContainer').show();
				uploadErrorCounter = 0;
			}
		},
		buttons: [{
			text: "Yes",
			click: function () {
				for (var f = 0; f < fileUploadData.length; f++) {
					fileUploadData[f].submit();
				}
				fileUploadData = [];
				jQuery(this).dialog('destroy');
			}
		}, {
			text: "No",
			click: function () {
				jQuery(event.currentTarget).find('table tbody.files').empty();
				jQuery(event.currentTarget).find('.dropnotice').show();
				jQuery(this).dialog('destroy');
			}
		}]
	});
}

function AddDirectoryGroupLinkUploadTypeErrorDialog(event) {
	jQuery('#errorFileUploadDialog').dialog({
		title: "Confirm File Upload",
		modal: true,
		resizable: false,
		width: "auto",
		dialogClass: 'errorFileUploadDialog',
		width: 400,
		open: function (e, ui) {
			jQuery('.allowedFileTypeListErrorDialog').text('xls,xlsx');
		},
		buttons: [{
			text: "Ok",
			click: function () {
				fileUploadData = [];
				jQuery(event.currentTarget).find('table tbody.files').empty();
				jQuery(event.currentTarget).find('.dropnotice').show();
				jQuery(this).dialog('destroy');
			}
		}]
	});
}

var rfiCannedTextGridMenu = null;
var rfiCannedTextGrid = null;
var tbRFICannedTextGrid = null;

function GetRFISettings() {
	//get canned responses grid
	rfiCannedTextGridMenu = new dhtmlXMenuObject('gridMenu');
	rfiCannedTextGridMenu.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/");
	rfiCannedTextGridMenu.renderAsContextMenu();
	rfiCannedTextGridMenu.attachEvent("onClick", function (id, zoneId) {
		onGridMenuButtonClick(rfiCannedTextGrid, zoneId, id);
	});
	rfiCannedTextGridMenu.loadXMLString(menuXML);

	rfiCannedTextGrid = new dhtmlXGridObject('rfiCannedTextGrid');
	rfiCannedTextGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	rfiCannedTextGrid.setSkin(pjqGridTheme);
	rfiCannedTextGrid.enableAutoHeight(true);
	rfiCannedTextGrid.enableAutoWidth(true);
	rfiCannedTextGrid.enableContextMenu(rfiCannedTextGridMenu);
	rfiCannedTextGrid.load("/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=RFICannedText", "xml");
	rfiCannedTextGrid.init();

	rfiCannedTextGrid.attachEvent("onXLE", function (grid_obj, count) {

	});

	rfiCannedTextGrid.attachEvent("onRowDblClicked", function (rId, cInd) {
		CreateAddEditCustomFieldForm(rfiCannedTextGrid, 'edit', rId);
	});

	rfiCannedTextGrid.attachEvent("onBeforeContextMenu", function (id, ind, obj) {
		rfiCannedTextGrid.selectRowById(id, false, false, true);
		return true;
	});
	rfiCannedTextGrid.attachEvent("onRowSelect", function (id, ind) {
		EnableToolBarButton(tbRFICannedTextGrid, 'edit');
		EnableToolBarButton(tbRFICannedTextGrid, 'delete');
	});
	rfiCannedTextGrid.attachEvent("onDrop", function (id, ind, obj) {
		//ChangeSortByOrder(rfiCannedTextGrid, 4);
	});
	rfiCannedTextGrid.attachEvent("onRowAdded", function (rId, rObj, rXml) {

	});


	tbRFICannedTextGrid = new dhtmlXToolbarObject("rfiCannedTextToolbar");
	tbRFICannedTextGrid.setSkin("dhx_web");
	tbRFICannedTextGrid.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
	tbRFICannedTextGrid.addButton('add', 0, 'Add', "new.gif", "new_dis.gif");
	tbRFICannedTextGrid.addButton('edit', 1, 'Edit', "Edit.jpg", "EditD.jpg");
	tbRFICannedTextGrid.addButton('delete', 4, 'Delete', "Delete.png", "DeleteD.png");
	tbRFICannedTextGrid.disableItem('edit');
	tbRFICannedTextGrid.disableItem('delete');
	tbRFICannedTextGrid.attachEvent("onClick", function (id) {
		switch (id) {
			case 'add':
				initRFIEditGrid();
				break;
			case 'edit':
				PanteraScript.PanteraScriptService.GetRFICannedText(pjqSessionId, parseInt(rfiCannedTextGrid.getSelectedRowId()), initRFIEditGrid, onScriptError);
				break;
			case 'delete':
				CreateDialog(rfiCannedTextGrid, 'delete', "", rfiCannedTextGrid.getSelectedRowId());
				break;
		}
	})

	//get global notifications
	PJQ.app.session.user.fetchRFISettings(_.bind(function (settings) {
		GetRFINotificationPJQSettingsC(settings);
	}, this));

	//setting to enable sub side RFI


	jQuery(window).resize(function () {
		rfiCannedTextGrid.setSizes();
	});

	jQuery('#planroomRFISettingsTab').removeClass(pjqHidden);
}

var currentRFICannedTextId = 0;

function initRFIEditGrid(response) {
	var rfiCannedTextLabel = '';
	var rfiCannedTextContent = '';
	if (response != null) {
		var rfiCannedTextItem = jQuery.parseJSON(response);
		currentRFICannedTextId = rfiCannedTextItem.RequestForInformationCannedTextId;
		rfiCannedTextLabel = rfiCannedTextItem.TextLabel;
		rfiCannedTextContent = rfiCannedTextItem.TextContent;
	}

	jQuery('#rfiCannedTextEditDialog').dialog({
		dialogClass: "no-close",
		title: "Confirm Deletion",
		modal: true,
		width: 400,
		closeOnEscape: false,
		resizable: false,
		buttons: [{
			text: "Save",
			click: function () {
				PanteraScript.PanteraScriptService.AddUpdateRFICannedText(pjqSessionId, currentRFICannedTextId, jQuery('#rfiCannedTextLabel').val(), jQuery('#rfiCannedTextContent').val(), AddUpdateRFICannedTextC, onScriptError);
			}
		}, {
			text: "Cancel",
			click: function () {
				currentRFICannedTextId = 0;
				jQuery('#rfiCannedTextEditDialog').dialog('destroy');
			}
		}],
		open: function () {
			jQuery('#rfiCannedTextLabel').val(rfiCannedTextLabel);
			jQuery('#rfiCannedTextContent').val(rfiCannedTextContent);
		}
	})
}

function refreshRFIGrid() {
	rfiCannedTextGrid.clearAndLoad("/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=RFICannedText", "xml");
}

function AddUpdateRFICannedTextC(response) {
	refreshRFIGrid();
	currentRFICannedTextId = 0;
	jQuery('#rfiCannedTextEditDialog').dialog('destroy');
}

function GetRFINotificationPJQSettingsC(nSettings) {
	let container = null;
	jQuery('#rfiCommands').after('<div id="rfiNotificationSettings" style="display:none;"></div>');
	container = jQuery('#rfiNotificationSettings');
	container.append(jQuery('#rfiNotificationSettingsContainer').contents().clone());
	container.show();
	loadRFINotificationPJQSettingsUI(container, nSettings);
	container.find('input[type="checkbox"]').off('change');
	container.find('input[type="checkbox"]').on('change', function () {
		let settingsModel = new PJQ.models.rfi.Settings({
			CanSubCreate: container.find('.rfiIsAllowSubCreation').prop('checked'),
			CanAssigneeApproveComments: container.find('.rfiIsAllowAssigneeApproveComments').prop('checked'),
			CanAssigneeChangeStatus: false,
			IsNotifyOpened: container.find('.rfiNotificationOpen').prop('checked'),
			IsNotifyClosed: container.find('.rfiNotificationClose').prop('checked'),
			IsNotifyAssigneeAdded: container.find('.rfiNotificationAssignee').prop('checked'),
			IsNotifyDistributionAdded: container.find('.rfiNotificationDistribution').prop('checked'),
			IsNotifyAttachmentAdded: container.find('.rfiNotificationDocument').prop('checked'),
			IsNotifyResponseAdded: container.find('.rfiNotificationResponse').prop('checked'),
			IsNotifyDueDateChanged: container.find('.rfiNotificationDueDate').prop('checked'),
			IsNotifyBallInCourtChanged: container.find('.rfiNotificationBallInCourt').prop('checked'),
			IsNotifyOverdue: container.find('.rfiNotificationOverdue').prop('checked')
		});
		settingsModel.put({
			success: function () {
				loadRFINotificationSettingsUI(jQuery('#rfiNotificationSettings'), nSettings);
			}
		});
	})
}

function loadRFINotificationPJQSettingsUI(container, nSettings) {
	container.find('.rfiIsAllowSubCreation').prop('checked', nSettings.get('canSubCreate'));
	container.find('.rfiIsAllowAssigneeApproveComments').prop('checked', nSettings.get('canAssigneeApproveComments'));
	container.find('.rfiNotificationOpen').prop('checked', nSettings.get('isNotifyOpened'));
	container.find('.rfiNotificationClose').prop('checked', nSettings.get('isNotifyClosed'));
	container.find('.rfiNotificationAssignee').prop('checked', nSettings.get('isNotifyAssigneeAdded'));
	container.find('.rfiNotificationDistribution').prop('checked', nSettings.get('isNotifyDistributionAdded'));
	container.find('.rfiNotificationDocument').prop('checked', nSettings.get('isNotifyAttachmentAdded'));
	container.find('.rfiNotificationResponse').prop('checked', nSettings.get('isNotifyResponseAdded'));
	container.find('.rfiNotificationDueDate').prop('checked', nSettings.get('isNotifyDueDateChanged'));
	container.find('.rfiNotificationBallInCourt').prop('checked', nSettings.get('isNotifyBallInCourtChanged'));
	container.find('.rfiNotificationOverdue').prop('checked', nSettings.get('isNotifyOverdue'));
}

function itbChoicesChange(obj) {
	if (jQuery(obj).attr('id') == 'itbFax') {
		if (jQuery(obj).prop('checked')) {
			jQuery('#itbFaxNoEmail').prop('checked', false);
			jQuery('#itbFaxEmailFails').prop('checked', false);
		}
	}
	else if (jQuery(obj).attr('id') == 'itbFaxNoEmail' || jQuery(obj).attr('id') == 'itbFaxEmailFails') {
		if (jQuery(obj).prop('checked')) {
			jQuery('#itbFax').prop('checked', false);
		}
	}
}

// Punchlist stuff
var tbPunchlistCustomFields = null, punchlistCustomFieldsGrid = null, punchlistCustomFieldGridMenu = null;
var tbPunchlistItemTypes = null, punchlistItemTypesGrid = null, punchlistItemTypesGridMenu = null;

function GetPunchlistSettings() {

	punchlistCustomFieldGridMenu = new dhtmlXMenuObject('gridMenu');
	punchlistCustomFieldGridMenu.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/");
	punchlistCustomFieldGridMenu.renderAsContextMenu();
	punchlistCustomFieldGridMenu.attachEvent("onClick", function (id, zoneId) {
		onGridMenuButtonClick(punchlistCustomFieldsGrid, zoneId, id);
	});
	punchlistCustomFieldGridMenu.loadXMLString(menuXML);


	tbPunchlistCustomFields = new dhtmlXToolbarObject("toolbarPunchlistCustomFields");
	tbPunchlistCustomFields.setSkin("dhx_web");
	tbPunchlistCustomFields.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
	tbPunchlistCustomFields.addButton('add', 0, 'Add', "new.gif", "new_dis.gif");
	tbPunchlistCustomFields.addButton('edit', 1, 'Edit', "Edit.jpg", "EditD.jpg");
	tbPunchlistCustomFields.addButton('delete', 4, 'Delete', "Delete.png", "DeleteD.png");
	//tbPunchlistCustomFields.disableItem('add');
	tbPunchlistCustomFields.disableItem('edit');
	tbPunchlistCustomFields.disableItem('delete');
	tbPunchlistCustomFields.attachEvent("onClick", function (id) {
		switch (id) {
			case 'add':
				CreateAddEditCustomFieldForm(punchlistCustomFieldsGrid, 'add');
				break;
			case 'edit':
				CreateAddEditCustomFieldForm(punchlistCustomFieldsGrid, 'edit', punchlistCustomFieldsGrid.getSelectedRowId());
				break;
			case 'delete':
				var selRow = punchlistCustomFieldsGrid.getSelectedRowId();
				var punchlistCFCName;
				var deleteType;
				if (selRow.indexOf(',') == -1) {
					punchlistCFCName = punchlistCustomFieldsGrid.cells(selRow, 0).getValue();
					deleteType = 'delete';
				}
				else {
					deleteType = 'deleteMultiple';
					punchlistCFCName = null;
				}
				CreateDialog(punchlistCustomFieldsGrid, deleteType, punchlistCFCName, selRow);
				break;
		}
	});

	punchlistCustomFieldsGrid = new dhtmlXGridObject('gridPunchlistCustomFields');
	punchlistCustomFieldsGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	punchlistCustomFieldsGrid.setSkin(pjqGridTheme);
	punchlistCustomFieldsGrid.enableAutoHeight(true);
	punchlistCustomFieldsGrid.enableContextMenu(punchlistCustomFieldGridMenu);
	punchlistCustomFieldsGrid.load("/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=PunchlistCustomFields&customFieldid=0", "xml");
	punchlistCustomFieldsGrid.setHeader("Name,Type,Required,Sort");
	punchlistCustomFieldsGrid.setInitWidthsP("60,20,10,10");
	punchlistCustomFieldsGrid.setColAlign("center,center,center,center");
	punchlistCustomFieldsGrid.setColTypes("ro,ro,ch,edn");
	punchlistCustomFieldsGrid.setColSorting("na,na,na,na");
	punchlistCustomFieldsGrid.init();
	punchlistCustomFieldsGrid.attachEvent("onEditCell", function (stage, rId, cInd, nValue, oValue) {
		if (stage == 1) {
			UpdatePunchlistCustomField(false, true, rId);
		}
		return true;
	});
	punchlistCustomFieldsGrid.attachEvent("onRowDblClicked", function (rId, cInd) {
		CreateAddEditCustomFieldForm(punchlistCustomFieldsGrid, 'edit', rId);
	});
	punchlistCustomFieldsGrid.attachEvent("onXLE", function (grid_obj, count) {
		//jQuery('.projectCustomFieldsGridContainer').removeClass(pjqHidden);
		CheckCustomFieldGridRowsCount(punchlistCustomFieldsGrid);
	});

	punchlistCustomFieldsGrid.attachEvent("onBeforeContextMenu", function (id, ind, obj) {
		punchlistCustomFieldsGrid.selectRowById(id, false, false, true);
		return true;
	});
	punchlistCustomFieldsGrid.attachEvent("onRowSelect", function (id, ind) {
		EnableToolBarButton(tbPunchlistCustomFields, 'edit');
		EnableToolBarButton(tbPunchlistCustomFields, 'delete');
	});
	punchlistCustomFieldsGrid.attachEvent("onDrop", function (id, ind, obj) {
		ChangeSortByOrder(punchlistCustomFieldsGrid, 4);
		UpdatePunchlistCustomField(true, false);
	});
	punchlistCustomFieldsGrid.attachEvent("onRowAdded", function (rId, rObj, rXml) {
		CheckCustomFieldGridRowsCount(punchlistCustomFieldsGrid);
	});
	punchlistCustomFieldsGrid.attachEvent("onEnter", function (rid, cInd) {
		punchlistCustomFieldsGrid.editStop();
	});

	jQuery('#planroomPunchlistSettingsTab').removeClass(pjqHidden);
}

var punchlistItemTypeDialogId = null;

function CreateAddEditPunchlistItemTypeForm(id) {
	punchlistItemTypeDialogId = id;
	var maxRow = punchlistItemTypesGrid.getRowsNum();
	var dlgtitle = '';
	if (id) {
		jQuery('#punchlistItemTypeName').val(punchlistItemTypesGrid.cells(id, 0).getValue());
		jQuery('#punchlistItemTypeSortOrder').val(punchlistItemTypesGrid.cells(id, 1).getValue());
		dlgtitle = 'Edit Item Type';
	}
	else {
		maxRow++;
		jQuery('#punchlistItemTypeName').val('');
		jQuery('#punchlistItemTypeSortOrder').val(maxRow.toString());
		dlgtitle = 'Add Item Type';
	}

	jQuery('#punchlistItemTypeSortOrder').spinner({
		min: 1,
		max: maxRow
	});

	var dlg = jQuery('#punchlistItemTypeDialog').dialog({
		title: dlgtitle,
		modal: true,
		resizable: false,
		width: 600,
		buttons: [{
			text: "Save",
			click: function () {

				var errorCount = 0;
				if (!validator.element('#punchlistItemTypeName'))
					errorCount++;
				if (!validator.element('#punchlistItemTypeSortOrder'))
					errorCount++;

				if (errorCount > 0)
					return;

				if (punchlistItemTypeDialogId)
					PanteraScript.PanteraScriptService.ModifyPunchlistItemType(pjqSessionId, punchlistItemTypeDialogId, jQuery('#punchlistItemTypeName').val(), jQuery('#punchlistItemTypeSortOrder').val(), PunchlistItemTypeSaved, onScriptError);
				else
					PanteraScript.PanteraScriptService.AddPunchlistItemType(pjqSessionId, 'newRow', jQuery('#punchlistItemTypeName').val(), jQuery('#punchlistItemTypeSortOrder').val(), PunchlistItemTypeSaved, onScriptError);

				jQuery(this).dialog('destroy');
			}
		},
			{
				text: "Cancel",
				click: function () {
					jQuery(this).dialog('destroy');
				}
			}]
	});
	dlg.parent().appendTo($("Form[name='Form']"));


}

function PunchlistItemTypeSaved(response) {
	punchlistItemTypesGrid.clearAll();
	punchlistItemTypesGrid.load("/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=PunchlistItemTypes&customFieldid=0", "xml");
	DisableToolBarButton(tbPunchlistCustomFields, 'edit');
	DisableToolBarButton(tbPunchlistCustomFields, 'delete');

}

function PunchlistSavedCallback(response) {
	EnableToolBarButton(tbPunchlistCustomFields, 'add');
}

function AddPunchlistCustomField(currentCFFormType) {
	var newRowId = "newRow" + newRowCounter;
	var cfName = jQuery('#customFieldName').val();
	var cfSort = jQuery('#customFieldSortOrder').val();
	var cfDefVal = jQuery('#customFieldDefaultValue-' + currentCFFormType).val();
	var cfIsShowInList;
	var cfIsMultChoice = jQuery('#punchlistcfIsMultChoice').prop('checked');
	var cfIsRequired = jQuery('#punchlistcfRequired').prop('checked');
	var cfIsAdminEditOnly = !jQuery('#punchlistcfIsEditableNonAdmin').prop('checked');
	var cfIsVisibleNonAdmin = jQuery('#punchlistcfIsVisibleNonAdmin').prop('checked');
	var cfMinVal = 0;
	var cfMaxVal = 0;
	var cfDesc = '';
	if (currentCFFormType == 'CHOICE') {
		cfDefVal = '';
	}
	else if (currentCFFormType == 'INT') {
		if (jQuery('#customFieldMinVal').val().length > 0) {
			cfMinVal = jQuery('#customFieldMinVal').val();
		}
		if (jQuery('#customFieldMaxVal').val().length > 0) {
			cfMaxVal = jQuery('#customFieldMaxVal').val();
		}
	}
	else if (currentCFFormType == 'DATETIME') {
		cfDefVal = jQuery('#customFieldDefaultValue-DATETIMEDATE').val() + ' ' + jQuery('#customFieldDefaultValue-DATETIMETIME').val();
	}
	else if (currentCFFormType.indexOf('-LIST') != -1 || currentCFFormType == 'WEATHER') {
		cfDefVal = '';
	}
	PanteraScript.PanteraScriptService.AddPunchlistCustomField(pjqSessionId, newRowId, cfName, cfDesc, cfSort, currentCFFormType, cfDefVal, cfMinVal, cfMaxVal, cfIsMultChoice, cfIsRequired, cfIsAdminEditOnly, cfIsVisibleNonAdmin, PunchlistCustomFieldSaved, onScriptError);
	var newCFRowData = [cfName, currentCFFormType, boolToInt(cfIsRequired), cfSort];
	punchlistCustomFieldsGrid.addRow(newRowId, newCFRowData, parseInt(cfSort) - 1);
	punchlistCustomFieldsGrid.setUserData(newRowId, 'isAllowMultChoice', cfIsMultChoice.toString());
	punchlistCustomFieldsGrid.setUserData(newRowId, 'isAdminEditOnly', cfIsAdminEditOnly.toString());
	punchlistCustomFieldsGrid.setUserData(newRowId, 'isVisibleNonAdmin', cfIsVisibleNonAdmin.toString());
	punchlistCustomFieldsGrid.setUserData(newRowId, 'defaultValue', cfDefVal);
	punchlistCustomFieldsGrid.setUserData(newRowId, 'minValue', cfMinVal);
	punchlistCustomFieldsGrid.setUserData(newRowId, 'maxValue', cfMaxVal);
	ChangeSortByOrder(punchlistCustomFieldsGrid, 3);
}

function UpdatePunchlistCustomField(multiple, isInline, customFieldId, currentCustomFieldType) {
	var thisCFCId;
	var updateChoices = false;
	var cfName;
	var cfSort;
	var cfDefVal;
	var cfIsAllowMultChoice = false;
	var cfIsShowInList = false;
	var cfIsVisibleRSVP;
	var cfIsRequired;
	var cfMinVal;
	var cfMaxVal;
	var cfDesc;
	var cfIsAdminEditOnly;
	var cfIsVisibleNonAdmin;

	if (multiple) {
		for (var i = 0; i < punchlistCustomFieldsGrid.getRowsNum(); i++) {
			thisCFCId = punchlistCustomFieldsGrid.getRowId(i);
			cfcFormType = punchlistCustomFieldsGrid.cells2(i, 1).getValue();
			cfName = punchlistCustomFieldsGrid.cells2(i, 0).getValue();
			cfSort = punchlistCustomFieldsGrid.cells2(i, 3).getValue();
			cfIsAllowMultChoice = (punchlistCustomFieldsGrid.getUserData(thisCFCId, 'isAllowMultChoice').toLowerCase() === "true");
			cfIsAdminEditOnly = (punchlistCustomFieldsGrid.getUserData(thisCFCId, 'isAdminEditOnly').toLowerCase() === "true");
			cfIsVisibleNonAdmin = (punchlistCustomFieldsGrid.getUserData(thisCFCId, 'isVisibleNonAdmin').toLowerCase() === "true");
			cfDefVal = punchlistCustomFieldsGrid.getUserData(thisCFCId, 'defaultValue');
			cfIsRequired = GridCboxIsChecked(punchlistCustomFieldsGrid.cells2(i, 2).getValue());
			cfMinVal = 0;
			cfMaxVal = 0;
			cfDesc = '';
			/*
			if(cfName.indexOf('&') != -1){
				cfName = cfName.replace(ampRegex, '&amp;');
			}
			*/
			if (cfcFormType == 'INT') {
				cfMinVal = punchlistCustomFieldsGrid.getUserData(thisCFCId, 'minValue');
				cfMaxVal = punchlistCustomFieldsGrid.getUserData(thisCFCId, 'maxValue');
			}
			PanteraScript.PanteraScriptService.UpdatePunchlistCustomField(pjqSessionId, thisCFCId, cfName, cfDesc, cfSort, cfcFormType, cfDefVal, cfMinVal, cfMaxVal, cfIsAllowMultChoice, cfIsRequired, cfIsAdminEditOnly, cfIsVisibleNonAdmin, updateChoices, PunchlistCustomFieldSaved, onScriptError);
		}
	}
	else if (isInline) {
		cfcFormType = punchlistCustomFieldsGrid.cells(customFieldId, 1).getValue();
		cfName = punchlistCustomFieldsGrid.cells(customFieldId, 0).getValue();
		cfSort = punchlistCustomFieldsGrid.cells(customFieldId, 3).getValue();
		cfIsAllowMultChoice = (punchlistCustomFieldsGrid.getUserData(customFieldId, 'isAllowMultChoice').toLowerCase() === "true")
		cfIsAdminEditOnly = (punchlistCustomFieldsGrid.getUserData(customFieldId, 'isAdminEditOnly').toLowerCase() === "true");
		cfIsVisibleNonAdmin = (punchlistCustomFieldsGrid.getUserData(customFieldId, 'isVisibleNonAdmin').toLowerCase() === "true");
		cfDefVal = punchlistCustomFieldsGrid.getUserData(customFieldId, 'defaultValue');
		cfIsRequired = GridCboxIsChecked(punchlistCustomFieldsGrid.cells(customFieldId, 2).getValue());
		cfMinVal = 0;
		cfMaxVal = 0;
		cfDesc = '';
		/*
		if(cfName.indexOf('&') != -1){
			cfName = cfName.replace(ampRegex, '&amp;');
		}
		*/
		if (cfcFormType == 'INT') {
			cfMinVal = punchlistCustomFieldsGrid.getUserData(customFieldId, 'minValue');
			cfMaxVal = punchlistCustomFieldsGrid.getUserData(customFieldId, 'maxValue');
		}
		PanteraScript.PanteraScriptService.UpdatePunchlistCustomField(pjqSessionId, customFieldId, cfName, cfDesc, cfSort, cfcFormType, cfDefVal, cfMinVal, cfMaxVal, cfIsAllowMultChoice, cfIsRequired, cfIsAdminEditOnly, cfIsVisibleNonAdmin, updateChoices, PunchlistCustomFieldSaved, onScriptError);
	}
	else {
		updateChoices = true;
		cfName = jQuery('#customFieldName').val();
		cfSort = parseInt(jQuery('#customFieldSortOrder').val());
		cfDefVal = jQuery('#customFieldDefaultValue-' + currentCustomFieldType).val();
		cfDefVal = cfDefVal ? cfDefVal : '';
		cfIsRequired = jQuery('#punchlistcfRequired').prop('checked');
		cfIsAdminEditOnly = !jQuery('#punchlistcfIsEditableNonAdmin').prop('checked');
		cfIsVisibleNonAdmin = jQuery('#punchlistcfIsVisibleNonAdmin').prop('checked');

		cfMinVal = 0;
		cfMaxVal = 0;
		cfDesc = '';
		/*
		if(cfName.indexOf('&') != -1){
			cfName = cfName.replace(ampRegex, '&amp;');
		}
		*/
		if (currentCustomFieldType == 'CHOICE') {
			cfIsAllowMultChoice = jQuery('#punchlistcfIsMultChoice').prop('checked');
			cfDefVal = '';
		}
		else if (currentCustomFieldType == 'INT') {
			if (jQuery('#customFieldMinVal').val().length > 0) {
				cfMinVal = jQuery('#customFieldMinVal').val();
			}
			if (jQuery('#customFieldMaxVal').val().length > 0) {
				cfMaxVal = jQuery('#customFieldMaxVal').val();
			}
		}
		else if (currentCustomFieldType == 'DATETIME') {
			cfDefVal = jQuery('#customFieldDefaultValue-DATETIMEDATE').val() + ' ' + jQuery('#customFieldDefaultValue-DATETIMETIME').val();
		}
		else if (currentCustomFieldType == 'FILE') {
			cfIsAllowMultChoice = jQuery('#punchlistcfIsMultChoice').prop('checked');
		}

		PanteraScript.PanteraScriptService.UpdatePunchlistCustomField(pjqSessionId, customFieldId, cfName, cfDesc, cfSort, currentCustomFieldType, cfDefVal, cfMinVal, cfMaxVal, cfIsAllowMultChoice, cfIsRequired, cfIsAdminEditOnly, cfIsVisibleNonAdmin, updateChoices, PunchlistCustomFieldSaved, onScriptError);
		punchlistCustomFieldsGrid.cells(customFieldId, 0).setValue(cfName);
		punchlistCustomFieldsGrid.cells(customFieldId, 1).setValue(currentCustomFieldType);
		punchlistCustomFieldsGrid.cells(customFieldId, 2).setValue(cfIsRequired);
		ChangeRowSortOrder(punchlistCustomFieldsGrid, customFieldId, 3, cfSort);
		punchlistCustomFieldsGrid.cells(customFieldId, 3).setValue(cfSort);
		punchlistCustomFieldsGrid.setUserData(customFieldId, 'isAllowMultChoice', cfIsAllowMultChoice.toString());
		punchlistCustomFieldsGrid.setUserData(customFieldId, 'isAdminEditOnly', cfIsAdminEditOnly.toString());
		punchlistCustomFieldsGrid.setUserData(customFieldId, 'isVisibleNonAdmin', cfIsVisibleNonAdmin.toString());
		punchlistCustomFieldsGrid.setUserData(customFieldId, 'defaultValue', cfDefVal);
		punchlistCustomFieldsGrid.setUserData(customFieldId, 'minValue', cfMinVal);
		punchlistCustomFieldsGrid.setUserData(customFieldId, 'maxValue', cfMaxVal);
	}

}

function PunchlistCustomFieldSaved(response) {
	var punchlistCFResult = jQuery.parseJSON(response);
	var cfChoiceName;
	var cfChoiceSort;
	var cfId = punchlistCFResult.RowId;
	var currentCFRowId = punchlistCFResult.CurrentRowId;
	var currentCFCRowId;
	var currentRowIndex;
	if (currentCFRowId != null) {
		currentRowIndex = punchlistCustomFieldsGrid.getRowIndex(currentCFRowId);
		punchlistCustomFieldsGrid.setRowId(currentRowIndex, cfId);
	}
	if (punchlistCFResult.FieldType == 'CHOICE' && punchlistCFResult.UpdateChoices == true) {
		AddUpdatePunchlistCustomFieldChoices(cfId);
	}
	try {
		customFieldDialog.dialog('destroy');
	} catch (err) {
	}
}

var punchlistCustomFieldChoicesGrid, tbPunchlistCustomFieldChoicesGrid, punchlistCustomFieldChoicesGridMenu;

function GetPunchlistCustomFieldChoices(customFieldId) {
	punchlistCustomFieldChoicesGridMenu = new dhtmlXMenuObject('gridMenu');
	punchlistCustomFieldChoicesGridMenu.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/");
	punchlistCustomFieldChoicesGridMenu.renderAsContextMenu();
	punchlistCustomFieldChoicesGridMenu.attachEvent("onClick", function (id, zoneId) {
		onGridMenuButtonClick(punchlistCustomFieldChoicesGrid, zoneId, id);
	});
	punchlistCustomFieldChoicesGridMenu.loadXMLString(menuXML);

	punchlistCustomFieldChoicesGrid = new dhtmlXGridObject('punchlistCFChoicesGrid');
	punchlistCustomFieldChoicesGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	punchlistCustomFieldChoicesGrid.setSkin(pjqGridTheme);
	punchlistCustomFieldChoicesGrid.enableAutoHeight(true);
	punchlistCustomFieldChoicesGrid.enableDragAndDrop(true);
	punchlistCustomFieldChoicesGrid.setDragBehavior('complex');
	punchlistCustomFieldChoicesGrid.enableMultiselect(true);
	punchlistCustomFieldChoicesGrid.enableContextMenu(punchlistCustomFieldChoicesGridMenu);
	punchlistCustomFieldChoicesGrid.load("/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=PunchlistCustomFieldChoices&customFieldid=" + customFieldId, "xml");
	punchlistCustomFieldChoicesGrid.init();
	punchlistCustomFieldChoicesGrid.attachEvent("onRowSelect", function (id, ind) {
		EnableToolBarButton(tbPunchlistCustomFieldChoicesGrid, 'delete');
	});
	punchlistCustomFieldChoicesGrid.attachEvent("onXLE", function (grid_obj, count) {
		jQuery('#punchlistCFChoicesGridContainer').removeClass(pjqHidden);
		UpdateCustomFieldChoicesDefaultValueDropDown(punchlistCustomFieldsGrid, punchlistCustomFieldChoicesGrid, customFieldId);
	});
	punchlistCustomFieldChoicesGrid.attachEvent("onEditCell", function (stage, rId, cInd, nValue, oValue) {
		if (stage == 2) {
			return UpdateCustomFieldChoicesDefaultValueDropDown(punchlistCustomFieldsGrid, punchlistCustomFieldChoicesGrid, customFieldId);
		}
	});
	punchlistCustomFieldChoicesGrid.attachEvent("onBeforeContextMenu", function (id, ind, obj) {
		punchlistCustomFieldChoicesGrid.selectRowById(id, false, false, true);
		return true;
	});
	punchlistCustomFieldChoicesGrid.attachEvent("onDrop", function (id, ind, obj) {
		ChangeSortByOrder(punchlistCustomFieldChoicesGrid, 1);
	});
	punchlistCustomFieldChoicesGrid.attachEvent("onEnter", function (rid, cInd) {
		punchlistCustomFieldChoicesGrid.editStop();
	});


	tbPunchlistCustomFieldChoicesGrid = new dhtmlXToolbarObject("punchlistCFChoicesToolbar");
	tbPunchlistCustomFieldChoicesGrid.setSkin("dhx_web");
	tbPunchlistCustomFieldChoicesGrid.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
	tbPunchlistCustomFieldChoicesGrid.addButton('add', 0, 'Add', "new.gif", "new_dis.gif");
	tbPunchlistCustomFieldChoicesGrid.addButton('delete', 4, 'Delete', "Delete.png", "DeleteD.png");
	tbPunchlistCustomFieldChoicesGrid.disableItem('delete');
	tbPunchlistCustomFieldChoicesGrid.attachEvent("onClick", function (id) {
		switch (id) {
			case 'add':
				AddNewGridRow(punchlistCustomFieldChoicesGrid);
				break;
			case 'delete':
				var selRow = punchlistCustomFieldChoicesGrid.getSelectedRowId();
				var punchlistCFCName;
				var deleteType;
				if (selRow.indexOf(',') == -1 && selRow.indexOf('newRow') == -1) {
					cfChoiceDeleteArray.push(selRow);
				}
				else {
					tempCFArray = selRow.split(',');
					for (i = 0; i < tempCFArray.length; i++) {
						if (tempCFArray[i].indexOf('newRow') == -1) {
							cfChoiceDeleteArray.push(tempCFArray[i]);
						}
					}
				}
				DeleteGridRow(punchlistCustomFieldChoicesGrid, selRow, false);
				break;
		}
	});
}

function AddUpdatePunchlistCustomFieldChoices(customFieldId) {
	for (i = 0; i < punchlistCustomFieldChoicesGrid.getRowsNum(); i++) {
		currentCFCRowId = punchlistCustomFieldChoicesGrid.getRowId(i);
		cfChoiceName = punchlistCustomFieldChoicesGrid.cells2(i, 0).getValue();
		cfChoiceSort = punchlistCustomFieldChoicesGrid.cells2(i, 1).getValue();
		/*
		if(cfChoiceName.indexOf('&') != -1){
			cfChoiceName = cfChoiceName.replace(ampRegex, '&amp;');
		}
		*/
		if (currentCFCRowId.indexOf('new') != -1) {
			PanteraScript.PanteraScriptService.AddPunchlistCustomFieldChoice(pjqSessionId, customFieldId, currentCFCRowId, cfChoiceName, cfChoiceSort, PunchlistCustomFieldChoiceSaved, onScriptError);
		}
		else {
			PanteraScript.PanteraScriptService.UpdatePunchlistCustomFieldChoice(pjqSessionId, parseInt(customFieldId), parseInt(currentCFCRowId), cfChoiceName, parseInt(cfChoiceSort), PunchlistCustomFieldChoiceSaved, onScriptError);
		}
	}
	punchlistCustomFieldChoicesGrid.destructor();
	ResetCustomFieldForm();
}

function PunchlistCustomFieldChoiceSaved(response) {
	var punchlistCFCResult = jQuery.parseJSON(response);
	var defaultValueId = jQuery('#customFieldDefaultValue-CHOICE').val();
	if (defaultValueId == punchlistCFCResult.CurrentRowId) {
		punchlistCustomFieldsGrid.setUserData(punchlistCFCResult.CustomFieldId, 'defaultValue', punchlistCFCResult.RowId);
		PanteraScript.PanteraScriptService.UpdatePunchlistCustomFieldDefaultValue(pjqSessionId, punchlistCFCResult.CustomFieldId, punchlistCFCResult.RowId, SettingSavedCallback, onScriptError);
	}
}


// Field Report stuff
var tbFieldReports = null,
	fieldReportsGrid = null,
	tbFieldReportCustomFields = null,
	fieldReportCustomFieldsGrid = null,
	lastFieldReportId = null,
	fieldReportCustomFieldGridMenu = null;

function GetFieldReportSettings() {
	tbFieldReports = new dhtmlXToolbarObject("toolbarFieldReports");
	tbFieldReports.setSkin("dhx_web");
	tbFieldReports.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
	tbFieldReports.addButton('add', 0, 'Add', "new.gif", "new_dis.gif");
	//tbFieldReports.addButton('edit', 1, 'Edit', "Edit.jpg", "EditD.jpg");
	tbFieldReports.addButton('delete', 4, 'Delete', "Delete.png", "DeleteD.png");
	//tbFieldReports.disableItem('edit');
	tbFieldReports.disableItem('delete');
	tbFieldReports.attachEvent("onClick", function (id) {
		switch (id) {
			case 'add':
				DisableToolBarButton(tbFieldReportCustomFields, 'add');
				DisableToolBarButton(tbFieldReportCustomFields, 'edit');
				DisableToolBarButton(tbFieldReportCustomFields, 'delete');
				fieldReportCustomFieldsGrid.clearAll();
				AddNewGridRow(fieldReportsGrid);
				break;
			case 'delete':
				var fieldReportSelRow = fieldReportsGrid.getSelectedRowId();
				var fieldReportName = fieldReportsGrid.cells(fieldReportSelRow, 0).getValue();
				CreateDialog(fieldReportsGrid, 'delete', fieldReportName, fieldReportSelRow);
				break;
		}
	});

	fieldReportsGrid = new dhtmlXGridObject('gridFieldReports');
	fieldReportsGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	fieldReportsGrid.setSkin(pjqGridTheme);
	fieldReportsGrid.enableAutoHeight(true);
	//fieldReportsGrid.enableContextMenu(projectStatusGridMenu);
	fieldReportsGrid.init();
	fieldReportsGrid.attachEvent("onRowSelect", function (id, ind) {
		EnableToolBarButton(tbFieldReports, 'delete');
		fieldReportCustomFieldsGrid.clearAll();
		if (typeof id != 'number' && id.indexOf('newRow') != -1) {
			DisableToolBarButton(tbFieldReportCustomFields, 'add');
			DisableToolBarButton(tbFieldReportCustomFields, 'edit');
			DisableToolBarButton(tbFieldReportCustomFields, 'copy');
			DisableToolBarButton(tbFieldReportCustomFields, 'delete');
		}
		else {
			EnableToolBarButton(tbFieldReportCustomFields, 'add');
			DisableToolBarButton(tbFieldReportCustomFields, 'edit');
			DisableToolBarButton(tbFieldReportCustomFields, 'copy');
			DisableToolBarButton(tbFieldReportCustomFields, 'delete');
			fieldReportCustomFieldsGrid.load(fieldReportGridXMLPath(id), 'xml');
		}

	});
	fieldReportsGrid.attachEvent("onEnter", function (rid, cInd) {
		fieldReportsGrid.editStop();
	});
	fieldReportsGrid.attachEvent("onEditCell", function (stage, rId, cInd, nValue, oValue) {
		if (stage == 2) {
			var fieldReportName = fieldReportsGrid.cells(rId, 0).getValue();
			var fieldReportNotes = fieldReportsGrid.cells(rId, 1).getValue();
			var fieldReportIsActive = fieldReportsGrid.cells(rId, 2).isChecked();
			lastFieldReportId = rId;
			if (isNaN(rId)) {
				PanteraScript.PanteraScriptService.AddFieldReportDefinition(pjqSessionId, fieldReportName, fieldReportNotes, fieldReportIsActive, FieldReportSavedCallback, onScriptError);
			}
			else {
				PanteraScript.PanteraScriptService.ModifyFieldReportDefinition(pjqSessionId, rId, fieldReportName, fieldReportNotes, fieldReportIsActive, SettingSavedCallback, onScriptError);
			}
		}
		return true
	});
	fieldReportsGrid.attachEvent("onCheck", function (rId, cInd, state) {
		var fieldReportName = fieldReportsGrid.cells(rId, 0).getValue();
		var fieldReportNotes = fieldReportsGrid.cells(rId, 1).getValue();
		var fieldReportIsActive = fieldReportsGrid.cells(rId, 2).isChecked();
		lastFieldReportId = rId;
		if (isNaN(rId)) {
			PanteraScript.PanteraScriptService.AddFieldReportDefinition(pjqSessionId, fieldReportName, fieldReportNotes, fieldReportIsActive, FieldReportSavedCallback, onScriptError);
		}
		else {
			PanteraScript.PanteraScriptService.ModifyFieldReportDefinition(pjqSessionId, rId, fieldReportName, fieldReportNotes, fieldReportIsActive, SettingSavedCallback, onScriptError);
		}
	});

	fieldReportsGrid.load("/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=FieldReportList&customFieldid=0", "xml");

	fieldReportCustomFieldGridMenu = new dhtmlXMenuObject('gridMenu');
	fieldReportCustomFieldGridMenu.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/");
	fieldReportCustomFieldGridMenu.renderAsContextMenu();
	fieldReportCustomFieldGridMenu.attachEvent("onClick", function (id, zoneId) {
		onGridMenuButtonClick(fieldReportCustomFieldsGrid, zoneId, id);
	});
	fieldReportCustomFieldGridMenu.loadXMLString(menuXML);

	tbFieldReportCustomFields = new dhtmlXToolbarObject("toolbarFieldReportCustomFields");
	tbFieldReportCustomFields.setSkin("dhx_web");
	tbFieldReportCustomFields.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
	tbFieldReportCustomFields.addButton('add', 0, 'Add', "new.gif", "new_dis.gif");
	tbFieldReportCustomFields.addButton('edit', 1, 'Edit', "edit.jpg", "editd.jpg");
	tbFieldReportCustomFields.addButton('copy', 4, 'Copy', "copy.gif", "copy_dis.gif");
	tbFieldReportCustomFields.addButton('delete', 4, 'Delete', "delete.png", "deleted.png");
	DisableToolBarButton(tbFieldReportCustomFields, 'add');
	DisableToolBarButton(tbFieldReportCustomFields, 'edit');
	DisableToolBarButton(tbFieldReportCustomFields, 'copy');
	DisableToolBarButton(tbFieldReportCustomFields, 'delete');
	tbFieldReportCustomFields.attachEvent("onClick", function (id) {
		switch (id) {
			case 'add':
				CreateAddEditCustomFieldForm(fieldReportCustomFieldsGrid, 'add');
				break;
			case 'edit':
				CreateAddEditCustomFieldForm(fieldReportCustomFieldsGrid, 'edit', fieldReportCustomFieldsGrid.getSelectedRowId());
				break;
			case 'copy':
				CopySelectedCustomField(fieldReportCustomFieldsGrid);
				break;
			case 'delete':
				var selRow = fieldReportCustomFieldsGrid.getSelectedRowId();
				var fieldReportCFCName;
				var deleteType;
				if (selRow.indexOf(',') == -1) {
					fieldReportCFCName = fieldReportCustomFieldsGrid.cells(selRow, 0).getValue();
					deleteType = 'delete';
				}
				else {
					deleteType = 'deleteMultiple';
					fieldReportCFCName = null;
				}
				CreateDialog(fieldReportCustomFieldsGrid, deleteType, fieldReportCFCName, selRow);
				break;
		}
	});

	fieldReportCustomFieldsGrid = new dhtmlXGridObject('gridFieldReportCustomFields');
	fieldReportCustomFieldsGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	fieldReportCustomFieldsGrid.setSkin(pjqGridTheme);
	fieldReportCustomFieldsGrid.enableAutoHeight(true);
	fieldReportCustomFieldsGrid.enableContextMenu(fieldReportCustomFieldGridMenu);
	//fieldReportCustomFieldsGrid.load("/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=ProjStatusList&customFieldid=0", "xml");
	fieldReportCustomFieldsGrid.setHeader("Name,Type,Required,Sort");
	fieldReportCustomFieldsGrid.setInitWidthsP("60,20,10,10");
	fieldReportCustomFieldsGrid.setColAlign("center,center,center,center");
	fieldReportCustomFieldsGrid.setColTypes("ro,ro,ch,edn");
	fieldReportCustomFieldsGrid.setColSorting("na,na,na,na");
	fieldReportCustomFieldsGrid.init();
	fieldReportCustomFieldsGrid.attachEvent("onEditCell", function (stage, rId, cInd, nValue, oValue) {
		if (stage == 1) {
			UpdateFieldReportCustomField(false, true, rId);
		}
		return true;
	});
	fieldReportCustomFieldsGrid.attachEvent("onRowDblClicked", function (rId, cInd) {
		CreateAddEditCustomFieldForm(fieldReportCustomFieldsGrid, 'edit', rId);
	});
	fieldReportCustomFieldsGrid.attachEvent("onXLE", function (grid_obj, count) {
		//jQuery('.projectCustomFieldsGridContainer').removeClass(pjqHidden);
		CheckCustomFieldGridRowsCount(fieldReportCustomFieldsGrid);
	});

	fieldReportCustomFieldsGrid.attachEvent("onBeforeContextMenu", function (id, ind, obj) {
		fieldReportCustomFieldsGrid.selectRowById(id, false, false, true);
		return true;
	});
	fieldReportCustomFieldsGrid.attachEvent("onRowSelect", function (id, ind) {
		EnableToolBarButton(tbFieldReportCustomFields, 'edit');
		EnableToolBarButton(tbFieldReportCustomFields, 'copy');
		EnableToolBarButton(tbFieldReportCustomFields, 'delete');
	});
	fieldReportCustomFieldsGrid.attachEvent("onDrop", function (id, ind, obj) {
		ChangeSortByOrder(fieldReportCustomFieldsGrid, 4);
		UpdateFieldReportCustomField(true, false);
	});
	fieldReportCustomFieldsGrid.attachEvent("onRowAdded", function (rId, rObj, rXml) {
		CheckCustomFieldGridRowsCount(fieldReportCustomFieldsGrid);
	});
	fieldReportCustomFieldsGrid.attachEvent("onEnter", function (rid, cInd) {
		fieldReportCustomFieldsGrid.editStop();
	});

	jQuery('#planroomFieldReportSettingsTab').removeClass(pjqHidden);
}

var currentFieldReportId = 0;

function fieldReportGridXMLPath(id) {
	if (id != null)
		currentFieldReportId = id;
	return "/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=FieldReportCustomFields&customFieldid=" + currentFieldReportId;
}

function refreshFieldReportCustomFieldGrid(callback) {
	fieldReportCustomFieldsGrid.clearAndLoad(fieldReportGridXMLPath(), callback, 'xml');
}

function CopySelectedCustomField(grid) {
	var customFieldId = parseInt(grid.getSelectedRowId());
	if (customFieldId > 0) {
		switch (grid) {
			case fieldReportCustomFieldsGrid:
				PanteraScript.PanteraScriptService.CopyCustomField(customFieldId, 'fieldreport', function (customFieldId) {
					refreshFieldReportCustomFieldGrid(function () {
						CreateAddEditCustomFieldForm(grid, 'edit', customFieldId);
					});
				}, onScriptError);
				break;
		}
	}
	else {
		//todo: show error that there is no selected custom field
	}
}

function FieldReportSavedCallback(response) {
	var newReportId = parseInt(response);
	fieldReportsGrid.changeRowId(lastFieldReportId, newReportId);
	lastFieldReportId = newReportId;
	fieldReportCustomFieldsGrid.load(fieldReportGridXMLPath(lastFieldReportId), 'xml');
	EnableToolBarButton(tbFieldReportCustomFields, 'add');
}

function AddFieldReportCustomField(currentCFFormType) {
	var fieldReportId = parseInt(fieldReportsGrid.getSelectedRowId());
	var newRowId = "newRow" + newRowCounter;
	var cfName = jQuery('#customFieldName').val();
	var cfDesc = jQuery('#customFieldCategory').val();
	var cfSort = jQuery('#customFieldSortOrder').val();
	var cfDefVal = jQuery('#customFieldDefaultValue-' + currentCFFormType).val();
	var cfIsShowInList;
	var cfIsMultChoice = jQuery('#fieldReportcfIsMultChoice').prop('checked');
	//var cfIsVisibleRSVP = jQuery('#fieldReportcfVisible').prop('checked');
	var cfIsRequired = jQuery('#fieldReportcfRequired').prop('checked');
	var cfMinVal = 0;
	var cfMaxVal = 0;
	customFieldConstraintAddList = [];

	if (currentCFFormType == 'CHOICE') {
		cfDefVal = '';
	}
	else if (currentCFFormType == 'INT') {
		if (jQuery('#customFieldMinVal').val().length > 0) {
			cfMinVal = jQuery('#customFieldMinVal').val();
		}
		if (jQuery('#customFieldMaxVal').val().length > 0) {
			cfMaxVal = jQuery('#customFieldMaxVal').val();
		}
	}
	else if (currentCFFormType == 'DATETIME') {
		cfDefVal = jQuery('#customFieldDefaultValue-DATETIMEDATE').val() + ' ' + jQuery('#customFieldDefaultValue-DATETIMETIME').val();
	}
	else if (currentCFFormType.indexOf('-LIST') != -1 || currentCFFormType == 'WEATHER' || currentCFFormType == 'CUSTOMFIELDTABLE') {
		cfDefVal = '';
	}

	for (var i = 0; i < customFieldConstraintsGrid.getRowsNum(); i++) {
		var rowId = customFieldConstraintsGrid.getRowId(i);
		var rowData = rowId.toString() + '|' + customFieldConstraintsGrid.cells(rowId, 0).getValue() + '|' + customFieldConstraintsGrid.cells(rowId, 1).getValue();
		customFieldConstraintAddList.push(rowData);
	}

	var hideRows = '';
	jQuery('[id^=vendorlist_show_]').each(function () {
		if (!jQuery(this).prop('checked')) {
			if (hideRows.length > 0)
				hideRows += '|';
			hideRows += jQuery(this).attr('id').replace('vendorlist_show_', '');
		}
	})

	PanteraScript.PanteraScriptService.AddFieldReportCustomField(pjqSessionId, newRowId, fieldReportId, cfName, cfDesc, cfSort, currentCFFormType, cfDefVal, cfMinVal, cfMaxVal, cfIsMultChoice, cfIsRequired, customFieldConstraintAddList.join(','), hideRows, FieldReportCustomFieldSaved, onScriptError);
	var newCFRowData = [cfName, cfDesc, currentCFFormType, boolToInt(cfIsRequired), cfSort];
	fieldReportCustomFieldsGrid.addRow(newRowId, newCFRowData, parseInt(cfSort) - 1);
	fieldReportCustomFieldsGrid.setUserData(newRowId, 'isAllowMultChoice', cfIsMultChoice.toString());
	fieldReportCustomFieldsGrid.setUserData(newRowId, 'defaultValue', cfDefVal);
	fieldReportCustomFieldsGrid.setUserData(newRowId, 'minValue', cfMinVal);
	fieldReportCustomFieldsGrid.setUserData(newRowId, 'maxValue', cfMaxVal);
	fieldReportCustomFieldsGrid.setUserData(newRowId, 'hideRows', hideRows);
	ChangeSortByOrder(fieldReportCustomFieldsGrid, 4);
}

var customFieldConstraintAddList = [], customFieldConstraintDeleteList = [];

function UpdateFieldReportCustomField(multiple, isInline, customFieldId, currentCustomFieldType) {
	var thisCFCId;
	var updateChoices = false;
	var cfName;
	var cfSort;
	var cfDefVal;
	var cfIsAllowMultChoice = false;
	var cfIsShowInList = false;
	var cfIsVisibleRSVP;
	var cfIsRequired;
	var cfMinVal;
	var cfMaxVal;
	var cfDesc;
	var hideRows = '';
	customFieldConstraintAddList = [];

	if (multiple) {
		for (var i = 0; i < fieldReportCustomFieldsGrid.getRowsNum(); i++) {
			thisCFCId = fieldReportCustomFieldsGrid.getRowId(i);
			cfName = fieldReportCustomFieldsGrid.cells2(i, 0).getValue();
			cfDesc = fieldReportCustomFieldsGrid.cells2(i, 1).getValue();
			cfcFormType = fieldReportCustomFieldsGrid.cells2(i, 2).getValue();
			cfIsRequired = GridCboxIsChecked(fieldReportCustomFieldsGrid.cells2(i, 3).getValue());
			cfSort = fieldReportCustomFieldsGrid.cells2(i, 4).getValue();
			cfIsAllowMultChoice = (fieldReportCustomFieldsGrid.getUserData(thisCFCId, 'isAllowMultChoice').toLowerCase() === "true");
			cfDefVal = fieldReportCustomFieldsGrid.getUserData(thisCFCId, 'defaultValue');
			hideRows = fieldReportCustomFieldsGrid.getUserData(thisCFCId, 'hideRows');
			cfMinVal = 0;
			cfMaxVal = 0;
			if (cfcFormType == 'INT') {
				cfMinVal = fieldReportCustomFieldsGrid.getUserData(thisCFCId, 'minValue');
				cfMaxVal = fieldReportCustomFieldsGrid.getUserData(thisCFCId, 'maxValue');
			}
			PanteraScript.PanteraScriptService.UpdateFieldReportCustomField(pjqSessionId, thisCFCId, cfName, cfDesc, cfSort, cfcFormType, cfDefVal, cfMinVal, cfMaxVal, cfIsAllowMultChoice, cfIsRequired, updateChoices, '', '', hideRows, FieldReportCustomFieldSaved, onScriptError);
		}
	}
	else if (isInline) {
		cfName = fieldReportCustomFieldsGrid.cells(customFieldId, 0).getValue();
		cfDesc = fieldReportCustomFieldsGrid.cells(customFieldId, 1).getValue();
		cfcFormType = fieldReportCustomFieldsGrid.cells(customFieldId, 2).getValue();
		cfIsRequired = GridCboxIsChecked(fieldReportCustomFieldsGrid.cells(customFieldId, 3).getValue());
		cfSort = fieldReportCustomFieldsGrid.cells(customFieldId, 4).getValue();
		cfIsAllowMultChoice = (fieldReportCustomFieldsGrid.getUserData(customFieldId, 'isAllowMultChoice').toLowerCase() === "true")
		cfDefVal = fieldReportCustomFieldsGrid.getUserData(customFieldId, 'defaultValue');
		hideRows = fieldReportCustomFieldsGrid.getUserData(customFieldId, 'hideRows');
		cfMinVal = 0;
		cfMaxVal = 0;
		/*
		if(cfName.indexOf('&') != -1){
			cfName = cfName.replace(ampRegex, '&amp;');
		}
		*/
		if (cfcFormType == 'INT') {
			cfMinVal = fieldReportCustomFieldsGrid.getUserData(customFieldId, 'minValue');
			cfMaxVal = fieldReportCustomFieldsGrid.getUserData(customFieldId, 'maxValue');
		}
		PanteraScript.PanteraScriptService.UpdateFieldReportCustomField(pjqSessionId, customFieldId, cfName, cfDesc, cfSort, cfcFormType, cfDefVal, cfMinVal, cfMaxVal, cfIsAllowMultChoice, cfIsRequired, updateChoices, '', '', hideRows, FieldReportCustomFieldSaved, onScriptError);
	}
	else {
		updateChoices = true;
		cfName = jQuery('#customFieldName').val();
		cfDesc = jQuery('#customFieldCategory').val();
		cfSort = parseInt(jQuery('#customFieldSortOrder').val());
		cfDefVal = jQuery('#customFieldDefaultValue-' + currentCustomFieldType).val();
		cfDefVal = cfDefVal ? cfDefVal : '';
		cfIsRequired = jQuery('#fieldReportcfRequired').prop('checked');
		cfMinVal = 0;
		cfMaxVal = 0;
		/*
		if(cfName.indexOf('&') != -1){
			cfName = cfName.replace(ampRegex, '&amp;');
		}
		*/
		if (currentCustomFieldType == 'CHOICE') {
			cfIsAllowMultChoice = jQuery('#fieldReportcfIsMultChoice').prop('checked');
			cfDefVal = '';
		}
		else if (currentCustomFieldType == 'INT') {
			if (jQuery('#customFieldMinVal').val().length > 0) {
				cfMinVal = jQuery('#customFieldMinVal').val();
			}
			if (jQuery('#customFieldMaxVal').val().length > 0) {
				cfMaxVal = jQuery('#customFieldMaxVal').val();
			}
		}
		else if (currentCustomFieldType == 'DATETIME') {
			cfDefVal = jQuery('#customFieldDefaultValue-DATETIMEDATE').val() + ' ' + jQuery('#customFieldDefaultValue-DATETIMETIME').val();
		}
		else if (currentCustomFieldType == 'FILE') {
			cfIsAllowMultChoice = jQuery('#fieldReportcfIsMultChoice').prop('checked');
		}

		for (var i = 0; i < customFieldConstraintsGrid.getRowsNum(); i++) {
			var rowId = customFieldConstraintsGrid.getRowId(i);
			var rowData = rowId.toString() + '|' + customFieldConstraintsGrid.cells(rowId, 0).getValue() + '|' + customFieldConstraintsGrid.cells(rowId, 1).getValue();
			customFieldConstraintAddList.push(rowData);
		}

		jQuery('[id^=vendorlist_show_]').each(function () {
			if (!jQuery(this).prop('checked')) {
				if (hideRows.length > 0)
					hideRows += '|';
				hideRows += jQuery(this).attr('id').replace('vendorlist_show_', '');
			}
		})

		PanteraScript.PanteraScriptService.UpdateFieldReportCustomField(pjqSessionId, customFieldId, cfName, cfDesc, cfSort, currentCustomFieldType, cfDefVal, cfMinVal, cfMaxVal, cfIsAllowMultChoice, cfIsRequired, updateChoices, customFieldConstraintAddList.join(','), customFieldConstraintDeleteList.join(','), hideRows, FieldReportCustomFieldSaved, onScriptError);
		fieldReportCustomFieldsGrid.cells(customFieldId, 0).setValue(cfName);
		fieldReportCustomFieldsGrid.cells(customFieldId, 1).setValue(cfDesc);
		fieldReportCustomFieldsGrid.cells(customFieldId, 2).setValue(currentCustomFieldType);
		fieldReportCustomFieldsGrid.cells(customFieldId, 3).setValue(cfIsRequired);
		fieldReportCustomFieldsGrid.cells(customFieldId, 4).setValue(cfSort);
		ChangeRowSortOrder(fieldReportCustomFieldsGrid, customFieldId, 4, cfSort);
		fieldReportCustomFieldsGrid.setUserData(customFieldId, 'isAllowMultChoice', cfIsAllowMultChoice.toString());
		fieldReportCustomFieldsGrid.setUserData(customFieldId, 'defaultValue', cfDefVal);
		fieldReportCustomFieldsGrid.setUserData(customFieldId, 'minValue', cfMinVal);
		fieldReportCustomFieldsGrid.setUserData(customFieldId, 'maxValue', cfMaxVal);
		fieldReportCustomFieldsGrid.setUserData(customFieldId, 'hideRows', hideRows);
	}

}

function FieldReportCustomFieldSaved(response) {
	var fieldReportCFResult = jQuery.parseJSON(response);
	var cfChoiceName;
	var cfChoiceSort;
	var cfId = fieldReportCFResult.RowId;
	var currentCFRowId = fieldReportCFResult.CurrentRowId;
	var currentCFCRowId;
	var currentRowIndex;
	if (currentCFRowId != null) {
		currentRowIndex = fieldReportCustomFieldsGrid.getRowIndex(currentCFRowId);
		fieldReportCustomFieldsGrid.setRowId(currentRowIndex, cfId);
		fieldReportCustomFieldsGrid.setSelectedRow(cfId);
	}
	if (fieldReportCFResult.FieldType == 'CHOICE' && fieldReportCFResult.UpdateChoices == true) {
		AddUpdateFieldReportCustomFieldChoices(cfId);
	}
	try {
		customFieldDialog.dialog('destroy');
	} catch (err) {
	}

	if (fieldReportCFResult.FieldType == 'CUSTOMFIELDTABLE' && isManageCustomFieldTable) {
		CustomFieldTableGridInitialize('fieldreport', cfId);
	}
}

var fieldReportCustomFieldChoicesGrid, tbFieldReportCustomFieldChoicesGrid, fieldReportCustomFieldChoicesGridMenu;

function GetFieldReportCustomFieldChoices(customFieldId) {
	fieldReportCustomFieldChoicesGridMenu = new dhtmlXMenuObject('gridMenu');
	fieldReportCustomFieldChoicesGridMenu.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/");
	fieldReportCustomFieldChoicesGridMenu.renderAsContextMenu();
	fieldReportCustomFieldChoicesGridMenu.attachEvent("onClick", function (id, zoneId) {
		onGridMenuButtonClick(fieldReportCustomFieldChoicesGrid, zoneId, id);
	});
	fieldReportCustomFieldChoicesGridMenu.loadXMLString(menuXML);

	fieldReportCustomFieldChoicesGrid = new dhtmlXGridObject('fieldReportCFChoicesGrid');
	fieldReportCustomFieldChoicesGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	fieldReportCustomFieldChoicesGrid.setSkin(pjqGridTheme);
	fieldReportCustomFieldChoicesGrid.enableAutoHeight(true);
	//projectCustomFieldChoicesGrid.enableAutoWidth(true);
	fieldReportCustomFieldChoicesGrid.enableDragAndDrop(true);
	fieldReportCustomFieldChoicesGrid.setDragBehavior('complex');
	fieldReportCustomFieldChoicesGrid.enableMultiselect(true);
	fieldReportCustomFieldChoicesGrid.enableContextMenu(fieldReportCustomFieldChoicesGridMenu);
	fieldReportCustomFieldChoicesGrid.load("/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=FieldReportCustomFieldChoices&customFieldid=" + customFieldId, "xml");
	fieldReportCustomFieldChoicesGrid.init();
	fieldReportCustomFieldChoicesGrid.attachEvent("onRowSelect", function (id, ind) {
		EnableToolBarButton(tbFieldReportCustomFieldChoicesGrid, 'delete');
	});
	fieldReportCustomFieldChoicesGrid.attachEvent("onXLE", function (grid_obj, count) {
		jQuery('#fieldReportCFChoicesGridContainer').removeClass(pjqHidden);
		UpdateCustomFieldChoicesDefaultValueDropDown(fieldReportCustomFieldsGrid, fieldReportCustomFieldChoicesGrid, customFieldId);
	});
	fieldReportCustomFieldChoicesGrid.attachEvent("onEditCell", function (stage, rId, cInd, nValue, oValue) {
		if (stage == 2) {
			return UpdateCustomFieldChoicesDefaultValueDropDown(fieldReportCustomFieldsGrid, fieldReportCustomFieldChoicesGrid, customFieldId);
		}
	});
	fieldReportCustomFieldChoicesGrid.attachEvent("onBeforeContextMenu", function (id, ind, obj) {
		fieldReportCustomFieldChoicesGrid.selectRowById(id, false, false, true);
		return true;
	});
	fieldReportCustomFieldChoicesGrid.attachEvent("onDrop", function (id, ind, obj) {
		ChangeSortByOrder(fieldReportCustomFieldChoicesGrid, 1);
	});
	fieldReportCustomFieldChoicesGrid.attachEvent("onEnter", function (rid, cInd) {
		fieldReportCustomFieldChoicesGrid.editStop();
	});


	tbFieldReportCustomFieldChoicesGrid = new dhtmlXToolbarObject("fieldReportCFChoicesToolbar");
	tbFieldReportCustomFieldChoicesGrid.setSkin("dhx_web");
	tbFieldReportCustomFieldChoicesGrid.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
	tbFieldReportCustomFieldChoicesGrid.addButton('add', 0, 'Add', "new.gif", "new_dis.gif");
	tbFieldReportCustomFieldChoicesGrid.addButton('delete', 4, 'Delete', "Delete.png", "DeleteD.png");
	tbFieldReportCustomFieldChoicesGrid.disableItem('delete');
	tbFieldReportCustomFieldChoicesGrid.attachEvent("onClick", function (id) {
		switch (id) {
			case 'add':
				AddNewGridRow(fieldReportCustomFieldChoicesGrid);
				break;
			case 'delete':
				var selRow = fieldReportCustomFieldChoicesGrid.getSelectedRowId();
				var fieldReportCFCName;
				var deleteType;
				if (selRow.indexOf(',') == -1 && selRow.indexOf('newRow') == -1) {
					cfChoiceDeleteArray.push(selRow);
				}
				else {
					tempCFArray = selRow.split(',');
					for (i = 0; i < tempCFArray.length; i++) {
						if (tempCFArray[i].indexOf('newRow') == -1) {
							cfChoiceDeleteArray.push(tempCFArray[i]);
						}
					}
				}
				DeleteGridRow(fieldReportCustomFieldChoicesGrid, selRow, false);
				break;
		}
	});
}

function AddUpdateFieldReportCustomFieldChoices(customFieldId) {
	for (i = 0; i < fieldReportCustomFieldChoicesGrid.getRowsNum(); i++) {
		currentCFCRowId = fieldReportCustomFieldChoicesGrid.getRowId(i);
		cfChoiceName = fieldReportCustomFieldChoicesGrid.cells2(i, 0).getValue();
		cfChoiceSort = fieldReportCustomFieldChoicesGrid.cells2(i, 1).getValue();
		/*
		if(cfChoiceName.indexOf('&') != -1){
			cfChoiceName = cfChoiceName.replace(ampRegex, '&amp;');
		}
		*/
		if (currentCFCRowId.indexOf('new') != -1) {
			PanteraScript.PanteraScriptService.AddFieldReportCustomFieldChoice(pjqSessionId, customFieldId, currentCFCRowId, cfChoiceName, cfChoiceSort, FieldReportCustomFieldChoiceSaved, onScriptError);
		}
		else {
			PanteraScript.PanteraScriptService.UpdateFieldReportCustomFieldChoice(pjqSessionId, parseInt(customFieldId), parseInt(currentCFCRowId), cfChoiceName, parseInt(cfChoiceSort), FieldReportCustomFieldChoiceSaved, onScriptError);
		}
	}
	fieldReportCustomFieldChoicesGrid.destructor();
	ResetCustomFieldForm();
}

function FieldReportCustomFieldChoiceSaved(response) {
	var fieldReportCFCResult = jQuery.parseJSON(response);
	var defaultValueId = jQuery('#customFieldDefaultValue-CHOICE').val();
	if (defaultValueId == fieldReportCFCResult.CurrentRowId) {
		fieldReportCustomFieldsGrid.setUserData(fieldReportCFCResult.CustomFieldId, 'defaultValue', fieldReportCFCResult.RowId);
		PanteraScript.PanteraScriptService.UpdateFieldReportCustomFieldDefaultValue(pjqSessionId, fieldReportCFCResult.CustomFieldId, fieldReportCFCResult.RowId, SettingSavedCallback, onScriptError);
	}
}

// Submittal stuff
var tbSubmittalCustomFields = null, submittalCustomFieldsGrid = null, submittalCustomFieldGridMenu = null;
var tbSubmittalItemTypes = null, submittalItemTypesGrid = null, submittalItemTypesGridMenu = null;

function GetSubmittalSettings(response) {
	var submittalSettings = jQuery.parseJSON(response);

	jQuery('#submittalDueDays').spinner({
		min: 1,
		max: 180,
		step: 1,
		spin: function (event, ui) {
			//validator.element('#' + jQuery(this).attr('id'));
			PanteraScript.PanteraScriptService.UpdatePlanroomSubmittalSettings(pjqSessionId, parseInt(jQuery('#submittalDueDays').val()), null, onScriptError);

		},
		change: function (event, ui) {
			PanteraScript.PanteraScriptService.UpdatePlanroomSubmittalSettings(pjqSessionId, parseInt(jQuery('#submittalDueDays').val()), null, onScriptError);
		}
	});
	jQuery('#submittalDueDays').val(submittalSettings.SubmittalDueDays);

	submittalItemTypesGridMenu = new dhtmlXMenuObject('gridMenu');
	submittalItemTypesGridMenu.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/");
	submittalItemTypesGridMenu.renderAsContextMenu();
	submittalItemTypesGridMenu.attachEvent("onClick", function (id, zoneId) {
		onGridMenuButtonClick(submittalItemTypesGrid, zoneId, id);
	});
	submittalItemTypesGridMenu.loadXMLString(menuXML);

	tbSubmittalItemTypes = new dhtmlXToolbarObject("toolbarSubmittalItemTypes");
	tbSubmittalItemTypes.setSkin("dhx_web");
	tbSubmittalItemTypes.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
	tbSubmittalItemTypes.addButton('add', 0, 'Add', "new.gif", "new_dis.gif");
	tbSubmittalItemTypes.addButton('edit', 1, 'Edit', "Edit.jpg", "EditD.jpg");
	tbSubmittalItemTypes.addButton('delete', 4, 'Delete', "Delete.png", "DeleteD.png");
	tbSubmittalItemTypes.disableItem('edit');
	tbSubmittalItemTypes.disableItem('delete');
	tbSubmittalItemTypes.attachEvent("onClick", function (id) {
		switch (id) {
			case 'add':
				CreateAddEditSubmittalItemTypeForm(null);
				break;
			case 'edit':
				CreateAddEditSubmittalItemTypeForm(submittalItemTypesGrid.getSelectedRowId());
				break;
			case 'delete':
				CreateDialog(submittalItemTypesGrid, 'delete', submittalItemTypesGrid.cells(submittalItemTypesGrid.getSelectedRowId(), 0).getValue(), submittalItemTypesGrid.getSelectedRowId());
				break;
		}
	});

	submittalItemTypesGrid = new dhtmlXGridObject('gridSubmittalItemTypes');
	submittalItemTypesGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	submittalItemTypesGrid.setSkin(pjqGridTheme);
	submittalItemTypesGrid.enableAutoHeight(true);
	submittalItemTypesGrid.enableContextMenu(submittalCustomFieldGridMenu);
	submittalItemTypesGrid.load("/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=SubmittalItemTypes&customFieldid=0", "xml");
	submittalItemTypesGrid.setHeader("Item Type,Sort");
	submittalItemTypesGrid.setInitWidthsP("90,,10");
	submittalItemTypesGrid.setColAlign("center,center");
	submittalItemTypesGrid.setColTypes("ro,ro");
	submittalItemTypesGrid.setColSorting("na,na");
	submittalItemTypesGrid.init();
	submittalItemTypesGrid.attachEvent("onRowDblClicked", function (rId, cInd) {
		CreateAddEditSubmittalItemTypeForm(rId);
	});
	submittalItemTypesGrid.attachEvent("onBeforeContextMenu", function (id, ind, obj) {
		submittalItemTypesGrid.selectRowById(id, false, false, true);
		return true;
	});
	submittalItemTypesGrid.attachEvent("onRowSelect", function (id, ind) {
		EnableToolBarButton(tbSubmittalItemTypes, 'edit');
		EnableToolBarButton(tbSubmittalItemTypes, 'delete');
	});


	submittalCustomFieldGridMenu = new dhtmlXMenuObject('gridMenu');
	submittalCustomFieldGridMenu.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/");
	submittalCustomFieldGridMenu.renderAsContextMenu();
	submittalCustomFieldGridMenu.attachEvent("onClick", function (id, zoneId) {
		onGridMenuButtonClick(submittalCustomFieldsGrid, zoneId, id);
	});
	submittalCustomFieldGridMenu.loadXMLString(menuXML);


	tbSubmittalCustomFields = new dhtmlXToolbarObject("toolbarSubmittalCustomFields");
	tbSubmittalCustomFields.setSkin("dhx_web");
	tbSubmittalCustomFields.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
	tbSubmittalCustomFields.addButton('add', 0, 'Add', "new.gif", "new_dis.gif");
	tbSubmittalCustomFields.addButton('edit', 1, 'Edit', "Edit.jpg", "EditD.jpg");
	tbSubmittalCustomFields.addButton('delete', 4, 'Delete', "Delete.png", "DeleteD.png");
	//tbSubmittalCustomFields.disableItem('add');
	tbSubmittalCustomFields.disableItem('edit');
	tbSubmittalCustomFields.disableItem('delete');
	tbSubmittalCustomFields.attachEvent("onClick", function (id) {
		switch (id) {
			case 'add':
				CreateAddEditCustomFieldForm(submittalCustomFieldsGrid, 'add');
				break;
			case 'edit':
				CreateAddEditCustomFieldForm(submittalCustomFieldsGrid, 'edit', submittalCustomFieldsGrid.getSelectedRowId());
				break;
			case 'delete':
				var selRow = submittalCustomFieldsGrid.getSelectedRowId();
				var submittalCFCName;
				var deleteType;
				if (selRow.indexOf(',') == -1) {
					submittalCFCName = submittalCustomFieldsGrid.cells(selRow, 0).getValue();
					deleteType = 'delete';
				}
				else {
					deleteType = 'deleteMultiple';
					submittalCFCName = null;
				}
				CreateDialog(submittalCustomFieldsGrid, deleteType, submittalCFCName, selRow);
				break;
		}
	});

	submittalCustomFieldsGrid = new dhtmlXGridObject('gridSubmittalCustomFields');
	submittalCustomFieldsGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	submittalCustomFieldsGrid.setSkin(pjqGridTheme);
	submittalCustomFieldsGrid.enableAutoHeight(true);
	submittalCustomFieldsGrid.enableContextMenu(submittalCustomFieldGridMenu);
	submittalCustomFieldsGrid.load("/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=SubmittalCustomFields&customFieldid=0", "xml");
	submittalCustomFieldsGrid.setHeader("Name,Type,Required,Sort");
	submittalCustomFieldsGrid.setInitWidthsP("60,20,10,10");
	submittalCustomFieldsGrid.setColAlign("center,center,center,center");
	submittalCustomFieldsGrid.setColTypes("ro,ro,ch,edn");
	submittalCustomFieldsGrid.setColSorting("na,na,na,na");
	submittalCustomFieldsGrid.init();
	submittalCustomFieldsGrid.attachEvent("onEditCell", function (stage, rId, cInd, nValue, oValue) {
		if (stage == 1) {
			UpdateSubmittalCustomField(false, true, rId);
		}
		return true;
	});
	submittalCustomFieldsGrid.attachEvent("onRowDblClicked", function (rId, cInd) {
		CreateAddEditCustomFieldForm(submittalCustomFieldsGrid, 'edit', rId);
	});
	submittalCustomFieldsGrid.attachEvent("onXLE", function (grid_obj, count) {
		//jQuery('.projectCustomFieldsGridContainer').removeClass(pjqHidden);
		CheckCustomFieldGridRowsCount(submittalCustomFieldsGrid);
	});

	submittalCustomFieldsGrid.attachEvent("onBeforeContextMenu", function (id, ind, obj) {
		submittalCustomFieldsGrid.selectRowById(id, false, false, true);
		return true;
	});
	submittalCustomFieldsGrid.attachEvent("onRowSelect", function (id, ind) {
		EnableToolBarButton(tbSubmittalCustomFields, 'edit');
		EnableToolBarButton(tbSubmittalCustomFields, 'delete');
	});
	submittalCustomFieldsGrid.attachEvent("onDrop", function (id, ind, obj) {
		ChangeSortByOrder(submittalCustomFieldsGrid, 4);
		UpdateSubmittalCustomField(true, false);
	});
	submittalCustomFieldsGrid.attachEvent("onRowAdded", function (rId, rObj, rXml) {
		CheckCustomFieldGridRowsCount(submittalCustomFieldsGrid);
	});
	submittalCustomFieldsGrid.attachEvent("onEnter", function (rid, cInd) {
		submittalCustomFieldsGrid.editStop();
	});

	jQuery('#planroomSubmittalSettingsTab').removeClass(pjqHidden);
}

var submittalItemTypeDialogId = null;

function CreateAddEditSubmittalItemTypeForm(id) {
	submittalItemTypeDialogId = id;
	var maxRow = submittalItemTypesGrid.getRowsNum();
	var dlgtitle = '';
	if (id) {
		jQuery('#submittalItemTypeName').val(submittalItemTypesGrid.cells(id, 0).getValue());
		jQuery('#submittalItemTypeSortOrder').val(submittalItemTypesGrid.cells(id, 1).getValue());
		dlgtitle = 'Edit Item Type';
	}
	else {
		maxRow++;
		jQuery('#submittalItemTypeName').val('');
		jQuery('#submittalItemTypeSortOrder').val(maxRow.toString());
		dlgtitle = 'Add Item Type';
	}

	jQuery('#submittalItemTypeSortOrder').spinner({
		min: 1,
		max: maxRow
	});

	var dlg = jQuery('#submittalItemTypeDialog').dialog({
		title: dlgtitle,
		modal: true,
		resizable: false,
		width: 600,
		buttons: [{
			text: "Save",
			click: function () {

				var errorCount = 0;
				if (!validator.element('#submittalItemTypeName'))
					errorCount++;
				if (!validator.element('#submittalItemTypeSortOrder'))
					errorCount++;

				if (errorCount > 0)
					return;

				if (submittalItemTypeDialogId)
					PanteraScript.PanteraScriptService.ModifySubmittalItemType(pjqSessionId, submittalItemTypeDialogId, jQuery('#submittalItemTypeName').val(), jQuery('#submittalItemTypeSortOrder').val(), SubmittalItemTypeSaved, onScriptError);
				else
					PanteraScript.PanteraScriptService.AddSubmittalItemType(pjqSessionId, 'newRow', jQuery('#submittalItemTypeName').val(), jQuery('#submittalItemTypeSortOrder').val(), SubmittalItemTypeSaved, onScriptError);

				jQuery(this).dialog('destroy');
			}
		},
			{
				text: "Cancel",
				click: function () {
					jQuery(this).dialog('destroy');
				}
			}]
	});
	dlg.parent().appendTo($("Form[name='Form']"));


}

function SubmittalItemTypeSaved(response) {
	submittalItemTypesGrid.clearAll();
	submittalItemTypesGrid.load("/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=SubmittalItemTypes&customFieldid=0", "xml");
	DisableToolBarButton(tbSubmittalCustomFields, 'edit');
	DisableToolBarButton(tbSubmittalCustomFields, 'delete');

}

function SubmittalSavedCallback(response) {
	EnableToolBarButton(tbSubmittalCustomFields, 'add');
}

function AddSubmittalCustomField(currentCFFormType) {
	var newRowId = "newRow" + newRowCounter;
	var cfName = jQuery('#customFieldName').val();
	var cfSort = jQuery('#customFieldSortOrder').val();
	var cfDefVal = jQuery('#customFieldDefaultValue-' + currentCFFormType).val();
	var cfIsShowInList;
	var cfIsMultChoice = jQuery('#submittalcfIsMultChoice').prop('checked');
	var cfIsRequired = jQuery('#submittalcfRequired').prop('checked');
	var cfIsAdminEditOnly = !jQuery('#submittalcfIsEditableNonAdmin').prop('checked');
	var cfIsVisibleNonAdmin = jQuery('#submittalcfIsVisibleNonAdmin').prop('checked');
	var cfMinVal = 0;
	var cfMaxVal = 0;
	var cfDesc = '';
	if (currentCFFormType == 'CHOICE') {
		cfDefVal = '';
	}
	else if (currentCFFormType == 'INT') {
		if (jQuery('#customFieldMinVal').val().length > 0) {
			cfMinVal = jQuery('#customFieldMinVal').val();
		}
		if (jQuery('#customFieldMaxVal').val().length > 0) {
			cfMaxVal = jQuery('#customFieldMaxVal').val();
		}
	}
	else if (currentCFFormType == 'DATETIME') {
		cfDefVal = jQuery('#customFieldDefaultValue-DATETIMEDATE').val() + ' ' + jQuery('#customFieldDefaultValue-DATETIMETIME').val();
	}
	else if (currentCFFormType.indexOf('-LIST') != -1 || currentCFFormType == 'WEATHER') {
		cfDefVal = '';
	}
	PanteraScript.PanteraScriptService.AddSubmittalCustomField(pjqSessionId, newRowId, cfName, cfDesc, cfSort, currentCFFormType, cfDefVal, cfMinVal, cfMaxVal, cfIsMultChoice, cfIsRequired, cfIsAdminEditOnly, cfIsVisibleNonAdmin, SubmittalCustomFieldSaved, onScriptError);
	var newCFRowData = [cfName, currentCFFormType, boolToInt(cfIsRequired), cfSort];
	submittalCustomFieldsGrid.addRow(newRowId, newCFRowData, parseInt(cfSort) - 1);
	submittalCustomFieldsGrid.setUserData(newRowId, 'isAllowMultChoice', cfIsMultChoice.toString());
	submittalCustomFieldsGrid.setUserData(newRowId, 'isAdminEditOnly', cfIsAdminEditOnly.toString());
	submittalCustomFieldsGrid.setUserData(newRowId, 'isVisibleNonAdmin', cfIsVisibleNonAdmin.toString());
	submittalCustomFieldsGrid.setUserData(newRowId, 'defaultValue', cfDefVal);
	submittalCustomFieldsGrid.setUserData(newRowId, 'minValue', cfMinVal);
	submittalCustomFieldsGrid.setUserData(newRowId, 'maxValue', cfMaxVal);
	ChangeSortByOrder(submittalCustomFieldsGrid, 3);
}

function UpdateSubmittalCustomField(multiple, isInline, customFieldId, currentCustomFieldType) {
	var thisCFCId;
	var updateChoices = false;
	var cfName;
	var cfSort;
	var cfDefVal;
	var cfIsAllowMultChoice = false;
	var cfIsShowInList = false;
	var cfIsVisibleRSVP;
	var cfIsRequired;
	var cfMinVal;
	var cfMaxVal;
	var cfDesc;
	var cfIsAdminEditOnly;
	var cfIsVisibleNonAdmin;

	if (multiple) {
		for (var i = 0; i < submittalCustomFieldsGrid.getRowsNum(); i++) {
			thisCFCId = submittalCustomFieldsGrid.getRowId(i);
			cfcFormType = submittalCustomFieldsGrid.cells2(i, 1).getValue();
			cfName = submittalCustomFieldsGrid.cells2(i, 0).getValue();
			cfSort = submittalCustomFieldsGrid.cells2(i, 3).getValue();
			cfIsAllowMultChoice = (submittalCustomFieldsGrid.getUserData(thisCFCId, 'isAllowMultChoice').toLowerCase() === "true");
			cfIsAdminEditOnly = (submittalCustomFieldsGrid.getUserData(thisCFCId, 'isAdminEditOnly').toLowerCase() === "true");
			cfIsVisibleNonAdmin = (submittalCustomFieldsGrid.getUserData(thisCFCId, 'isVisibleNonAdmin').toLowerCase() === "true");
			cfDefVal = submittalCustomFieldsGrid.getUserData(thisCFCId, 'defaultValue');
			cfIsRequired = GridCboxIsChecked(submittalCustomFieldsGrid.cells2(i, 2).getValue());
			cfMinVal = 0;
			cfMaxVal = 0;
			cfDesc = '';
			/*
			if(cfName.indexOf('&') != -1){
				cfName = cfName.replace(ampRegex, '&amp;');
			}
			*/
			if (cfcFormType == 'INT') {
				cfMinVal = submittalCustomFieldsGrid.getUserData(thisCFCId, 'minValue');
				cfMaxVal = submittalCustomFieldsGrid.getUserData(thisCFCId, 'maxValue');
			}
			PanteraScript.PanteraScriptService.UpdateSubmittalCustomField(pjqSessionId, thisCFCId, cfName, cfDesc, cfSort, cfcFormType, cfDefVal, cfMinVal, cfMaxVal, cfIsAllowMultChoice, cfIsRequired, cfIsAdminEditOnly, cfIsVisibleNonAdmin, updateChoices, SubmittalCustomFieldSaved, onScriptError);
		}
	}
	else if (isInline) {
		cfcFormType = submittalCustomFieldsGrid.cells(customFieldId, 1).getValue();
		cfName = submittalCustomFieldsGrid.cells(customFieldId, 0).getValue();
		cfSort = submittalCustomFieldsGrid.cells(customFieldId, 3).getValue();
		cfIsAllowMultChoice = (submittalCustomFieldsGrid.getUserData(customFieldId, 'isAllowMultChoice').toLowerCase() === "true")
		cfIsAdminEditOnly = (submittalCustomFieldsGrid.getUserData(customFieldId, 'isAdminEditOnly').toLowerCase() === "true");
		cfIsVisibleNonAdmin = (submittalCustomFieldsGrid.getUserData(customFieldId, 'isVisibleNonAdmin').toLowerCase() === "true");
		cfDefVal = submittalCustomFieldsGrid.getUserData(customFieldId, 'defaultValue');
		cfIsRequired = GridCboxIsChecked(submittalCustomFieldsGrid.cells(customFieldId, 2).getValue());
		cfMinVal = 0;
		cfMaxVal = 0;
		cfDesc = '';
		/*
		if(cfName.indexOf('&') != -1){
			cfName = cfName.replace(ampRegex, '&amp;');
		}
		*/
		if (cfcFormType == 'INT') {
			cfMinVal = submittalCustomFieldsGrid.getUserData(customFieldId, 'minValue');
			cfMaxVal = submittalCustomFieldsGrid.getUserData(customFieldId, 'maxValue');
		}
		PanteraScript.PanteraScriptService.UpdateSubmittalCustomField(pjqSessionId, customFieldId, cfName, cfDesc, cfSort, cfcFormType, cfDefVal, cfMinVal, cfMaxVal, cfIsAllowMultChoice, cfIsRequired, cfIsAdminEditOnly, cfIsVisibleNonAdmin, updateChoices, SubmittalCustomFieldSaved, onScriptError);
	}
	else {
		updateChoices = true;
		cfName = jQuery('#customFieldName').val();
		cfSort = parseInt(jQuery('#customFieldSortOrder').val());
		cfDefVal = jQuery('#customFieldDefaultValue-' + currentCustomFieldType).val();
		cfDefVal = cfDefVal ? cfDefVal : '';
		cfIsRequired = jQuery('#submittalcfRequired').prop('checked');
		cfIsAdminEditOnly = !jQuery('#submittalcfIsEditableNonAdmin').prop('checked');
		cfIsVisibleNonAdmin = jQuery('#submittalcfIsVisibleNonAdmin').prop('checked');

		cfMinVal = 0;
		cfMaxVal = 0;
		cfDesc = '';
		/*
		if(cfName.indexOf('&') != -1){
			cfName = cfName.replace(ampRegex, '&amp;');
		}
		*/
		if (currentCustomFieldType == 'CHOICE') {
			cfIsAllowMultChoice = jQuery('#submittalcfIsMultChoice').prop('checked');
			cfDefVal = '';
		}
		else if (currentCustomFieldType == 'INT') {
			if (jQuery('#customFieldMinVal').val().length > 0) {
				cfMinVal = jQuery('#customFieldMinVal').val();
			}
			if (jQuery('#customFieldMaxVal').val().length > 0) {
				cfMaxVal = jQuery('#customFieldMaxVal').val();
			}
		}
		else if (currentCustomFieldType == 'DATETIME') {
			cfDefVal = jQuery('#customFieldDefaultValue-DATETIMEDATE').val() + ' ' + jQuery('#customFieldDefaultValue-DATETIMETIME').val();
		}
		else if (currentCustomFieldType == 'FILE') {
			cfIsAllowMultChoice = jQuery('#submittalcfIsMultChoice').prop('checked');
		}

		PanteraScript.PanteraScriptService.UpdateSubmittalCustomField(pjqSessionId, customFieldId, cfName, cfDesc, cfSort, currentCustomFieldType, cfDefVal, cfMinVal, cfMaxVal, cfIsAllowMultChoice, cfIsRequired, cfIsAdminEditOnly, cfIsVisibleNonAdmin, updateChoices, SubmittalCustomFieldSaved, onScriptError);
		submittalCustomFieldsGrid.cells(customFieldId, 0).setValue(cfName);
		submittalCustomFieldsGrid.cells(customFieldId, 1).setValue(currentCustomFieldType);
		submittalCustomFieldsGrid.cells(customFieldId, 2).setValue(cfIsRequired);
		ChangeRowSortOrder(submittalCustomFieldsGrid, customFieldId, 3, cfSort);
		submittalCustomFieldsGrid.cells(customFieldId, 3).setValue(cfSort);
		submittalCustomFieldsGrid.setUserData(customFieldId, 'isAllowMultChoice', cfIsAllowMultChoice.toString());
		submittalCustomFieldsGrid.setUserData(customFieldId, 'isAdminEditOnly', cfIsAdminEditOnly.toString());
		submittalCustomFieldsGrid.setUserData(customFieldId, 'isVisibleNonAdmin', cfIsVisibleNonAdmin.toString());
		submittalCustomFieldsGrid.setUserData(customFieldId, 'defaultValue', cfDefVal);
		submittalCustomFieldsGrid.setUserData(customFieldId, 'minValue', cfMinVal);
		submittalCustomFieldsGrid.setUserData(customFieldId, 'maxValue', cfMaxVal);
	}

}

function SubmittalCustomFieldSaved(response) {
	var submittalCFResult = jQuery.parseJSON(response);
	var cfChoiceName;
	var cfChoiceSort;
	var cfId = submittalCFResult.RowId;
	var currentCFRowId = submittalCFResult.CurrentRowId;
	var currentCFCRowId;
	var currentRowIndex;
	if (currentCFRowId != null) {
		currentRowIndex = submittalCustomFieldsGrid.getRowIndex(currentCFRowId);
		submittalCustomFieldsGrid.setRowId(currentRowIndex, cfId);
	}
	if (submittalCFResult.FieldType == 'CHOICE' && submittalCFResult.UpdateChoices == true) {
		AddUpdateSubmittalCustomFieldChoices(cfId);
	}
	try {
		customFieldDialog.dialog('destroy');
	} catch (err) {
	}
}

var submittalCustomFieldChoicesGrid, tbSubmittalCustomFieldChoicesGrid, submittalCustomFieldChoicesGridMenu;

function GetSubmittalCustomFieldChoices(customFieldId) {
	submittalCustomFieldChoicesGridMenu = new dhtmlXMenuObject('gridMenu');
	submittalCustomFieldChoicesGridMenu.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/");
	submittalCustomFieldChoicesGridMenu.renderAsContextMenu();
	submittalCustomFieldChoicesGridMenu.attachEvent("onClick", function (id, zoneId) {
		onGridMenuButtonClick(submittalCustomFieldChoicesGrid, zoneId, id);
	});
	submittalCustomFieldChoicesGridMenu.loadXMLString(menuXML);

	submittalCustomFieldChoicesGrid = new dhtmlXGridObject('submittalCFChoicesGrid');
	submittalCustomFieldChoicesGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	submittalCustomFieldChoicesGrid.setSkin(pjqGridTheme);
	submittalCustomFieldChoicesGrid.enableAutoHeight(true);
	submittalCustomFieldChoicesGrid.enableDragAndDrop(true);
	submittalCustomFieldChoicesGrid.setDragBehavior('complex');
	submittalCustomFieldChoicesGrid.enableMultiselect(true);
	submittalCustomFieldChoicesGrid.enableContextMenu(submittalCustomFieldChoicesGridMenu);
	submittalCustomFieldChoicesGrid.load("/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=SubmittalCustomFieldChoices&customFieldid=" + customFieldId, "xml");
	submittalCustomFieldChoicesGrid.init();
	submittalCustomFieldChoicesGrid.attachEvent("onRowSelect", function (id, ind) {
		EnableToolBarButton(tbSubmittalCustomFieldChoicesGrid, 'delete');
	});
	submittalCustomFieldChoicesGrid.attachEvent("onXLE", function (grid_obj, count) {
		jQuery('#submittalCFChoicesGridContainer').removeClass(pjqHidden);
		UpdateCustomFieldChoicesDefaultValueDropDown(submittalCustomFieldsGrid, submittalCustomFieldChoicesGrid, customFieldId);
	});
	submittalCustomFieldChoicesGrid.attachEvent("onEditCell", function (stage, rId, cInd, nValue, oValue) {
		if (stage == 2) {
			return UpdateCustomFieldChoicesDefaultValueDropDown(submittalCustomFieldsGrid, submittalCustomFieldChoicesGrid, customFieldId);
		}
	});
	submittalCustomFieldChoicesGrid.attachEvent("onBeforeContextMenu", function (id, ind, obj) {
		submittalCustomFieldChoicesGrid.selectRowById(id, false, false, true);
		return true;
	});
	submittalCustomFieldChoicesGrid.attachEvent("onDrop", function (id, ind, obj) {
		ChangeSortByOrder(submittalCustomFieldChoicesGrid, 1);
	});
	submittalCustomFieldChoicesGrid.attachEvent("onEnter", function (rid, cInd) {
		submittalCustomFieldChoicesGrid.editStop();
	});


	tbSubmittalCustomFieldChoicesGrid = new dhtmlXToolbarObject("submittalCFChoicesToolbar");
	tbSubmittalCustomFieldChoicesGrid.setSkin("dhx_web");
	tbSubmittalCustomFieldChoicesGrid.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
	tbSubmittalCustomFieldChoicesGrid.addButton('add', 0, 'Add', "new.gif", "new_dis.gif");
	tbSubmittalCustomFieldChoicesGrid.addButton('delete', 4, 'Delete', "Delete.png", "DeleteD.png");
	tbSubmittalCustomFieldChoicesGrid.disableItem('delete');
	tbSubmittalCustomFieldChoicesGrid.attachEvent("onClick", function (id) {
		switch (id) {
			case 'add':
				AddNewGridRow(submittalCustomFieldChoicesGrid);
				break;
			case 'delete':
				var selRow = submittalCustomFieldChoicesGrid.getSelectedRowId();
				var submittalCFCName;
				var deleteType;
				if (selRow.indexOf(',') == -1 && selRow.indexOf('newRow') == -1) {
					cfChoiceDeleteArray.push(selRow);
				}
				else {
					tempCFArray = selRow.split(',');
					for (i = 0; i < tempCFArray.length; i++) {
						if (tempCFArray[i].indexOf('newRow') == -1) {
							cfChoiceDeleteArray.push(tempCFArray[i]);
						}
					}
				}
				DeleteGridRow(submittalCustomFieldChoicesGrid, selRow, false);
				break;
		}
	});
}

function AddUpdateSubmittalCustomFieldChoices(customFieldId) {
	for (i = 0; i < submittalCustomFieldChoicesGrid.getRowsNum(); i++) {
		currentCFCRowId = submittalCustomFieldChoicesGrid.getRowId(i);
		cfChoiceName = submittalCustomFieldChoicesGrid.cells2(i, 0).getValue();
		cfChoiceSort = submittalCustomFieldChoicesGrid.cells2(i, 1).getValue();
		/*
		if(cfChoiceName.indexOf('&') != -1){
			cfChoiceName = cfChoiceName.replace(ampRegex, '&amp;');
		}
		*/
		if (currentCFCRowId.indexOf('new') != -1) {
			PanteraScript.PanteraScriptService.AddSubmittalCustomFieldChoice(pjqSessionId, customFieldId, currentCFCRowId, cfChoiceName, cfChoiceSort, SubmittalCustomFieldChoiceSaved, onScriptError);
		}
		else {
			PanteraScript.PanteraScriptService.UpdateSubmittalCustomFieldChoice(pjqSessionId, parseInt(customFieldId), parseInt(currentCFCRowId), cfChoiceName, parseInt(cfChoiceSort), SubmittalCustomFieldChoiceSaved, onScriptError);
		}
	}
	submittalCustomFieldChoicesGrid.destructor();
	ResetCustomFieldForm();
}

function SubmittalCustomFieldChoiceSaved(response) {
	var submittalCFCResult = jQuery.parseJSON(response);
	var defaultValueId = jQuery('#customFieldDefaultValue-CHOICE').val();
	if (defaultValueId == submittalCFCResult.CurrentRowId) {
		submittalCustomFieldsGrid.setUserData(submittalCFCResult.CustomFieldId, 'defaultValue', submittalCFCResult.RowId);
		PanteraScript.PanteraScriptService.UpdateSubmittalCustomFieldDefaultValue(pjqSessionId, submittalCFCResult.CustomFieldId, submittalCFCResult.RowId, SettingSavedCallback, onScriptError);
	}
}

var ampRegex = new RegExp('&', 'g');
var dQuoteRegex = new RegExp('"', 'g');

function SaveSettings() {
	if (isSaveProfileSettings) {
		PanteraScript.PanteraScriptService.UpdateCompanyInfoSettings(pjqSessionId, profCompName.val(), profContName.val(), profAdd1.val(), profAdd2.val(), profCity.val(), profState.val(), profZip.val(), profCountry.val(), profPhone.val(), profExt.val(), profFax.val(), profEmail.val(), SettingSavedCallback, onScriptError);
		isSaveProfileSettings == false;
	}
	if (isSavePlanroomGeneralSettings) {
		var maxAge;
		if (projectMaxAge.val().trim() == '') {
			maxAge = 0;
		}
		else {
			maxAge = projectMaxAge.val();
		}
		PanteraScript.PanteraScriptService.UpdatePlanroomGeneralSettings(pjqSessionId, IsChecked(isEnableProjCopy), IsChecked(isRequireAcceptDecline), IsChecked(isRequireInfoUpdate), IsChecked(isLockoutAcceptDecline), maxAge, defaultITBView.val(), rowsPerPageITB.val(), IsChecked(isITBMovePageSelect), IsChecked(isITBShowMessageFail), IsChecked(isITBEnableAttach), defaultITBTimezone.val(), isITBEmail ? isITBEmail.prop('checked') : true, isITBFax ? isITBFax.prop('checked') : false, isITBFaxNoEmail ? isITBFaxNoEmail.prop('checked') : false, isITBFaxEmailFails ? isITBFaxEmailFails.prop('checked') : false, SettingSavedCallback, onScriptError);
		isSavePlanroomGeneralSettings == false;
	}
	if (isSavePaymentSettings) {
		PanteraScript.PanteraScriptService.UpdatePaymentInfoSettings(pjqSessionId, paymentInfo.BillingInfoId, jQuery('#profilePaymentCompanyName').val(), jQuery('#profilePaymentCardholderName').val(), jQuery('#profilePaymentAddress1').val(), jQuery('#profilePaymentAddress2').val(), jQuery('#profilePaymentCity').val(), jQuery('#profilePaymentState').val(), jQuery('#profilePaymentZip').val(), jQuery('#profilePaymentCountry').val(), jQuery('#profilePaymentPhone').val(), jQuery('#profilePaymentExtension').val(), jQuery('#profilePaymentCardNumber').val().replace(new RegExp('-', 'g'), ''), jQuery('#profilePaymentExpiresMonth').val(), jQuery('#profilePaymentExpiresYear').val().substr(2, 3), jQuery('#profilePaymentCVV').val(), UpdatePaymentInfoSettingsC, onScriptError)
		isSavePaymentSettings = false;
	}
	if (isSaveOrderingSettings) {
		PanteraScript.PanteraScriptService.UpdatePlanroomOrderingSettings(pjqSessionId, deliverBy.val(), largeFormatCount.val(), largeFormatSize.val(), largeFormatPaper.val(), largeFormatBinding.val(), smallFormatCount.val(), smallFormatPaper.val(), smallFormatBinding.val(), SettingSavedCallback, onScriptError);
		isSaveOrderingSettings == false;
	}
	if (isSaveProjectMessagingSettings) {
		PanteraScript.PanteraScriptService.UpdateProjectMessagingSettings(pjqSessionId, defaultResponseType.val(), SettingSavedCallback, onScriptError);
		isSaveProjectMessagingSettings == false;
	}
	if (isSaveAddressBookSettings) {
		PanteraScript.PanteraScriptService.UpdateAddressBookSettings(pjqSessionId, rowsPerPage.val(), IsChecked(isCoreInfoReq), IsChecked(isShowUnionStatus), IsChecked(isEditUnionStatus), IsChecked(isShowSector), IsChecked(isEditSector), IsChecked(isShowMinorityStatus), IsChecked(isEditMinorityStatus), addressBookGroupLevels.val(), SettingSavedCallback, onScriptError)
		isSaveAddressBookSettings = false;
	}
}

function SettingSavedCallback(response) {
	SaveUnlockNav();
}

function UpdatePaymentInfoSettingsC(response) {
	paymentInfo = jQuery.parseJSON(response);
	InitNotifyDialog(null, 'Your Payment Infomation has been updated successfully.', 'Save Successful');
}

function SaveProjectStatusListGrid(stage, cellIndex, newValue, oldValue) {
	if (stage == 2 | cellIndex == 1) {
		var statusNameList = "";
		var statusRSVPList = "";
		var statusSortList = "";
		for (var i = 0; i < projectStatusGrid.getRowsNum(); i++) {
			var statusName = projectStatusGrid.cells2(i, 0).getValue();
			/*
			if(statusName.indexOf('&') != -1){
				statusName = statusName.replace(ampRegex, '&amp;');
			}
			*/
			if (statusName.trim() == "") {
				if (oldValue != "") {
					statusName.setValue(oldValue)
				}
				else {
					var thisRowId = projectStatusGrid.getRowId(i);
					DeleteGridRow(projectStatusGrid, thisRowId)
				}
				return;
			}
			var statusRSVP = projectStatusGrid.cells2(i, 1).getValue();
			var statusSort = projectStatusGrid.cells2(i, 2).getValue();
			if (statusName != null) {
				statusNameList = statusNameList + statusName + ",";
				statusRSVPList = statusRSVPList + GridCboxIsCheckedString(statusRSVP) + ",";
				statusSortList = statusSortList + statusSort + ",";
			}
			else {
				return false;
			}
		}
		PanteraScript.PanteraScriptService.UpdateProjectStatusList(pjqSessionId, statusNameList, statusRSVPList, statusSortList, SettingSavedCallback, onScriptError);
		return true;
	}
}

function SaveMessageStatusListGrid(state, cellIndex, newValue, oldValue) {
	if (state == 2 | cellIndex == 1) {
		var statusNameList = "";
		var statusRSVPList = "";
		var statusSortList = "";
		for (i = 0; i < messageStatusGrid.getRowsNum(); i++) {
			var statusName = messageStatusGrid.cells2(i, 0).getValue();
			/*
			if(statusName.indexOf('&') != -1){
				statusName = statusName.replace(ampRegex, '&amp;');
			}
			*/
			if (statusName.trim() == "") {
				if (oldValue != "") {
					statusName.setValue(oldValue)
				}
				else {
					var thisRowId = messageStatusGrid.getRowId(i);
					DeleteGridRow(messageStatusGrid, thisRowId)
				}
				return false;
			}
			var statusRSVP = messageStatusGrid.cells2(i, 1).getValue();
			var statusSort = messageStatusGrid.cells2(i, 2).getValue();
			if (statusName != null) {
				statusNameList = statusNameList + statusName + ",";
				statusRSVPList = statusRSVPList + GridCboxIsCheckedString(statusRSVP) + ",";
				statusSortList = statusSortList + statusSort + ",";
			}
			else {
				return false;
			}
		}

		PanteraScript.PanteraScriptService.UpdateMessageStatusList(pjqSessionId, statusNameList, statusRSVPList, statusSortList, SettingSavedCallback, onScriptError);
		return true;
	}
}

var lastSavedGroup = null;

function AddAddressBookGroup(rowId, stage) {
	if (stage == 2) {

		if (addressBookGroupsGrid.cells(rowId, 0).getValue() == "") {
			DeleteGridRow(addressBookGroupsGrid, rowId);
			return;
		}
		var groupName = addressBookGroupsGrid.cells(rowId, 0).getValue();
		var parentGroup;
		var sortOrder;
		var csiCode = '';


		ChangeSortByOrder(addressBookGroupsGrid, (addressBookSettings.IsCSICodeEnabled ? 3 : 2));

		if (groupName.length > 0) {
			switch (addressBookGroupLevels.val()) {
				case '1':
					parentGroup = addressBookGroupsGrid.cells(rowId, 1).getValue();
					sortOrder = addressBookGroupsGrid.cells(rowId, (addressBookSettings.IsCSICodeEnabled ? 3 : 2)).getValue();

					if (addressBookSettings.IsCSICodeEnabled)
						csiCode = addressBookGroupsGrid.cells(rowId, 2).getValue();

					break;
				case '2':
					parentGroup = addressBookGroupsGrid.cells(rowId, 1).getValue();
					if (parentGroup.trim().length == 0) {
						parentGroup = "No Parent";
					}
					sortOrder = addressBookGroupsGrid.cells(rowId, (addressBookSettings.IsCSICodeEnabled ? 3 : 2)).getValue();

					if (addressBookSettings.IsCSICodeEnabled)
						csiCode = addressBookGroupsGrid.cells(rowId, 2).getValue();

					break;
				case '3':
					parentGroup = addressBookGroupsGrid.cells(rowId, 1).getValue();
					if (parentGroup.indexOf('>') > -1) {
						var parentGroupArray = parentGroup.split('>');
						parentGroup = parentGroupArray[0].trim() + "|" + parentGroupArray[1].trim();
					}
					else if (parentGroup.length == 0) {
						parentGroup = "No Parent|No Parent";
					}
					sortOrder = addressBookGroupsGrid.cells(rowId, (addressBookSettings.IsCSICodeEnabled ? 3 : 2)).getValue();

					if (addressBookSettings.IsCSICodeEnabled)
						csiCode = addressBookGroupsGrid.cells(rowId, 2).getValue();

					break;
			}
			//CheckGroupsHaveContainers();
			lastSavedGroup = rowId;
			PanteraScript.PanteraScriptService.AddAddressBookGroup(pjqSessionId, groupName, parentGroup, csiCode, sortOrder, AddressBookGroupSettingsSaved, onScriptError);
		}
		return true;
	}
	else {
		return;
	}
}

function UpdateAddressBookGroup(rowId, cellIndex, state, oldVal, newVal) {
	var groupRow;
	var thisGroupArray;
	var groupsArray;
	var thisGroupName;
	var thisParentGroup = "";
	var thisGroupSort;
	var thisCSICode = "";
	var thisRowId;
	if (cellIndex == 1 && state == 2 && addressBookGroupLevels.val() != 1) {
		CheckParentGroupExists(rowId, cellIndex);
	}
	if (cellIndex == (addressBookSettings.IsCSICodeEnabled ? 3 : 2) && state == 2) {
		addressBookGroupsGrid.cells(rowId, (addressBookSettings.IsCSICodeEnabled ? 3 : 2)).setValue(newVal);
		ArrangeGridBySortOrder(addressBookGroupsGrid, cellIndex);
		ChangeSortByOrder(addressBookGroupsGrid, cellIndex);

	}
	if (rowId == 'allgroups') {
		if (addressBookGroupLevels.val() == 1) {
			for (var i = 0; i < addressBookGroupsGrid.getRowsNum(); i++) {
				thisRowId = addressBookGroupsGrid.getRowId(i);
				thisGroupName = addressBookGroupsGrid.cells2(i, 0).getValue();
				/*
				if(thisGroupName.indexOf('&') != -1){
					thisGroupName = thisGroupName.replace(ampRegex, '&amp;');
					//addressBookGroupsGrid.cells2(i, 0).setValue(thisGroupName);
				}
				*/
				oldVal = thisGroupName;
				thisParentGroup = "";

				if (addressBookSettings.IsCSICodeEnabled)
					thisCSICode = addressBookGroupsGrid.cells2(i, 2).getValue();

				thisGroupSort = addressBookGroupsGrid.cells2(i, (addressBookSettings.IsCSICodeEnabled ? 3 : 2)).getValue();
				PanteraScript.PanteraScriptService.UpdateAddressBookGroup(pjqSessionId, thisRowId, thisGroupName, oldVal, thisParentGroup, thisCSICode, thisGroupSort, AddressBookGroupSettingsSaved, onScriptError);
			}
		}
		else if (addressBookGroupLevels.val() == 2) {
			for (var i = 0; i < addressBookGroupsGrid.getRowsNum(); i++) {
				thisRowId = addressBookGroupsGrid.getRowId(i);
				CheckParentGroupExists(thisRowId, 1);
				thisGroupName = addressBookGroupsGrid.cells2(i, 0).getValue();
				/*
				if(thisGroupName.indexOf('&') != -1){
					thisGroupName = thisGroupName.replace(ampRegex, '&amp;');
					//addressBookGroupsGrid.cells2(i, 0).setValue(thisGroupName);
				}
				*/
				oldVal = thisGroupName;
				thisParentGroup = addressBookGroupsGrid.cells2(i, 1).getValue();
				if (thisParentGroup.trim().length == 0) {
					thisParentGroup = "No Parent";
				}

				if (addressBookSettings.IsCSICodeEnabled)
					thisCSICode = addressBookGroupsGrid.cells2(i, 2).getValue();

				thisGroupSort = addressBookGroupsGrid.cells2(i, (addressBookSettings.IsCSICodeEnabled ? 3 : 2)).getValue();
				if (thisGroupName.length > 0) {
					PanteraScript.PanteraScriptService.UpdateAddressBookGroup(pjqSessionId, thisRowId, thisGroupName, oldVal, thisParentGroup, thisCSICode, thisGroupSort, AddressBookGroupSettingsSaved, onScriptError);
				}
			}
		}
		else if (addressBookGroupLevels.val() == 3) {
			for (var i = 0; i < addressBookGroupsGrid.getRowsNum(); i++) {
				thisRowId = addressBookGroupsGrid.getRowId(i);
				CheckParentGroupExists(thisRowId, 1);
				thisGroupName = addressBookGroupsGrid.cells2(i, 0).getValue();
				/*
				if(thisGroupName.indexOf('&') != -1){
					thisGroupName = thisGroupName.replace(ampRegex, '&amp;');
					//addressBookGroupsGrid.cells2(i, 0).setValue(thisGroupName);
				}
				*/
				oldVal = thisGroupName;
				thisParentGroup = addressBookGroupsGrid.cells2(i, 1).getValue();
				if (thisParentGroup.trim().length == 0) {
					thisParentGroup = "No Parent|No Parent";
				}

				if (addressBookSettings.IsCSICodeEnabled)
					thisCSICode = addressBookGroupsGrid.cells2(i, 2).getValue();

				thisGroupSort = addressBookGroupsGrid.cells2(i, (addressBookSettings.IsCSICodeEnabled ? 3 : 2)).getValue();

				if (thisGroupName.length > 0) {
					if (thisParentGroup.indexOf('>') != -1) {
						var parentGroupArray = thisParentGroup.split('>');
						thisParentGroup = parentGroupArray[0].trim() + "|" + parentGroupArray[1].trim();
					}
				}
				PanteraScript.PanteraScriptService.UpdateAddressBookGroup(pjqSessionId, thisRowId, thisGroupName, oldVal, thisParentGroup, thisCSICode, thisGroupSort, AddressBookGroupSettingsSaved, onScriptError);
			}
		}
	}
	else if (rowId != null && state == 2 && (oldVal != newVal || (newVal == null && oldVal == null))) {
		thisGroupName = addressBookGroupsGrid.cells(rowId, 0).getValue();
		if (oldVal == null)
			oldVal = thisGroupName

		if (thisGroupName.trim().length > 0) {
			switch (addressBookGroupLevels.val()) {
				case '1':
					thisParentGroup = addressBookGroupsGrid.cells(rowId, 1).getValue();
					if (addressBookSettings.IsCSICodeEnabled)
						thisCSICode = addressBookGroupsGrid.cells(rowId, 2).getValue();
					thisGroupSort = addressBookGroupsGrid.cells(rowId, (addressBookSettings.IsCSICodeEnabled ? 3 : 2)).getValue();
					break;
				case '2':
					thisParentGroup = addressBookGroupsGrid.cells(rowId, 1).getValue();
					if (thisParentGroup.trim().length == 0) {
						thisParentGroup = "No Parent";
					}
					if (addressBookSettings.IsCSICodeEnabled)
						thisCSICode = addressBookGroupsGrid.cells(rowId, 2).getValue();
					thisGroupSort = addressBookGroupsGrid.cells(rowId, (addressBookSettings.IsCSICodeEnabled ? 3 : 2)).getValue();
					break;
				case '3':
					thisParentGroup = addressBookGroupsGrid.cells(rowId, 1).getValue();
					if (thisParentGroup.indexOf('>') > -1) {
						var parentGroupArray = thisParentGroup.split('>');
						thisParentGroup = parentGroupArray[0].trim() + "|" + parentGroupArray[1].trim();
					}
					else if (thisParentGroup.length == 0) {
						thisParentGroup = "No Parent|No Parent";
					}
					if (addressBookSettings.IsCSICodeEnabled)
						thisCSICode = addressBookGroupsGrid.cells(rowId, 2).getValue();
					thisGroupSort = addressBookGroupsGrid.cells(rowId, (addressBookSettings.IsCSICodeEnabled ? 3 : 2)).getValue();
					break;
			}
			FormatGroupContainers();
			PanteraScript.PanteraScriptService.UpdateAddressBookGroup(pjqSessionId, rowId, thisGroupName, oldVal, thisParentGroup, thisCSICode, thisGroupSort, AddressBookGroupSettingsSaved, onScriptError);
		}
		else {
			addressBookGroupsGrid.cells(rowId, 0).setValue(oldVal);
		}
		return true;
	}
	else {
		return;
	}
}

function CheckParentGroupExists(rowId, cellIndex) {
	var treeParentGroupList = addressBookGroupsGroupsTree.getSubItems('abGroupsTree');
	var treeParentGroups = treeParentGroupList.split('|');
	var comboValue = addressBookGroupsGrid.cells(rowId, cellIndex).getValue().toLowerCase();
	if (addressBookGroupLevels.val() == 3 && comboValue.indexOf('|') != -1) {
		comboValue = comboValue.split('|')[1].trim();
	}
	else if (addressBookGroupLevels.val() == 3 && comboValue.indexOf('>') != -1) {
		comboValue = comboValue.split('>')[1].trim();
	}
	else if (addressBookGroupLevels.val() == 3) {
		addressBookGroupsGrid.cells(rowId, cellIndex).setValue("");
		return;
	}
	var thisGroupValue = '';
	var thisGroupValue2 = '';
	var valueMatched = false;
	if (comboValue != "" | treeParentGroups.length != 0) {
		for (g = 0; g < treeParentGroups.length; g++) {
			thisGroupValue = addressBookGroupsGroupsTree.getItemText(treeParentGroups[g]);
			if (thisGroupValue.toLowerCase() == comboValue && addressBookGroupLevels.val() != 3) {
				addressBookGroupsGrid.cells(rowId, cellIndex).setValue(thisGroupValue);
				valueMatched = true;
			}
			else if (addressBookGroupLevels.val() == 3) {
				var treeParentChildGroupList = addressBookGroupsGroupsTree.getSubItems(treeParentGroups[g]);
				var treeParentChildGroups = treeParentChildGroupList.split('|');
				for (g2 = 0; g2 < treeParentChildGroups.length; g2++) {
					thisGroupValue2 = addressBookGroupsGroupsTree.getItemText(treeParentChildGroups[g2]);
					if (thisGroupValue2.toLowerCase() == comboValue) {
						valueMatched = true;
					}
				}
			}
		}
	}
	if (!valueMatched) {
		addressBookGroupsGrid.cells(rowId, cellIndex).setValue("");
	}
	FormatGroupContainers();
}

var addressBookTreeItemOldVal = '';

function UpdateAddressBookGroupsGroups(state, id) {
	var itemText;
	var nameExists = false;
	if (id != null) {
		itemText = addressBookGroupsGroupsTree.getItemText(id);
	}
	if (state == 0) {
		addressBookTreeItemOldVal = itemText;
	}
	if (state == 2 && itemText.indexOf('|') != -1) {
		addressBookGroupsGroupsTree.setItemText(id, itemText.replace('|', ''));
		IllegalCharacterDialog('|', '>');
	}
	if (state == 3 && addressBookGroupsGroupsTree.hasChildren('abGroupsTree') > 0) {
		if (typeof itemText != 'undefined') {
			if (itemText.trim() == "" && addressBookTreeItemOldVal.trim() != "" && addressBookTreeItemOldVal != null) {
				addressBookGroupsGroupsTree.setItemText(id, addressBookTreeItemOldVal);
				return;
			}
			if (itemText.trim() == "" && addressBookTreeItemOldVal.trim() == "" | addressBookTreeItemOldVal == null) {
				DeleteTreeItem(addressBookGroupsGroupsTree, id);
				return;
			}
		}
		else {
			itemText = "";
		}
		UpdateSetGroupParents(id, addressBookTreeItemOldVal);
		var parentGroupIds = addressBookGroupsGroupsTree.getSubItems('abGroupsTree').split('|');
		var parentGroupsCt = parentGroupIds.length;
		var thisParentGroupId;
		var groupNamesList = "";
		var thisChildGroupId;
		for (p1 = 0; p1 < parentGroupsCt; p1++) {
			thisParentGroupId = parentGroupIds[p1];
			parentGroupName = addressBookGroupsGroupsTree.getItemText(thisParentGroupId);
			if (parentGroupName.indexOf('&') != -1) {
				parentGroupName = parentGroupName.replace(ampRegex, '&amp;');
				//addressBookGroupsGroupsTree.setItemText(id,parentGroupName);
			}
			if (parentGroupName.indexOf('"') != -1) {
				parentGroupName = parentGroupName.replace(dQuoteRegex, '\'');
				addressBookGroupsGroupsTree.setItemText(id, parentGroupName);
			}
			if (itemText.toLowerCase() == parentGroupName.toLowerCase() && addressBookTreeItemOldVal != "" && thisParentGroupId != id) {
				CreateDialog(addressBookGroupsGroupsTree, 'duplicateEntryNotify', itemText);
				addressBookGroupsGroupsTree.setItemText(id, addressBookTreeItemOldVal);
				nameExists = true;
				break;
			}
			else if (itemText.toLowerCase() == parentGroupName.toLowerCase() && addressBookTreeItemOldVal == "" && thisParentGroupId != id) {
				CreateDialog(addressBookGroupsGroupsTree, 'duplicateEntryDelete', itemText, id);
				nameExists = true;
				break;
			}
			if (addressBookGroupLevels.val() == 3) {
				childGroups = addressBookGroupsGroupsTree.getSubItems(thisParentGroupId).split('|');
				childGroupsCt = childGroups.length;
				if (addressBookGroupsGroupsTree.hasChildren(thisParentGroupId) == 0) {
					continue;
				}
				for (c1 = 0; c1 < childGroupsCt; c1++) {
					childGroupName = addressBookGroupsGroupsTree.getItemText(childGroups[c1]);
					thisChildGroupId = childGroups[c1];
					if (itemText.toLowerCase() == childGroupName.toLowerCase() && addressBookTreeItemOldVal != "" && thisChildGroupId != id) {
						CreateDialog(addressBookGroupsGroupsTree, 'duplicateEntryNotify', itemText);
						addressBookGroupsGroupsTree.setItemText(id, addressBookTreeItemOldVal);
						nameExists = true;
						break;
					}
					else if (itemText.toLowerCase() == childGroupName.toLowerCase() && addressBookTreeItemOldVal == "" && thisChildGroupId != id) {
						CreateDialog(addressBookGroupsGroupsTree, 'duplicateEntryDelete', itemText, id);
						nameExists = true;
						break;
					}
					else {
						groupNamesList += parentGroupName.trim() + '||' + childGroupName.trim() + '{|}';
					}

				}
			}
			else {
				groupNamesList += parentGroupName + '|';
			}
		}
		if (!nameExists) {
			if (addressBookGroupLevels.val() == 3) {
				groupNamesList = groupNamesList.substring(0, groupNamesList.length - 3).trim();
			}
			else {
				groupNamesList = groupNamesList.substring(0, groupNamesList.length - 1).trim();
			}
			PanteraScript.PanteraScriptService.UpdateAddressBookGroupsGroup(pjqSessionId, addressBookGroupLevels.val(), groupNamesList, AddressBookGroupGroupsSaved, onScriptError);

			return true;
		}
		addressBookTreeItemOldVal = null;
	}
	else if (!addressBookGroupsGroupsTree.hasChildren('abGroupsTree') && id == null) {
		PanteraScript.PanteraScriptService.UpdateAddressBookGroupsGroup(pjqSessionId, addressBookGroupLevels.val(), "", AddressBookGroupGroupsSaved, onScriptError);
	}
	if (state < 3) {
		return true;
	}
}

function AddressBookGroupGroupsSaved(response) {
	UpdateGridCombos(addressBookGroupsGrid);
}

function UpdateSetGroupParents(itemId, oldVal) {
	var groupsGridCt = addressBookGroupsGrid.getRowsNum();
	var thisParentLevel = addressBookGroupsGroupsTree.getLevel(itemId);
	var oldValParentLevel3;
	var thisGroupParentId;
	var thisGroupParentName;
	var thisTreeParentId;
	var newTreeParentVal;
	if (oldVal.trim().length != 0) {
		for (gp = 0; gp < groupsGridCt; gp++) {
			thisGroupParentName = addressBookGroupsGrid.cells2(gp, 1).getValue();
			newTreeParentVal = addressBookGroupsGroupsTree.getItemText(itemId);
			if (addressBookGroupLevels.val() == 2) {
				if (thisGroupParentName == oldVal) {
					addressBookGroupsGrid.cells2(gp, 1).setValue(newTreeParentVal);
					UpdateAddressBookGroup(addressBookGroupsGrid.getRowId(gp), 1, 2);
				}
			}
			else if (addressBookGroupLevels.val() == 3) {
				if (thisParentLevel == 1) {
					if (thisGroupParentName.indexOf(oldVal) != -1) {
						addressBookGroupsGrid.cells2(gp, 1).setValue(thisGroupParentName.replace(oldVal, newTreeParentVal));
						UpdateAddressBookGroup(addressBookGroupsGrid.getRowId(gp), 1, 2);
					}
				}
				else if (thisParentLevel == 2) {
					if (thisGroupParentName.indexOf(oldVal) != -1) {
						thisTreeParentId = addressBookGroupsGroupsTree.getParentId(itemId);
						newTreeParentVal = addressBookGroupsGroupsTree.getItemText(thisTreeParentId);
						oldValParentLevel3 = newTreeParentVal + " > " + oldVal;
						if (thisGroupParentName == oldValParentLevel3) {
							newTreeParentVal = newTreeParentVal + " > " + addressBookGroupsGroupsTree.getItemText(itemId);
							addressBookGroupsGrid.cells2(gp, 1).setValue(newTreeParentVal);
							UpdateAddressBookGroup(addressBookGroupsGrid.getRowId(gp), 1, 2);
						}
					}
				}
			}
		}
	}
}

function UpdateAddressBookGroupParents(itemLevel, groupString) {
	var groupsGridCt = addressBookGroupsGrid.getRowsNum();
	var thisCell;
	var groupsArray;
	var arrayGroupString;
	if (itemLevel == 1) {
		groupString = groupString.substring(0, groupString.length - 1).trim();
		groupsArray = groupString.split('|');
		for (i1 = 0; i1 < groupsArray.length; i1++) {
			arrayGroupString = groupsArray[i1]
			for (i2 = 0; i2 < groupsGridCt; i2++) {
				thisCell = addressBookGroupsGrid.cells2(i2, 1);
				if (thisCell.getTitle() == arrayGroupString) {
					thisCell.setValue("");
				}
			}
		}
	}
	else {
		for (i = 0; i < groupsGridCt; i++) {
			thisCell = addressBookGroupsGrid.cells2(i, 1);
			if (thisCell.getTitle() == groupString) {
				thisCell.setValue("");
			}
		}
	}
}


function AddressBookGroupSettingsSaved(response) {
	var saveResult = jQuery.parseJSON(response);
	var thisGroupName;
	switch (saveResult.Type) {
		case 'AddGroup':
			if (saveResult.Result == 'SUCCESS') {
				addressBookGroupsGrid.changeRowId(lastSavedGroup, saveResult.RowId);
			}
			else if (saveResult.Result == 'ERROR') {
				thisGroupName = addressBookGroupsGrid.cells(lastSavedGroup, 0).getValue();
				CreateDialog(addressBookGroupsGrid, 'duplicateEntryDelete', thisGroupName, lastSavedGroup);
			}
			lastSavedGroup = null;
			break;
		case 'UpdateGroup':
			if (saveResult.Result == 'SUCCESS') {
			}
			else if (saveResult.Result == 'ERROR') {
				thisGroupName = addressBookGroupsGrid.cells(saveResult.RowId, 0).getValue();
				addressBookGroupsGrid.cells(saveResult.RowId, 0).setValue(saveResult.OldValue);
				CreateDialog(addressBookGroupsGrid, 'duplicateEntryNotify', thisGroupName);
			}
			break;
	}
}


function AddAddressBookRegion(rowId, state) {
	if (state == 2) {
		var regionName = addressBookRegionsGrid.cells(rowId, 0).getValue();
		if (regionName.trim() == "") {
			DeleteGridRow(addressBookRegionsGrid, rowId)
		}
		else {
			var regionDesc = "";
			var regionSort = addressBookRegionsGrid.cells(rowId, 1).getValue();
			PanteraScript.PanteraScriptService.AddAddressBookRegion(pjqSessionId, regionName, regionDesc, regionSort, AddressBookRegionSettingsSaved, onScriptError);
		}
	}
	return true;
}

function UpdateAddressBookRegion(rowId, cellId, state, oldVal, newVal) {
	if (rowId == 'allRegions') {
		var thisRowId;
		var thisRegionName;
		var thisRegionDesc;
		var thisRegionSort;
		for (var i = 0; i < addressBookRegionsGrid.getRowsNum(); i++) {
			thisRowId = addressBookRegionsGrid.getRowId(i);
			thisRegionName = addressBookRegionsGrid.cells2(i, 0).getValue();
			if (thisRegionName.indexOf('&') != -1) {
				thisRegionName = thisRegionName.replace(ampRegex, '&amp;');
				//addressBookRegionsGrid.cells2(i, 0).setValue(thisRegionName);
			}
			thisRegionDesc = "";
			thisRegionSort = addressBookRegionsGrid.cells2(i, 2).getValue();
			oldVal = thisRegionName;
			PanteraScript.PanteraScriptService.UpdateAddressBookRegion(pjqSessionId, thisRowId, thisRegionName, oldVal, thisRegionDesc, thisRegionSort, AddressBookRegionSettingsSaved, onScriptError);
		}
	}
	else if (state == 2) {
		if (newVal.trim() == "" && cellId == 0) {
			addressBookRegionsGrid.cells(rowId, 0).setValue(oldVal);
		}

		if (oldVal != newVal) {
			var regionName = addressBookRegionsGrid.cells(rowId, 0).getValue();
			if (regionName.indexOf('&') != -1) {
				regionName = regionName.replace(ampRegex, '&amp;');
				//addressBookRegionsGrid.cells(rowId, 0).setValue(regionName);
			}
			var regionDesc = "";
			var regionSort = addressBookRegionsGrid.cells(rowId, 1).getValue();
			PanteraScript.PanteraScriptService.UpdateAddressBookRegion(pjqSessionId, rowId, regionName, oldVal, regionDesc, regionSort, AddressBookRegionSettingsSaved, onScriptError);
			return true;
		}
	}
}

function AddressBookRegionSettingsSaved(response) {
	var saveResult = jQuery.parseJSON(response);
	var thisRegionName;
	switch (saveResult.Type) {
		case 'AddRegion':
			var lastRowNum = addressBookRegionsGrid.getRowsNum() - 1;
			var errorRowId = addressBookRegionsGrid.getRowId(lastRowNum);
			if (saveResult.Result == 'SUCCESS') {
				addressBookRegionsGrid.setRowId(lastRowNum, saveResult.RowId);
			}
			else if (saveResult.Result == 'ERROR') {
				thisRegionName = addressBookRegionsGrid.cells(errorRowId, 0).getValue();
				CreateDialog(addressBookRegionsGrid, 'duplicateEntryDelete', thisRegionName, errorRowId);
			}
			break;
		case 'UpdateRegion':
			if (saveResult.Result == 'SUCCESS') {
			}
			else if (saveResult.Result == 'ERROR') {
				addressBookRegionsGrid.cells(saveResult.RowId, 0).setValue(saveResult.OldValue);
				CreateDialog(addressBookRegionsGrid, 'duplicateEntryNotify', saveResult.OldValue);
			}
			break;
	}
}

function AddProjectCustomField(currentCFFormType) {
	var newProjRowId = "newRow" + newRowCounter;
	var cfName = jQuery('#customFieldName').val();
	var cfSort = jQuery('#customFieldSortOrder').val();
	var cfDefVal = jQuery('#customFieldDefaultValue-' + currentCFFormType).val();
	var cfIsShowInList;
	var cfIsMultChoice = jQuery('#projcfIsMultChoice').prop('checked');
	var cfIsVisibleRSVP = jQuery('#projcfVisible').prop('checked');
	var cfIsRequired = jQuery('#projcfRequired').prop('checked');
	var cfMinVal = 0;
	var cfMaxVal = 0;
	var cfDesc = '';
	/*
	if(cfName.indexOf('&') != -1){
		cfName = cfName.replace(ampRegex, '&amp;');
	}
	*/
	if (currentCFFormType == 'CHOICE') {
		cfDefVal = '';
	}
	else if (currentCFFormType == 'INT') {
		if (jQuery('#customFieldMinVal').val().length > 0) {
			cfMinVal = jQuery('#customFieldMinVal').val();
		}
		if (jQuery('#customFieldMaxVal').val().length > 0) {
			cfMaxVal = jQuery('#customFieldMaxVal').val();
		}
	}
	else if (currentCFFormType == 'DATETIME') {
		cfDefVal = jQuery('#customFieldDefaultValue-DATETIMEDATE').val() + ' ' + jQuery('#customFieldDefaultValue-DATETIMETIME').val();
	}
	PanteraScript.PanteraScriptService.AddProjectCustomField(pjqSessionId, newProjRowId, cfName, cfDesc, cfSort, currentCFFormType, cfDefVal, cfMinVal, cfMaxVal, cfIsMultChoice, cfIsRequired, cfIsVisibleRSVP, ProjectCustomFieldSaved, onScriptError);
	var newCFRowData = [cfName, currentCFFormType, boolToInt(cfIsRequired), boolToInt(cfIsVisibleRSVP), cfSort];
	projectCustomFieldGrid.addRow(newProjRowId, newCFRowData, parseInt(cfSort) - 1);
	projectCustomFieldGrid.setUserData(newProjRowId, 'isAllowMultChoice', cfIsMultChoice.toString());
	projectCustomFieldGrid.setUserData(newProjRowId, 'defaultValue', cfDefVal);
	projectCustomFieldGrid.setUserData(newProjRowId, 'minValue', cfMinVal);
	projectCustomFieldGrid.setUserData(newProjRowId, 'maxValue', cfMaxVal);
	ChangeSortByOrder(projectCustomFieldGrid, 4);
}

function UpdateProjectCustomField(multiple, isInline, customFieldId, currentCustomFieldType) {
	var thisCFCId;
	var updateChoices = false;
	var cfName;
	var cfSort;
	var cfDefVal;
	var cfIsAllowMultChoice = false;
	var cfIsShowInList = false;
	var cfIsVisibleRSVP;
	var cfIsRequired;
	var cfMinVal;
	var cfMaxVal;
	var cfDesc;

	if (multiple) {
		for (var i = 0; i < projectCustomFieldGrid.getRowsNum(); i++) {
			thisCFCId = projectCustomFieldGrid.getRowId(i);
			cfcFormType = projectCustomFieldGrid.cells2(i, 1).getValue();
			cfName = projectCustomFieldGrid.cells2(i, 0).getValue();
			cfSort = projectCustomFieldGrid.cells2(i, 4).getValue();
			cfIsAllowMultChoice = (projectCustomFieldGrid.getUserData(thisCFCId, 'isAllowMultChoice').toLowerCase() === "true");
			cfDefVal = projectCustomFieldGrid.getUserData(thisCFCId, 'defaultValue');
			cfIsRequired = GridCboxIsChecked(projectCustomFieldGrid.cells2(i, 2).getValue());
			cfIsVisibleRSVP = GridCboxIsChecked(projectCustomFieldGrid.cells2(i, 3).getValue());
			cfMinVal = 0;
			cfMaxVal = 0;
			cfDesc = '';
			/*
			if(cfName.indexOf('&') != -1){
				cfName = cfName.replace(ampRegex, '&amp;');
			}
			*/
			if (cfcFormType == 'INT') {
				cfMinVal = projectCustomFieldGrid.getUserData(thisCFCId, 'minValue');
				cfMaxVal = projectCustomFieldGrid.getUserData(thisCFCId, 'maxValue');
			}
			PanteraScript.PanteraScriptService.UpdateProjectCustomField(pjqSessionId, thisCFCId, cfName, cfDesc, cfSort, cfcFormType, cfDefVal, cfMinVal, cfMaxVal, cfIsAllowMultChoice, cfIsVisibleRSVP, cfIsRequired, updateChoices, ProjectCustomFieldSaved, onScriptError);
		}
	}
	else if (isInline) {
		cfcFormType = projectCustomFieldGrid.cells(customFieldId, 1).getValue();
		cfName = projectCustomFieldGrid.cells(customFieldId, 0).getValue();
		cfSort = projectCustomFieldGrid.cells(customFieldId, 4).getValue();
		cfIsAllowMultChoice = (projectCustomFieldGrid.getUserData(thisCFCId, 'isAllowMultChoice').toLowerCase() === "true")
		cfDefVal = projectCustomFieldGrid.getUserData(customFieldId, 'defaultValue');
		cfIsRequired = GridCboxIsChecked(projectCustomFieldGrid.cells(customFieldId, 2).getValue());
		cfIsVisibleRSVP = GridCboxIsChecked(projectCustomFieldGrid.cells(customFieldId, 3).getValue());
		cfMinVal = 0;
		cfMaxVal = 0;
		cfDesc = '';
		/*
		if(cfName.indexOf('&') != -1){
			cfName = cfName.replace(ampRegex, '&amp;');
		}
		*/
		if (cfcFormType == 'INT') {
			cfMinVal = projectCustomFieldGrid.getUserData(customFieldId, 'minValue');
			cfMaxVal = projectCustomFieldGrid.getUserData(customFieldId, 'maxValue');
		}
		PanteraScript.PanteraScriptService.UpdateProjectCustomField(pjqSessionId, customFieldId, cfName, cfDesc, cfSort, cfcFormType, cfDefVal, cfMinVal, cfMaxVal, cfIsAllowMultChoice, cfIsVisibleRSVP, cfIsRequired, updateChoices, ProjectCustomFieldSaved, onScriptError);
	}
	else {
		updateChoices = true;
		cfName = jQuery('#customFieldName').val();
		cfSort = parseInt(jQuery('#customFieldSortOrder').val());
		cfDefVal = jQuery('#customFieldDefaultValue-' + currentCustomFieldType).val();
		cfIsRequired = jQuery('#projcfRequired').prop('checked');
		cfIsVisibleRSVP = jQuery('#projcfVisible').prop('checked');
		cfMinVal = 0;
		cfMaxVal = 0;
		cfDesc = '';
		/*
		if(cfName.indexOf('&') != -1){
			cfName = cfName.replace(ampRegex, '&amp;');
		}
		*/
		if (currentCustomFieldType == 'CHOICE') {
			cfIsAllowMultChoice = jQuery('#projcfIsMultChoice').prop('checked');
			cfDefVal = '';
		}
		else if (currentCustomFieldType == 'INT') {
			if (jQuery('#customFieldMinVal').val().length > 0) {
				cfMinVal = jQuery('#customFieldMinVal').val();
			}
			if (jQuery('#customFieldMaxVal').val().length > 0) {
				cfMaxVal = jQuery('#customFieldMaxVal').val();
			}
		}
		if (currentCustomFieldType == 'DATETIME') {
			cfDefVal = jQuery('#customFieldDefaultValue-DATETIMEDATE').val() + ' ' + jQuery('#customFieldDefaultValue-DATETIMETIME').val();
		}

		PanteraScript.PanteraScriptService.UpdateProjectCustomField(pjqSessionId, customFieldId, cfName, cfDesc, cfSort, currentCustomFieldType, cfDefVal, cfMinVal, cfMaxVal, cfIsAllowMultChoice, cfIsVisibleRSVP, cfIsRequired, updateChoices, ProjectCustomFieldSaved, onScriptError);
		projectCustomFieldGrid.cells(customFieldId, 0).setValue(cfName);
		projectCustomFieldGrid.cells(customFieldId, 1).setValue(currentCustomFieldType);
		projectCustomFieldGrid.cells(customFieldId, 2).setValue(cfIsRequired);
		projectCustomFieldGrid.cells(customFieldId, 3).setValue(cfIsVisibleRSVP);
		ChangeRowSortOrder(projectCustomFieldGrid, customFieldId, 4, cfSort);
		projectCustomFieldGrid.cells(customFieldId, 4).setValue(cfSort);
		projectCustomFieldGrid.setUserData(customFieldId, 'isAllowMultChoice', cfIsAllowMultChoice.toString());
		projectCustomFieldGrid.setUserData(customFieldId, 'defaultValue', cfDefVal);
		projectCustomFieldGrid.setUserData(customFieldId, 'minValue', cfMinVal);
		projectCustomFieldGrid.setUserData(customFieldId, 'maxValue', cfMaxVal);
	}
}

function AddUpdateProjectCustomFieldChoices(customFieldId) {
	for (i = 0; i < projectCustomFieldChoicesGrid.getRowsNum(); i++) {
		currentCFCRowId = projectCustomFieldChoicesGrid.getRowId(i);
		cfChoiceName = projectCustomFieldChoicesGrid.cells2(i, 0).getValue();
		cfChoiceSort = projectCustomFieldChoicesGrid.cells2(i, 1).getValue();
		/*
		if(cfChoiceName.indexOf('&') != -1){
			cfChoiceName = cfChoiceName.replace(ampRegex, '&amp;');
		}
		*/
		if (currentCFCRowId.indexOf('new') != -1) {
			PanteraScript.PanteraScriptService.AddProjectCustomFieldChoice(pjqSessionId, customFieldId, currentCFCRowId, cfChoiceName, cfChoiceSort, ProjectCustomFieldChoiceSaved, onScriptError);
		}
		else {
			PanteraScript.PanteraScriptService.UpdateProjectCustomFieldChoice(pjqSessionId, parseInt(customFieldId), parseInt(currentCFCRowId), cfChoiceName, parseInt(cfChoiceSort), ProjectCustomFieldChoiceSaved, onScriptError);
		}
	}
	projectCustomFieldChoicesGrid.destructor();
	ResetCustomFieldForm();
}

function AddAddressBookCustomField(grid, cfFormType) {
	var newabcfRowId = "newRow" + newRowCounter;
	var cfName = jQuery('#customFieldName').val();
	var cfSort = jQuery('#customFieldSortOrder').val();
	var sortRow = 5;
	var cfDefVal = jQuery('#customFieldDefaultValue-' + cfFormType).val();
	var cfIsShowInList = jQuery('#abcfShowInList').prop('checked');
	var cfIsAllowMultChoice = false;
	var cfIsVisibleRSVP = jQuery('#abcfRSVPEditable').prop('checked');
	var cfIsChangeRSVP = jQuery('#abcfRSVPEditable').prop('checked');
	var cfIsRequiredRSVP = jQuery('#abcfRSVPRequired').prop('checked');
	var cfIsShowInParticipantList = false; // jQuery('#abcfShowInParticipantList').prop('checked');
	var cfMinVal = 0;
	var cfMaxVal = 0;
	var cfDesc = '';
	/*
	if(cfName.indexOf('&') != -1){
		cfName = cfName.replace(ampRegex, '&amp;');
	}
	*/
	if (cfFormType == 'CHOICE') {
		cfIsAllowMultChoice = jQuery('#abcfIsMultChoice').prop('checked');
		cfDefVal = '';
	}
	else if (cfFormType == 'INT') {
		if (jQuery('#customFieldMinVal').val().length > 0) {
			cfMinVal = jQuery('#customFieldMinVal').val();
		}
		if (jQuery('#customFieldMaxVal').val().length > 0) {
			cfMaxVal = jQuery('#customFieldMaxVal').val();
		}
	}
	var newCFRowData;
	if (!cfDefVal)
		cfDefVal = '';
	if (grid == addressBookCompanyCustomFieldGrid) {
		PanteraScript.PanteraScriptService.AddCompanyCustomField(pjqSessionId, newabcfRowId, cfName, cfDesc, cfSort, cfFormType, cfDefVal, cfMinVal, cfMaxVal, cfIsAllowMultChoice, cfIsShowInList, cfIsVisibleRSVP, cfIsChangeRSVP, cfIsRequiredRSVP, cfIsShowInParticipantList, AddressBookCustomFieldsSaved, onScriptError);
		newCFRowData = [cfName, cfFormType, boolToInt(cfIsVisibleRSVP), boolToInt(cfIsRequiredRSVP), boolToInt(cfIsShowInParticipantList), cfSort];
	}
	else if (grid == addressBookContactCustomFieldGrid) {
		PanteraScript.PanteraScriptService.AddContactCustomField(pjqSessionId, newabcfRowId, cfName, cfDesc, cfSort, cfFormType, cfDefVal, cfMinVal, cfMaxVal, cfIsAllowMultChoice, cfIsShowInList, cfIsVisibleRSVP, cfIsChangeRSVP, cfIsRequiredRSVP, cfIsShowInParticipantList, AddressBookCustomFieldsSaved, onScriptError);
		newCFRowData = [cfName, cfFormType, boolToInt(cfIsVisibleRSVP), boolToInt(cfIsRequiredRSVP), boolToInt(cfIsShowInParticipantList), cfSort];
	}
	grid.addRow(newabcfRowId, newCFRowData, parseInt(cfSort) - 1);
	grid.setUserData(newabcfRowId, 'defaultValue', cfDefVal);
	grid.setUserData(newabcfRowId, 'minValue', cfMinVal);
	grid.setUserData(newabcfRowId, 'maxValue', cfMaxVal);
	grid.setUserData(newabcfRowId, 'isAllowMultChoice', cfIsAllowMultChoice.toString());
	grid.setUserData(newabcfRowId, 'isShowInList', cfIsShowInList.toString());
	ChangeSortByOrder(grid, sortRow);
}

function UpdateAddressBookCustomField(grid, multiple, isInline, customFieldId, currentCFFormType) {
	var updateChoices = false;
	var cfName;
	var cfSort;
	var cfDefVal;
	var cfIsShowInList;
	var cfIsAllowMultChoice = false;
	var cfIsVisibleRSVP;
	var cfIsChangeRSVP;
	var cfIsRequiredRSVP;
	var cfIsShowInParticipantList;
	var cfMinVal;
	var cfMaxVal;
	var cfDesc;
	var cfIsChoiceList = false;
	if (multiple) {
		for (i = 0; i < grid.getRowsNum(); i++) {
			var thisCFCId = grid.getRowId(i);
			cfcFormType = grid.cells2(i, 1).getValue();
			cfName = grid.cells2(i, 0).getValue();
			cfSort = grid.cells2(i, 5).getValue();
			cfDefVal = grid.getUserData(thisCFCId, 'defaultValue');
			cfIsShowInList = (grid.getUserData(thisCFCId, 'isShowInList').toLowerCase() == 'true');
			cfIsAllowMultChoice = (grid.getUserData(thisCFCId, 'isAllowMultChoice').toLowerCase() == 'true');
			cfIsChangeRSVP = GridCboxIsChecked(grid.cells2(i, 2).getValue());
			cfIsVisibleRSVP = GridCboxIsChecked(grid.cells2(i, 2).getValue());
			cfIsRequiredRSVP = GridCboxIsChecked(grid.cells2(i, 3).getValue());
			cfIsShowInParticipantList = GridCboxIsChecked(grid.cells2(i, 4).getValue());
			cfMinVal = 0;
			cfMaxVal = 0;
			cfDesc = '';
			/*
			if(cfName.indexOf('&') != -1){
				cfName = cfName.replace(ampRegex, '&amp;');
			}
			*/
			if (cfcFormType == 'CHOICE' && cfDefVal == '0') {
				cfDefVal = '';
			}
			if (cfcFormType == 'INT') {
				cfMinVal = grid.getUserData(thisCFCId, 'minValue');
				cfMaxVal = grid.getUserData(thisCFCId, 'maxValue');
			}
			if (grid == addressBookCompanyCustomFieldGrid) {
				PanteraScript.PanteraScriptService.UpdateCompanyCustomField(pjqSessionId, thisCFCId, cfName, cfDesc, cfSort, cfcFormType, cfDefVal, cfMinVal, cfMaxVal, cfIsAllowMultChoice, cfIsShowInList, cfIsVisibleRSVP, cfIsChangeRSVP, cfIsRequiredRSVP, cfIsShowInParticipantList, updateChoices, AddressBookCustomFieldsSaved, onScriptError);
			}
			else if (grid == addressBookContactCustomFieldGrid) {
				PanteraScript.PanteraScriptService.UpdateContactCustomField(pjqSessionId, thisCFCId, cfName, cfDesc, cfSort, cfcFormType, cfDefVal, cfMinVal, cfMaxVal, cfIsAllowMultChoice, cfIsShowInList, cfIsVisibleRSVP, cfIsChangeRSVP, cfIsRequiredRSVP, cfIsShowInParticipantList, updateChoices, AddressBookCustomFieldsSaved, onScriptError);
			}
		}
	}
	else if (isInline) {
		cfcFormType = grid.cells(customFieldId, 1).getValue();
		cfName = grid.cells(customFieldId, 0).getValue();
		cfSort = grid.cells(customFieldId, 5).getValue();
		cfDefVal = grid.getUserData(customFieldId, 'defaultValue');
		cfIsShowInList = (grid.getUserData(thisCFCId, 'isShowInList').toLowerCase() == 'true');
		cfIsAllowMultChoice = (grid.getUserData(thisCFCId, 'isAllowMultChoice').toLowerCase() == 'true');
		cfIsChangeRSVP = GridCboxIsChecked(grid.cells(customFieldId, 2).getValue());
		cfIsVisibleRSVP = GridCboxIsChecked(grid.cells(customFieldId, 2).getValue());
		cfIsRequiredRSVP = GridCboxIsChecked(grid.cells(customFieldId, 3).getValue());
		cfIsShowInParticipantList = GridCboxIsChecked(grid.cells(customFieldId, 4).getValue());
		cfMinVal = 0;
		cfMaxVal = 0;
		cfDesc = '';
		/*
		if(cfName.indexOf('&') != -1){
			cfName = cfName.replace(ampRegex, '&amp;');
		}
		*/
		if (cfcFormType == 'CHOICE' && cfDefVal == '0') {
			cfDefVal = '';
		}

		if (cfcFormType == 'INT') {
			cfMinVal = grid.getUserData(customFieldId, 'minValue');
			cfMaxVal = grid.getUserData(customFieldId, 'maxValue');
		}
		if (grid == addressBookCompanyCustomFieldGrid) {
			PanteraScript.PanteraScriptService.UpdateCompanyCustomField(pjqSessionId, customFieldId, cfName, cfDesc, cfSort, cfcFormType, cfDefVal, cfMinVal, cfMaxVal, cfIsAllowMultChoice, cfIsShowInList, cfIsVisibleRSVP, cfIsChangeRSVP, cfIsRequiredRSVP, cfIsShowInParticipantList, updateChoices, AddressBookCustomFieldsSaved, onScriptError);
		}
		else if (grid == addressBookContactCustomFieldGrid) {
			PanteraScript.PanteraScriptService.UpdateContactCustomField(pjqSessionId, customFieldId, cfName, cfDesc, cfSort, cfcFormType, cfDefVal, cfMinVal, cfMaxVal, cfIsAllowMultChoice, cfIsShowInList, cfIsVisibleRSVP, cfIsChangeRSVP, cfIsRequiredRSVP, cfIsShowInParticipantList, updateChoices, AddressBookCustomFieldsSaved, onScriptError);
		}
	}
	else {
		updateChoices = true;
		cfcFormType = jQuery('#abCustomFieldType').val();
		cfName = jQuery('#customFieldName').val();
		cfSort = jQuery('#customFieldSortOrder').val();
		cfDefVal = jQuery('#customFieldDefaultValue-' + cfcFormType).val();
		cfIsShowInList = jQuery('#abcfShowInList').prop('checked');
		cfIsChangeRSVP = jQuery('#abcfRSVPEditable').prop('checked');
		cfIsVisibleRSVP = jQuery('#abcfRSVPEditable').prop('checked');
		cfIsRequiredRSVP = jQuery('#abcfRSVPRequired').prop('checked');
		cfIsShowInParticipantList = jQuery('#abcfShowInParticipantList').prop('checked');
		cfMinVal = 0;
		cfMaxVal = 0;
		cfDesc = '';
		/*
		if(cfName.indexOf('&') != -1){
			cfName = cfName.replace(ampRegex, '&amp;');
		}
		*/
		if (cfcFormType == 'CHOICE') {
			cfIsAllowMultChoice = jQuery('#abcfIsMultChoice').prop('checked');
			if (cfDefVal == '0')
				cfDefVal = '';
		}
		else if (cfcFormType == 'INT') {
			if (jQuery('#customFieldMinVal').val().length > 0) {
				cfMinVal = jQuery('#customFieldMinVal').val();
			}
			if (jQuery('#customFieldMaxVal').val().length > 0) {
				cfMaxVal = jQuery('#customFieldMaxVal').val();
			}
		}
		if (grid == addressBookCompanyCustomFieldGrid) {
			PanteraScript.PanteraScriptService.UpdateCompanyCustomField(pjqSessionId, customFieldId, cfName, cfDesc, cfSort, cfcFormType, cfDefVal, cfMinVal, cfMaxVal, cfIsAllowMultChoice, cfIsShowInList, cfIsVisibleRSVP, cfIsChangeRSVP, cfIsRequiredRSVP, cfIsShowInParticipantList, updateChoices, AddressBookCustomFieldsSaved, onScriptError);
		}
		else if (grid == addressBookContactCustomFieldGrid) {
			PanteraScript.PanteraScriptService.UpdateContactCustomField(pjqSessionId, customFieldId, cfName, cfDesc, cfSort, cfcFormType, cfDefVal, cfMinVal, cfMaxVal, cfIsAllowMultChoice, cfIsShowInList, cfIsVisibleRSVP, cfIsChangeRSVP, cfIsRequiredRSVP, cfIsShowInParticipantList, updateChoices, AddressBookCustomFieldsSaved, onScriptError);
		}

		if (cfcFormType == 'CHOICE' && cfDefVal == '')
			cfDefVal = '0';

		grid.cells(customFieldId, 0).setValue(cfName);
		grid.cells(customFieldId, 1).setValue(cfcFormType);
		grid.cells(customFieldId, 2).setValue(cfIsChangeRSVP);
		grid.cells(customFieldId, 3).setValue(cfIsRequiredRSVP);
		grid.cells(customFieldId, 4).setValue(cfIsShowInParticipantList);
		grid.cells(customFieldId, 5).setValue(cfSort);
		grid.setUserData(customFieldId, 'isShowInList', cfIsShowInList.toString());
		grid.setUserData(customFieldId, 'isAllowMultChoice', cfIsAllowMultChoice.toString());
		grid.setUserData(customFieldId, 'defaultValue', cfDefVal);
		grid.setUserData(customFieldId, 'minValue', cfMinVal);
		grid.setUserData(customFieldId, 'maxValue', cfMaxVal);
	}
}

function AddUpdateAddressBookCustomFieldChoices(grid, customFieldId) {
	if (grid == addressBookCompanyCustomFieldGrid) {
		for (i = 0; i < addressBookCompanyCustomFieldChoicesGrid.getRowsNum(); i++) {
			currentCFCRowId = addressBookCompanyCustomFieldChoicesGrid.getRowId(i);
			cfChoiceName = addressBookCompanyCustomFieldChoicesGrid.cells2(i, 0).getValue();
			cfChoiceSort = addressBookCompanyCustomFieldChoicesGrid.cells2(i, 1).getValue();
			/*
			if(cfChoiceName.indexOf('&') != -1){
				cfChoiceName = cfChoiceName.replace(ampRegex, '&amp;');
			}
			*/
			if (currentCFCRowId.indexOf('new') != -1) {
				PanteraScript.PanteraScriptService.AddCompanyCustomFieldChoice(pjqSessionId, currentCFCRowId, customFieldId, cfChoiceName, cfChoiceSort, AddressBookCustomFieldChoiceSaved, onScriptError);
			}
			else {
				PanteraScript.PanteraScriptService.UpdateCompanyCustomFieldChoice(pjqSessionId, currentCFCRowId, customFieldId, cfChoiceName, cfChoiceSort, AddressBookCustomFieldChoiceSaved, onScriptError);
			}
		}
		addressBookCompanyCustomFieldChoicesGrid.destructor();
		ResetCustomFieldForm();
	}
	else if (grid == addressBookContactCustomFieldGrid) {
		for (i = 0; i < addressBookContactCustomFieldChoicesGrid.getRowsNum(); i++) {
			currentCFCRowId = addressBookContactCustomFieldChoicesGrid.getRowId(i);
			cfChoiceName = addressBookContactCustomFieldChoicesGrid.cells(currentCFCRowId, 0).getValue();
			cfChoiceSort = addressBookContactCustomFieldChoicesGrid.cells(currentCFCRowId, 1).getValue();
			/*
			if(cfChoiceName.indexOf('&') != -1){
				cfChoiceName = cfChoiceName.replace(ampRegex, '&amp;');
			}
			*/
			if (currentCFCRowId.indexOf('new') != -1) {
				PanteraScript.PanteraScriptService.AddContactCustomFieldChoice(pjqSessionId, currentCFCRowId, customFieldId, cfChoiceName, cfChoiceSort, AddressBookCustomFieldChoiceSaved, onScriptError);
			}
			else {
				PanteraScript.PanteraScriptService.UpdateContactCustomFieldChoice(pjqSessionId, currentCFCRowId, customFieldId, cfChoiceName, cfChoiceSort, AddressBookCustomFieldChoiceSaved, onScriptError);
			}
		}
		addressBookContactCustomFieldChoicesGrid.destructor();
		ResetCustomFieldForm();
	}

}

function ChangeRowSortOrder(grid, rowId, sortCol, newVal) {
	if (grid.cells(rowId, sortCol).getValue() != newVal) {
		for (i = 0; i < grid.getRowsNum(); i++) {
			var thisRowSort = parseInt(grid.cells2(i, sortCol).getValue());
			if (thisRowSort >= newVal) {
				grid.cells2(i, sortCol).setValue(thisRowSort + 1);
			}
		}
		grid.cells(rowId, sortCol).setValue(newVal);
		grid.sortRows(sortCol);
	}
}

function ProjectCustomFieldSaved(response) {
	var projCFResult = jQuery.parseJSON(response);
	var cfChoiceName;
	var cfChoiceSort;
	var cfId = projCFResult.RowId;
	var currentCFRowId = projCFResult.CurrentRowId;
	var currentCFCRowId;
	var currentRowIndex;
	if (currentCFRowId != null) {
		currentRowIndex = projectCustomFieldGrid.getRowIndex(currentCFRowId);
		projectCustomFieldGrid.setRowId(currentRowIndex, cfId);
	}
	if (projCFResult.FieldType == 'CHOICE' && projCFResult.UpdateChoices == true) {
		AddUpdateProjectCustomFieldChoices(cfId);
	}
	//customFieldDialog.dialog('destroy');
}

function ProjectCustomFieldChoiceSaved(response) {
	var projCFCResult = jQuery.parseJSON(response);
	var defaultValueId = jQuery('#customFieldDefaultValue-CHOICE').val();
	if (defaultValueId == projCFCResult.CurrentRowId) {
		projectCustomFieldGrid.setUserData(projCFCResult.CustomFieldId, 'defaultValue', projCFCResult.RowId);
		PanteraScript.PanteraScriptService.UpdateProjectCustomFieldDefaultValue(pjqSessionId, projCFCResult.CustomFieldId, projCFCResult.RowId, SettingSavedCallback, onScriptError);
	}
}

function AddressBookCustomFieldsSaved(response) {
	var abCFResult = jQuery.parseJSON(response);
	var cfChoiceName;
	var cfChoiceSort;
	var cfId = abCFResult.RowId;
	var currentCFRowId = abCFResult.CurrentRowId;
	var currentCFCRowId;
	var currentRowIndex;
	if (abCFResult.CustomFieldLocation == 'company' && currentCFRowId != null) {
		currentRowIndex = addressBookCompanyCustomFieldGrid.getRowIndex(currentCFRowId);
		addressBookCompanyCustomFieldGrid.setRowId(currentRowIndex, cfId);
	}
	else if (abCFResult.CustomFieldLocation == 'contact' && currentCFRowId != null) {
		currentRowIndex = addressBookContactCustomFieldGrid.getRowIndex(currentCFRowId);
		addressBookContactCustomFieldGrid.setRowId(currentRowIndex, cfId);
	}
	if (abCFResult.FieldType == 'CHOICE' && abCFResult.UpdateChoices == true) {
		if (abCFResult.CustomFieldLocation == 'company') {
			AddUpdateAddressBookCustomFieldChoices(addressBookCompanyCustomFieldGrid, cfId);
		}
		else if (abCFResult.CustomFieldLocation == 'contact') {
			AddUpdateAddressBookCustomFieldChoices(addressBookContactCustomFieldGrid, cfId);
		}
	}
	try {
		customFieldDialog.dialog('destroy');
	} catch (err) {
	}
}

function AddressBookCustomFieldChoiceSaved(response) {
	var abCFCResult = jQuery.parseJSON(response);
	var defaultValueId = jQuery('#customFieldDefaultValue-CHOICE').val();
	if (defaultValueId == abCFCResult.CurrentRowId && abCFCResult.CustomFieldLocation == 'company') {
		addressBookCompanyCustomFieldGrid.setUserData(abCFCResult.CustomFieldId, 'defaultValue', abCFCResult.RowId);
		//PanteraScript.PanteraScriptService.UpdateCompanyCustomFieldDefaultValue(pjqSessionId, abCFCResult.CustomFieldId, abCFCResult.RowId, SettingSavedCallback, onScriptError);
	}
	else if (defaultValueId == abCFCResult.CurrentRowId && abCFCResult.CustomFieldLocation == 'contact') {
		addressBookContactCustomFieldGrid.setUserData(abCFCResult.CustomFieldId, 'defaultValue', abCFCResult.RowId);
		PanteraScript.PanteraScriptService.UpdateContactCustomFieldDefaultValue(pjqSessionId, abCFCResult.CustomFieldId, abCFCResult.RowId, SettingSavedCallback, onScriptError);
	}
}


// VALIDATION & FORMATTING HELPER FUNCTIONS
function FormatCurrencyHelper(value) {
	var parsedValue = value.val().replace("$", "");
	parsedValue = parsedValue.replace(',', "");
	var formattedValue = parsedValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	value.val('$' + formattedValue);
}

function CheckDuplicateCustomFieldName(grid, rowId) {
	var fieldName = jQuery('#customFieldName');
	for (i = 0; i < grid.getRowsNum(); i++) {
		if (grid.cells2(i, 0).getValue().toLowerCase() == fieldName.val().toLowerCase()) {
			if (!fieldName.hasClass('pjq-input-error') && rowId == null | rowId == '' | grid.getRowId(i) != rowId) {
				fieldName.addClass('pjq-input-error');
				jQuery('#customFieldDialogForm').siblings('.ui-dialog-buttonpane').find(".ui-button:first").button('disable');
				fieldName.parent().append("<label for='customFieldName' class='pjq-errortext'><br />Name already exists!</label>");
				break;
			}
		}
		else {
			fieldName.siblings('.pjq-errortext').remove();
			fieldName.removeClass('pjq-input-error');
			jQuery('#customFieldDialogForm').siblings('.ui-dialog-buttonpane').find(".ui-button:first").button('enable');
		}
	}
}

function ValidateCustomFieldForm() {

	if (jQuery('#customFieldConstraintsGrid').is(":visible")) {
		for (var i = 0; i < customFieldConstraintsGrid.getRowsNum(); i++) {
			for (var j = 0; j < customFieldConstraintsGrid.getColumnCount(); j++) {
				customFieldConstraintsGrid.validateCell(customFieldConstraintsGrid.getRowId(i), j);
			}
		}

		if (jQuery('#customFieldConstraintsGrid .dhtmlx_validation_error').length > 0)
			return false;
	}

	var fieldName = jQuery('#customFieldName'),
		fieldType;
	if (!jQuery('#projectCustomFieldType').closest('tr').hasClass('pjq-settings-hidden')) {
		fieldType = jQuery('#projectCustomFieldType');
	}
	else if (!jQuery('#abCustomFieldType').closest('tr').hasClass('pjq-settings-hidden')) {
		fieldType = jQuery('#abCustomFieldType');
	}
	else if (!jQuery('#fieldReportCustomFieldType').closest('tr').hasClass('pjq-settings-hidden')) {
		fieldType = jQuery('#fieldReportCustomFieldType');
	}
	else if (!jQuery('#submittalCustomFieldType').closest('tr').hasClass('pjq-settings-hidden')) {
		fieldType = jQuery('#submittalCustomFieldType');
	}
	else if (!jQuery('#customFieldTableCustomFieldType').closest('tr').hasClass('pjq-settings-hidden')) {
		fieldType = jQuery('#customFieldTableCustomFieldType');
	}

	if (fieldName.val().trim().length == 0) {
		fieldName.addClass('pjq-input-error');
		fieldName.parent().append("<label for='customFieldName' class='pjq-errortext'><br />Name cannot be blank</label>");
		return false;
	}
	else if (fieldType != null && fieldType.val().trim() == "INT") {
		var intDefaultValField = jQuery('#customFieldDefaultValue-INT'),
			intMinValField = jQuery('#customFieldMinVal'),
			intMaxValField = jQuery('#customFieldMaxVal');
		if (intDefaultValField.val().trim().length > 0 && (intMinValField.val().trim().length > 0 || intMaxValField.val().trim().length > 0)) {
			var intDefaultVal = parseInt(intDefaultValField.val().trim()),
				intMinVal = parseInt(intMinValField.val().trim()),
				intMaxVal = parseInt(intMaxValField.val().trim());
			if (intDefaultVal < intMinVal || intDefaultVal > intMaxVal) {
				intDefaultValField.addClass('pjq-input-error');
				intDefaultValField.parent().append("<label for='customFieldName' class='pjq-errortext'><br />Must be in between max/min values</label>");
				return false;
			}
			else {
				intDefaultValField.removeClass('pjq-input-error');
				intDefaultValField.parent().find('.pjq-errortext').remove();
			}
		}
	}
	return true;
}

function SaveLockNav(input) {
	var currentSubTab = input.closest('.ui-tabs');
	jQuery('#mainSettingsTabs').tabs('disable').addClass('disabled-ui-tabs');
	currentSubTab.tabs('disable').addClass('disabled-ui-tabs');
	jQuery('#settingsSave').button('enable');
	jQuery('#settingsCancel').button('enable');
}

function SaveUnlockNav() {
	jQuery('#mainSettingsTabs').tabs('enable');
	jQuery('.disabled-ui-tabs').tabs('enable');
	jQuery('#settingsSave').button('disable');
	jQuery('#settingsCancel').button('disable');
}

var isSavePlanroomGeneralSettings = false;
var isSavePaymentSettings = false;
var isSavePaymentSettings = false;
var isSaveProfileSettings = false;
var isSaveOrderingSettings = false;
var isSaveProjectMessagingSettings = false;
var isSaveAddressBookSettings = false;

function SetSaveState(input) {
	isSavePaymentSettings = false;
	isSavePaymentSettings = false;
	isSaveProfileSettings = false;
	isSaveOrderingSettings = false;
	isSaveProjectMessagingSettings = false;
	isSaveAddressBookSettings = false;

	var thisTabId = input.closest('.ui-tabs-panel').attr('id').trim();
	switch (thisTabId) {
		case 'profileCompanyInfoSettingsTab':
			isSaveProfileSettings = true;
			break;
		case 'profilePaymentInfoSettingsTab':
			isSavePaymentSettings = true;
			break;
		case 'planroomGeneralSettingsTab':
			isSavePlanroomGeneralSettings = true;
			break;
		case 'planroomOrderingSettingsTab':
			isSaveOrderingSettings = true;
			break;
		case 'planroomProjectMessagingSettingsTab':
			isSaveProjectMessagingSettings = true;
			break;
		case 'addressBookGeneralSettingsTab':
			isSaveAddressBookSettings = true;
			break;

	}
}

function CancelSettings() {
	PanteraScript.PanteraScriptService.GetPJQSettingsSettings(pjqSessionId, GetPJQSettingsSettings, onScriptError);
	if (isSaveProfileSettings) {
		PanteraScript.PanteraScriptService.GetCompanyInfoSettings(pjqSessionId, GetCompanyInfo, onScriptError);
		isSaveProfileSettings = false;
	}
	if (isSavePaymentSettings) {
		PanteraScript.PanteraScriptService.GetPaymentInfoSettings(pjqSessionId, GetPaymentInfo, onScriptError);
		isSavePaymentSettings = false;
	}
	if (isSavePlanroomGeneralSettings) {
		PanteraScript.PanteraScriptService.GetPlanroomGeneralSettings(pjqSessionId, GetPlanroomSettings, onScriptError);
		isSavePlanroomGeneralSettings = false;
	}
	if (isSaveOrderingSettings) {
		PanteraScript.PanteraScriptService.GetPlanroomOrderingSettings(pjqSessionId, GetPlanroomOrdering, onScriptError);
		isSaveOrderingSettings = false;
	}
	if (isSaveProjectMessagingSettings) {
		PanteraScript.PanteraScriptService.GetPlanroomGeneralSettings(pjqSessionId, GetPlanroomSettings, onScriptError);
		isSaveProjectMessagingSettings = false;
	}
	if (isSaveAddressBookSettings) {
		PanteraScript.PanteraScriptService.GetPlanroomAddressBookSettings(pjqSessionId, GetAddressBookSettings, onScriptError);
		isSaveAddressBookSettings = false;
	}
	SaveUnlockNav();
}

var passwordResetDialog;

function ResetPasswordDialog() {
	passwordResetDialog = jQuery('#passwordResetDialog');
	var passCurrent = jQuery('#passwordInputCurrent').val();
	var passNew = jQuery('#passwordInputNew').val();
	var passNewConfirm = jQuery('#passwordInputNewConfirm').val();
	passwordResetDialog.removeClass(pjqHidden);
	passwordResetDialog.dialog({
		title: "Reset Password",
		modal: true,
		closeOnEscape: false,
		resizable: false,
		width: 350,
		dialogClass: 'passwordResetDialog',
		buttons: [{
			text: "Save",
			click: function () {
				//ResetPassword();
				var passCurrent = jQuery('#passwordInputCurrent');
				var passNew = jQuery('#passwordInputNew');
				var passNewConfirm = jQuery('#passwordInputNewConfirm');
				var passResetError = jQuery('#passwordResetError');
				var resetValidate = PasswordResetValid(passCurrent.val(), passNew.val(), passNewConfirm.val());
				if (resetValidate == 0) {
					passCurrent.css('background', 'inherit');
					passNew.css('background', '#FFBFBF');
					passNewConfirm.css('background', '#FFBFBF');
					passResetError.text('');
					passResetError.text('New & confirm passwords do not match.');
				}
				else if (resetValidate == 1) {
					//Current pass same as new pass
					passCurrent.css('background', '#FFBFBF');
					passNew.css('background', '#FFBFBF');
					passNewConfirm.css('background', '#FFBFBF');
					passResetError.text('');
					passResetError.text('New password cannot be the same as the current password.');
				}
				else if (resetValidate == 2) {
					//Current pass correct & new pass matches confirm pass
					PanteraScript.PanteraScriptService.ResetPassword(pjqSessionId, passCurrent.val(), passNew.val(), ResetPasswordCallback, onScriptError);
				}
			}
		}, {
			text: "Cancel",
			click: function () {
				var passResetError = jQuery('#passwordResetError');
				passwordResetDialog.dialog('destroy');
				jQuery('#passwordInputCurrent').val('');
				jQuery('#passwordInputNew').val('');
				jQuery('#passwordInputNewConfirm').val('');
				jQuery('#passwordResetError').text('');
				jQuery('#passwordInputCurrent').css('background', 'inherit');
				jQuery('#passwordInputNew').css('background', 'inherit');
				jQuery('#passwordInputNewConfirm').css('background', 'inherit');
			}
		}]
	})

}

function PasswordResetValid(currentPass, newPass, confirmPass) {
	if (newPass != confirmPass) {
		return 0;
	}
	if (currentPass == newPass) {
		return 1;
	}
	else {
		return 2;
	}
}

function ResetPasswordCallback(response) {
	if (response) {
		var buttonPane = jQuery('.passwordResetDialog').find('.ui-dialog-buttonpane');
		buttonPane.hide();
		jQuery('#passwordResetTable').addClass(pjqHidden);
		jQuery('#passwordResetSuccess').removeClass(pjqHidden);
		jQuery('#passwordInputCurrent').val('');
		jQuery('#passwordInputNew').val('');
		jQuery('#passwordInputNewConfirm').val('');
		jQuery('#passwordResetError').text('');
		setTimeout(function () {
			passwordResetDialog.dialog('destroy');
			jQuery('#passwordResetTable').removeClass(pjqHidden);
			jQuery('#passwordResetSuccess').addClass(pjqHidden);
			buttonPane.show();
		}, 2000)
	}
	else {
		jQuery('#passwordInputCurrent').css('background', '#FFBFBF');
		jQuery('#passwordResetError').text('Current password is incorrect.');
	}
}

function ResetPasswordInputError() {
	jQuery('#passwordInputCurrent').css('background', 'inherit');
	jQuery('#passwordInputNew').css('background', 'inherit');
	jQuery('#passwordInputNewConfirm').css('background', 'inherit');
	jQuery('#passwordResetError').text('');
}

function IllegalCharacterDialog(character, replacedWith) {
	jQuery('#illegalCharDialog').removeClass(pjqHidden);
	jQuery('#illegalChar').text(character);
	jQuery('#charReplacedWith').text(replacedWith);
	jQuery('#illegalCharDialog').dialog({
		title: "Illegal Character",
		modal: true,
		resizable: false,
		dialogClass: 'illegalCharDialog',
		buttons: [{
			text: "Ok",
			click: function () {
				jQuery(this).dialog('destroy');
			}
		}]
	})
}

//Facebook API
var linkFBStatus;
var linkFBButton;
var unlinkFBButton

function GetSocialMediaStatus(response) {
	socialMediaResult = jQuery.parseJSON(response);
	linkFBStatus = jQuery('#facebookStatus');
	linkFBButton = jQuery('#linkFacebook');
	unlinkFBButton = jQuery('#unlinkFacebook');
	linkFBButton.button();
	unlinkFBButton.button();
	if (socialMediaResult.IsFacebookRegistered) {
		unlinkFBButton.removeClass(pjqHidden);

		linkFBStatus.text('Linked');
		linkFBStatus.css('color', '#2BCA00');
	}
	else {
		linkFBButton.removeClass(pjqHidden);
		linkFBStatus.text('Not Linked');
		linkFBStatus.css('color', '#FF2C2C');
	}
}

function CheckFbLoginState() {
	FB.getLoginStatus(function (loginStatus) {
		if (loginStatus.status == 'connnected') {
			FB.api('/me?fields=token_for_business', function (apiResponse) {
				LinkSocialMedia(apiResponse);
			});
		}
		else {
			FB.login(function (loginStatus) {
				if (loginStatus.status == 'connected') {
					FB.api('/me?fields=token_for_business', function (apiResponse) {
						LinkSocialMedia(apiResponse);
					});
				}
			}, {
				scope: 'public_profile,email'
			});
		}
	});
}

var fbUserId;
var fbUserToken;

function LinkSocialMedia(response) {
	fbUserId = response.id;
	fbUserToken = response.token_for_business
	PanteraScript.PanteraScriptService.LinkLoggedInSocialMediaUser(pjqSessionId, 'facebook', fbUserId, fbUserToken, SocialMediaLinked, onScriptError);
}

function SocialMediaLinked(response) {
	var linkResult = jQuery.parseJSON(response);
	if (linkResult.MediaSource == 'facebook' && linkResult.Status == 0) {
		linkFBStatus.text('Linked');
		linkFBStatus.css('color', '#2BCA00');
		unlinkFBButton.removeClass(pjqHidden);
		linkFBButton.addClass(pjqHidden);
	}
	else {
		SocialMediaUserExists('facebook', fbUserId);
	}
}

function SocialMediaUserExists(source, smUserId) {
	jQuery('#fbUserExistsDialog').removeClass(pjqHidden);
	jQuery('#fbUserExistsDialog').text('This Facebook user is already linked to another plan room account.  Would you like to disconnect it login and connect it to this account instead?');
	jQuery('#fbUserExistsDialog').dialog({
		title: "Facebook User Already Linked",
		modal: true,
		closeOnEscape: false,
		resizable: false,
		dialogClass: 'fbUserExistsDialog',
		buttons: [{
			text: "Confirm",
			click: function () {
				PanteraScript.PanteraScriptService.UnlinkLoggedInSocialMediaUser(pjqSessionId, 'facebook', smUserId, ExistingSocialMediaUnlinked, onScriptError);
			}
		}, {
			text: "Cancel",
			click: function () {
				jQuery(this).dialog('destroy');
			}
		}]
	})
}

function ExistingSocialMediaUnlinked(response) {
	var unlinkResult = jQuery.parseJSON(response);
	if (unlinkResult.MediaSource == 'facebook') {
		PanteraScript.PanteraScriptService.LinkLoggedInSocialMediaUser(pjqSessionId, 'facebook', fbUserId, fbUserToken, SocialMediaLinked, onScriptError);
		jQuery('#fbUserExistsDialog').dialog('destroy');
	}
}

function UnlinkSocialMedia(source) {
	var thisTitle = '';
	if (source == 'facebook') {
		thisTitle = "Unlink Facebook";
	}
	jQuery('#socialMediaDialog').dialog({
		title: thisTitle,
		modal: true,
		closeOnEscape: false,
		resizable: false,
		width: "auto",
		dialogClass: 'unlinkSocialMediaDialog',
		buttons: [{
			text: "Confirm",
			click: function () {
				PanteraScript.PanteraScriptService.UnlinkSocialMediaUser(pjqSessionId, source, SocialMediaUnlinked, onScriptError);
				jQuery('#socialMediaDialog').addClass(pjqHidden);
				jQuery(this).dialog('destroy');
			}
		}, {
			text: "Cancel",
			click: function () {
				jQuery('#socialMediaDialog').addClass(pjqHidden);
				jQuery(this).dialog('destroy');
			}
		}]
	})
	jQuery('#socialMediaDialog').removeClass(pjqHidden);
}

function SocialMediaUnlinked(response) {
	var unlinkResult = jQuery.parseJSON(response);
	if (unlinkResult.MediaSource == 'facebook' && unlinkResult.Status == 0) {
		linkFBStatus.text('Not Linked');
		linkFBStatus.css('color', '#FF2C2C');
		unlinkFBButton.addClass(pjqHidden);
		linkFBButton.removeClass(pjqHidden);
	}
}

function UnlinkExternalApp(source) //"procore"
{
	var thisTitle = '';
	if (source == 'procore') {
		thisTitle = "Unlink Procore";
	}
	jQuery('#externalAppDialog').dialog({
		title: thisTitle,
		modal: true,
		closeOnEscape: false,
		resizable: false,
		width: "auto",
		dialogClass: 'unlinkExternalAppDialog',
		buttons: [{
			text: "Confirm",
			click: function () {
				PanteraScript.PanteraScriptService.UnlinkExternalApp(pjqSessionId, 'procore', ExternalAppUnlinked, onScriptError);
				jQuery('#externalAppDialog').addClass(pjqHidden);
				jQuery(this).dialog('destroy');
			}
		}, {
			text: "Cancel",
			click: function () {
				jQuery('#externalAppDialog').addClass(pjqHidden);
				jQuery(this).dialog('destroy');
			}
		}]
	})
	jQuery('#externalAppDialog').removeClass(pjqHidden);
}

function ExternalAppUnlinked(response) {
	var unlinkResult = jQuery.parseJSON(response);
	if (unlinkResult.MediaSource == 'procore' && unlinkResult.Status == 0) {
		linkProcoreStatus.text('Not Linked');
		linkProcoreStatus.css('color', '#FF2C2C');
		unlinkProcoreButton.addClass(pjqHidden);
		linkProcoreButton.removeClass(pjqHidden);
	}
}

//Helper functions
function IsChecked(cBox) {
	if (jQuery(cBox).is(":checked")) {
		return true;
	}
	else {
		return false;
	}
}

function GridCboxIsChecked(cboxVal) {
	if (cboxVal == 1) {
		return true;
	}
	else {
		return false;
	}
}

function GridCboxIsCheckedString(cboxVal) {
	if (cboxVal == 1) {
		return "true";
	}
	else {
		return "false";
	}
}

function CheckForDefaultTab() {
	var sTab = window.location.search.split('&');
	if (sTab.length > 1) {
		var sTabFormatted = sTab[1].replace('stab=', '');
		if (sTabFormatted == 'additionalinfo') {
			jQuery('#profileSettingsSubTabs').tabs('option', 'active', 1);
		}
		else if (sTabFormatted == 'refs') {
			jQuery('#profileSettingsSubTabs').tabs('option', 'active', 0);
		}
		else if (sTabFormatted == 'photos') {
			jQuery('#profileSettingsSubTabs').tabs('option', 'active', 3);
		}
	}
}

function SortAddressBookGroupsAlphanumeric() {
	DisableToolBarButton(tbAddressBookGroupsGrid, 'sortAlpha');
	if (addressBookGroupLevels.val() == 1) {
		PanteraScript.PanteraScriptService.SortAddressBookGroupsAlpha(pjqSessionId, GroupsSortedResponse, onScriptError);
	}
	else {
		PanteraScript.PanteraScriptService.SortAddressBookGroupsByDescriptionAlpha(pjqSessionId, GroupsSortedResponse, onScriptError);
	}
}

function GroupsSortedResponse(response) {
	addressBookGroupsGrid.clearAndLoad("/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=AbGroups&customFieldid=0", "xml");
	EnableToolBarButton(tbAddressBookGroupsGrid, 'sortAlpha');
}

function ChangeSortByOrder(grid, sortCol) {
	var statusCounter = 1;
	for (var i = 0; i < grid.getRowsNum(); i++) {
		grid.cells2(i, sortCol).setValue(statusCounter);
		statusCounter++;
	}
	ArrangeGridBySortOrder(grid, sortCol);
}

function ArrangeGridBySortOrder(grid, sortCol) {
	grid.sortRows(sortCol, 'int', 'asc');
}

function CheckCustomFieldGridRowsCount(grid) {
	var lockAdd = false;
	if (grid.getRowsNum() == 50) {
		lockAdd = true;
	}
	if (lockAdd) {
		switch (grid) {
			case projectCustomFieldGrid:
				DisableToolBarButton(tbProjectCustomFieldGrid, 'add');
				break;
			case addressBookCompanyCustomFieldGrid:
				DisableToolBarButton(tbAddressBookCompanyCustomFieldGrid, 'add');
				break;
			case addressBookContactCustomFieldGrid:
				DisableToolBarButton(tbAddressBookContactCustomFieldGrid, 'add');
				break;
		}
	}
	else {
		switch (grid) {
			case projectCustomFieldGrid:
				EnableToolBarButton(tbProjectCustomFieldGrid, 'add');
				break;
			case addressBookCompanyCustomFieldGrid:
				EnableToolBarButton(tbAddressBookCompanyCustomFieldGrid, 'add');
				break;
			case addressBookContactCustomFieldGrid:
				EnableToolBarButton(tbAddressBookContactCustomFieldGrid, 'add');
				break;
		}
	}
}

function CheckGroupsHaveParents() {
	if (addressBookGroupLevels.val() != 1) {
		var loopRowId;
		for (gr = 0; gr < addressBookGroupsGrid.getRowsNum(); gr++) {
			loopRowId = addressBookGroupsGrid.getRowId(gr);
			if (addressBookGroupsGrid.cells(loopRowId, 1).getValue() == "No Parent" || addressBookGroupsGrid.cells(loopRowId, 1).getValue() == "No Parent > No Parent") {
				addressBookGroupsGrid.cells(loopRowId, 1).setValue("");
			}
			//else if (addressBookGroupsGrid.cells(loopRowId, 1).getValue() == "") {
			//	UpdateAddressBookGroup(loopRowId, 0, 2, "old", "new");
			//}
		}
	}
	else {
		return;
	}
}

function FormatGroupContainers() {
	if (addressBookGroupLevels.val() != 1) {
		var loopRowId;
		for (f = 0; f < addressBookGroupsGrid.getRowsNum(); f++) {
			loopRowId = addressBookGroupsGrid.getRowId(f);
			if (addressBookGroupsGrid.cells(loopRowId, 1).getValue() == "") {
				addressBookGroupsGrid.setRowTextStyle(loopRowId, "color:rgb(135, 135, 135);font-style:italic");
			}
			else {
				addressBookGroupsGrid.setRowTextStyle(loopRowId, "color:#000;font-style:inherit");
			}
		}
	}
}

function AddNewTreeNode(tree, location, parentId) {
	var newItemId = "newNode" + newNodeCounter;
	if (location == 'parent') {
		tree.insertNewChild('abGroupsTree', newItemId, "", 0, 0, 0, 0, 'SELECT');
	}
	else if (location == 'child') {
		tree.insertNewChild(parentId, newItemId, "", 0, 0, 0, 0, 'SELECT');
	}
	else if (location == 'sibling') {
		tree.insertNewChild(parentId, newItemId, "", 0, 0, 0, 0, 'SELECT');
	}
	EditTreeNode(tree, newItemId);
	newNodeCounter++;
}

function EditTreeNode(tree, itemId) {
	tree.editItem(itemId);
}

function DeleteTreeItem(tree, id) {
	var item = tree.getSelectedItemId();
	switch (id) {
		case 'selected':
			if (tree == addressBookGroupsGroupsTree) {
				item = tree.getSelectedItemId();
			}
			break;
		default:
			item = id;
			break;
	}
	tree.deleteItem(item);
	UpdateAddressBookGroupsGroups(3);
}

function EnableToolBarButton(toolbar, button) {
	toolbar.enableItem(button);
}

function DisableToolBarButton(toolbar, button) {
	toolbar.disableItem(button);
}

function InitMergeDialog(type) {
	if (type == 'groups') {
		var selGroups = addressBookGroupsGrid.getSelectedRowId().split(',');
		for (var g = 0; g < selGroups.length; g++) {
			var thisGroup = addressBookGroupsGrid.cells(parseInt(selGroups[g]), 0).getValue();
			jQuery('#mergeGroupsSelect').append('<option value="' + selGroups[g] + '">' + thisGroup + '</option>');
		}
		jQuery('.mergeGroups').show();
	}
	else if (type == 'regions') {
		var selRegions = addressBookRegionsGrid.getSelectedRowId().split(',');
		for (var g = 0; g < selRegions.length; g++) {
			var thisRegion = addressBookRegionsGrid.cells(parseInt(selRegions[g]), 0).getValue();
			jQuery('#mergeRegionsSelect').append('<option value="' + selRegions[g] + '">' + thisRegion + '</option>');
		}
		jQuery('.mergeRegions').show();
	}

	jQuery('#mergeDialog').dialog({
		title: "Merge " + type,
		modal: true,
		closeOnEscape: false,
		resizable: false,
		width: 'auto',
		dialogClass: 'mergeDialog',
		buttons: [{
			text: "Merge",
			click: function () {
				if (type == 'groups') {
					MergeGroups();
				}
				else if (type == 'regions') {
					MergeRegions();
				}
			}
		}, {
			text: "Cancel",
			click: function () {
				jQuery('#mergeDialog').dialog('close');
			}
		}],
		open: function (event, ui) {
			jQuery('.mergeDialog').find('.ui-dialog-buttonset').children('button:first-child').button('disable');
			if (type == 'groups') {
				jQuery('#mergeGroupsSelect').on('change', function () {
					if (jQuery(this).val().length > 0) {
						jQuery('.mergeDialog').find('.ui-dialog-buttonset').children('button:first-child').button('enable');
					}
					else {
						jQuery('.mergeDialog').find('.ui-dialog-buttonset').children('button:first-child').button('disable');
					}
				})
			}
			else if (type == 'regions') {
				jQuery('#mergeRegionsSelect').on('change', function () {
					if (jQuery(this).val().length > 0) {
						jQuery('.mergeDialog').find('.ui-dialog-buttonset').children('button:first-child').button('enable');
					}
					else {
						jQuery('.mergeDialog').find('.ui-dialog-buttonset').children('button:first-child').button('disable');
					}
				})
			}

		},
		close: function (event, ui) {
			jQuery('#mergeGroupsSelect').empty();
			jQuery('#mergeGroupsSelect').append('<option value="">Select...</option>');
			jQuery('#mergeRegionsSelect').empty();
			jQuery('#mergeRegionsSelect').append('<option value="">Select...</option>');
			jQuery('.mergeGroups').hide();
			jQuery('.mergeGroupContainers').hide();
			jQuery('.mergeRegions').hide();
		}
	})
}

function MergeGroups() {
	var selGroups = addressBookGroupsGrid.getSelectedRowId().split(',');
	var selectedMergeGroup = parseInt(jQuery('#mergeGroupsSelect').val());
	PanteraScript.PanteraScriptService.MergeAddressBookGroups(selGroups.join('|'), selectedMergeGroup, MergeGroupsC, onScriptError);
	//var contactCount = 0;
	for (var g = 0; g < selGroups.length; g++) {
		//contactCount += parseInt(addressBookGroupsGrid.cells(selGroups[g], 2).getValue());
		if (parseInt(selGroups[g]) != selectedMergeGroup) {
			addressBookGroupsGrid.deleteRow(parseInt(selGroups[g]));
		}
	}
	//addressBookGroupsGrid.cells(selectedMergeGroup, 4).setValue(contactCount);
	ChangeSortByOrder(addressBookGroupsGrid, 2);
	//UpdateAddressBookGroup('allgroups');
}

function MergeGroupsC(response) {
	jQuery('#mergeDialog').dialog('close');
	tbAddressBookGroupsGrid.disableItem('merge');
}

function MergeRegions() {
	var selRegions = addressBookRegionsGrid.getSelectedRowId().split(',');
	var selectedMergeRegion = parseInt(jQuery('#mergeRegionsSelect').val());
	PanteraScript.PanteraScriptService.MergeAddressBookRegions(selRegions.join('|'), selectedMergeRegion, MergeRegionsC, onScriptError);
	for (var r = 0; r < selRegions.length; r++) {
		if (parseInt(selRegions[r]) != selectedMergeRegion) {
			addressBookRegionsGrid.deleteRow(parseInt(selRegions[r]));
		}
	}
	ChangeSortByOrder(addressBookRegionsGrid, 1);
}

function MergeRegionsC(response) {
	jQuery('#mergeDialog').dialog('close');
}

function copyPaymentInfoFromCompanyInfo() {
	jQuery('#profilePaymentCompanyName').val(jQuery('#profileCompanyName').val());
	jQuery('#profilePaymentCardholderName').val(jQuery('#profileContactName').val());
	jQuery('#profilePaymentAddress1').val(jQuery('#profileAddress1').val());
	jQuery('#profilePaymentAddress2').val(jQuery('#profileAddress2').val());
	jQuery('#profilePaymentCity').val(jQuery('#profileCity').val());
	jQuery('#profilePaymentState').val(jQuery('#profileState').val());
	jQuery('#profilePaymentCountry').val(jQuery('#profileCountry').val());
	jQuery('#profilePaymentZip').val(jQuery('#profileZip').val());
	jQuery('#profilePaymentPhone').val(jQuery('#profilePhone').val());
	jQuery('#profilePaymentExtension').val(jQuery('#profileExtension').val());
	jQuery('#profilePaymentCompanyName').trigger('change');
}

function FormatPhoneHelper(value, isUnformat) {
	if (typeof value != 'undefined') {
		var phoneFormatted;
		value = value.replace('(', '');
		value = value.replace(')', '');
		value = value.replace(/-/g, '');
		value = value.replace(' ', '');
		value = value.replace('/', '');
		if (isUnformat) {
			return value;
		}
		if (value.toLowerCase() == 'na')
			phoneFormatted = 'N/A';
		else if (value.length != 0) {
			phoneFormatted = '(' + value.substring(0, 3) + ') ' + value.substring(3, 6) + '-' + value.substring(6, 10);
		}
		else {
			phoneFormatted == '';
		}
		return phoneFormatted;
	}
	else {
		return '';
	}
}

function CheckProcoreLoginState() {
	var url = companyInfo.ProCoreURL + '/oauth/authorize?response_type=code&client_id=' + companyInfo.ProCoreClientId + '&redirect_uri=' + encodeURIComponent(companyInfo.ProCoreClientRedirect);
	document.location = url;

}

var tbCFTCustomFields = null, cftCustomFieldsGrid = null, customFieldTableEntity = null,
	customFieldTableCustomFieldId = null, isManageCustomFieldTable = false, cftCustomFieldGridMenu = null;

function CustomFieldTableGridInitialize(entity, customFieldId) {
	customFieldTableEntity = entity.toLowerCase();
	customFieldTableCustomFieldId = customFieldId;
	cftCustomFieldGridMenu = new dhtmlXMenuObject('gridMenu');
	cftCustomFieldGridMenu.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/");
	cftCustomFieldGridMenu.renderAsContextMenu();
	cftCustomFieldGridMenu.attachEvent("onClick", function (id, zoneId) {
		onGridMenuButtonClick(cftCustomFieldsGrid, zoneId, id);
	});
	cftCustomFieldGridMenu.loadXMLString(menuXML);

	tbCFTCustomFields = new dhtmlXToolbarObject("toolbarFieldReportCFTCustomFields");
	tbCFTCustomFields.setSkin("dhx_web");
	tbCFTCustomFields.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
	tbCFTCustomFields.addButton('add', 0, 'Add', "new.gif", "new_dis.gif");
	tbCFTCustomFields.addButton('edit', 1, 'Edit', "Edit.jpg", "EditD.jpg");
	tbCFTCustomFields.addButton('delete', 4, 'Delete', "Delete.png", "DeleteD.png");
	tbCFTCustomFields.disableItem('edit');
	tbCFTCustomFields.disableItem('delete');
	tbCFTCustomFields.attachEvent("onClick", function (id) {
		switch (id) {
			case 'add':
				CreateAddEditCustomFieldForm(cftCustomFieldsGrid, 'add');
				break;
			case 'edit':
				CreateAddEditCustomFieldForm(cftCustomFieldsGrid, 'edit', cftCustomFieldsGrid.getSelectedRowId());
				break;
			case 'delete':
				var selRow = cftCustomFieldsGrid.getSelectedRowId();
				var cftCFCName;
				var deleteType;
				if (selRow.indexOf(',') == -1) {
					cftCFCName = cftCustomFieldsGrid.cells(selRow, 0).getValue();
					deleteType = 'delete';
				}
				else {
					deleteType = 'deleteMultiple';
					cftCFCName = null;
				}
				CreateDialog(cftCustomFieldsGrid, deleteType, cftCFCName, selRow);
				break;
		}
	});

	cftCustomFieldsGrid = new dhtmlXGridObject('gridFieldReportCFTCustomFields');
	cftCustomFieldsGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	cftCustomFieldsGrid.setSkin(pjqGridTheme);
	cftCustomFieldsGrid.enableAutoHeight(true);
	cftCustomFieldsGrid.enableContextMenu(cftCustomFieldGridMenu);
	cftCustomFieldsGrid.setHeader("Name,Type,Width,Required,Sort");
	cftCustomFieldsGrid.setInitWidthsP("50,20,10,10,10");
	cftCustomFieldsGrid.setColAlign("center,center,center,center,center");
	cftCustomFieldsGrid.setColTypes("ro,ro,edn,ch,edn");
	cftCustomFieldsGrid.setColSorting("na,na,na,na,na");
	cftCustomFieldsGrid.init();
	cftCustomFieldsGrid.attachEvent("onEditCell", function (stage, rId, cInd, nValue, oValue) {
		if (stage == 1) {
			UpdateCustomFieldTableCustomField(false, true, rId);
		}
		return true;
	});
	cftCustomFieldsGrid.attachEvent("onRowDblClicked", function (rId, cInd) {
		CreateAddEditCustomFieldForm(cftCustomFieldsGrid, 'edit', rId);
	});
	cftCustomFieldsGrid.attachEvent("onXLE", function (grid_obj, count) {
		//jQuery('.projectCustomFieldsGridContainer').removeClass(pjqHidden);
		CheckCustomFieldGridRowsCount(cftCustomFieldsGrid);
	});

	cftCustomFieldsGrid.attachEvent("onBeforeContextMenu", function (id, ind, obj) {
		cftCustomFieldsGrid.selectRowById(id, false, false, true);
		return true;
	});
	cftCustomFieldsGrid.attachEvent("onRowSelect", function (id, ind) {
		EnableToolBarButton(tbCFTCustomFields, 'edit');
		EnableToolBarButton(tbCFTCustomFields, 'delete');
	});
	cftCustomFieldsGrid.attachEvent("onDrop", function (id, ind, obj) {
		ChangeSortByOrder(cftCustomFieldsGrid, 4);
		UpdateCustomFieldTableCustomField(true, false);
	});
	cftCustomFieldsGrid.attachEvent("onRowAdded", function (rId, rObj, rXml) {
		CheckCustomFieldGridRowsCount(cftCustomFieldsGrid);
	});

	switch (customFieldTableEntity) {
		case 'fieldreport':
			jQuery('#fieldReportSettingsMain').hide();
			jQuery('#fieldReportSettingsCustomFieldTableFields').show();
			jQuery('#fieldReportCFTReturn').button();
			jQuery('#fieldReportCFTHeaderFieldReportType').text(fieldReportsGrid.cells(fieldReportsGrid.getSelectedRowId(), 0).getValue());
			jQuery('#fieldReportCFTHeaderTableName').text(fieldReportCustomFieldsGrid.cells(customFieldId, 0).getValue());
			cftCustomFieldsGrid.load("/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=FieldReportCFTList&customFieldid=" + customFieldId.toString(), "xml");
			break;
	}
}

function customFieldTableReturn() {
	switch (customFieldTableEntity) {
		case 'fieldreport':
			jQuery('#fieldReportSettingsMain').show();
			jQuery('#fieldReportSettingsCustomFieldTableFields').hide();
			break;
	}
}

function AddCustomFieldTableCustomField(currentCFFormType) {

	var newRowId = "newRow" + newRowCounter;
	var cfName = jQuery('#customFieldName').val();
	var cfSort = jQuery('#customFieldSortOrder').val();
	var cfDefVal = jQuery('#customFieldDefaultValue-' + currentCFFormType).val();
	var cfIsShowInList;
	var cfIsMultChoice = jQuery('#customFieldTablecfIsMultChoice').prop('checked');
	var cfIsRequired = jQuery('#customFieldTablecfRequired').prop('checked');
	var cfWidth = parseInt(jQuery('#customFieldTablecfWidthPercent').val());
	var cfMinVal = 0;
	var cfMaxVal = 0;
	var cfDesc = '';
	if (currentCFFormType == 'CHOICE') {
		cfDefVal = '';
	}
	else if (currentCFFormType == 'INT') {
		if (jQuery('#customFieldMinVal').val().length > 0) {
			cfMinVal = jQuery('#customFieldMinVal').val();
		}
		if (jQuery('#customFieldMaxVal').val().length > 0) {
			cfMaxVal = jQuery('#customFieldMaxVal').val();
		}
	}
	else if (currentCFFormType == 'DATETIME') {
		cfDefVal = jQuery('#customFieldDefaultValue-DATETIMEDATE').val() + ' ' + jQuery('#customFieldDefaultValue-DATETIMETIME').val();
	}
	else if (currentCFFormType.indexOf('-LIST') != -1 || currentCFFormType == 'WEATHER' || currentCFFormType == 'CUSTOMFIELDTABLE') {
		cfDefVal = '';
	}
	PanteraScript.PanteraScriptService.AddCustomFieldTableCustomField(pjqSessionId, newRowId, 'FieldReport', customFieldTableCustomFieldId, cfName, cfDesc, cfSort, currentCFFormType, cfDefVal, cfMinVal, cfMaxVal, cfIsMultChoice, cfIsRequired, cfWidth, CustomFieldTableCustomFieldSaved, onScriptError);
	var newCFRowData = [cfName, currentCFFormType, cfWidth, boolToInt(cfIsRequired), cfSort];
	cftCustomFieldsGrid.addRow(newRowId, newCFRowData, parseInt(cfSort) - 1);
	cftCustomFieldsGrid.setUserData(newRowId, 'isAllowMultChoice', cfIsMultChoice.toString());
	cftCustomFieldsGrid.setUserData(newRowId, 'defaultValue', cfDefVal);
	cftCustomFieldsGrid.setUserData(newRowId, 'minValue', cfMinVal);
	cftCustomFieldsGrid.setUserData(newRowId, 'maxValue', cfMaxVal);
	ChangeSortByOrder(cftCustomFieldsGrid, 4);
}

function UpdateCustomFieldTableCustomField(multiple, isInline, customFieldId, currentCustomFieldType) {
	var thisCFCId;
	var updateChoices = false;
	var cfName;
	var cfSort;
	var cfDefVal;
	var cfIsAllowMultChoice = false;
	var cfIsShowInList = false;
	var cfIsVisibleRSVP;
	var cfIsRequired;
	var cfMinVal;
	var cfMaxVal;
	var cfDesc;
	var cfWidth = 0;

	if (multiple) {
		for (var i = 0; i < cftCustomFieldsGrid.getRowsNum(); i++) {
			thisCFCId = cftCustomFieldsGrid.getRowId(i);
			cfcFormType = cftCustomFieldsGrid.cells2(i, 1).getValue();
			cfName = cftCustomFieldsGrid.cells2(i, 0).getValue();
			cfSort = cftCustomFieldsGrid.cells2(i, 4).getValue();
			cfWidth = parseInt(cftCustomFieldsGrid.cells2(i, 2).getValue());
			cfIsAllowMultChoice = (cftCustomFieldsGrid.getUserData(thisCFCId, 'isAllowMultChoice').toLowerCase() === "true");
			cfDefVal = cftCustomFieldsGrid.getUserData(thisCFCId, 'defaultValue');
			cfIsRequired = GridCboxIsChecked(cftCustomFieldsGrid.cells2(i, 3).getValue());
			cfMinVal = 0;
			cfMaxVal = 0;
			cfDesc = '';
			/*
			if(cfName.indexOf('&') != -1){
				cfName = cfName.replace(ampRegex, '&amp;');
			}
			*/
			if (cfcFormType == 'INT') {
				cfMinVal = cftCustomFieldsGrid.getUserData(thisCFCId, 'minValue');
				cfMaxVal = cftCustomFieldsGrid.getUserData(thisCFCId, 'maxValue');
			}
			PanteraScript.PanteraScriptService.UpdateCustomFieldTableCustomField(pjqSessionId, thisCFCId, cfName, cfDesc, cfSort, cfcFormType, cfDefVal, cfMinVal, cfMaxVal, cfIsAllowMultChoice, cfIsRequired, cfWidth, updateChoices, CustomFieldTableCustomFieldSaved, onScriptError);
		}
	}
	else if (isInline) {
		cfcFormType = cftCustomFieldsGrid.cells(customFieldId, 1).getValue();
		cfName = cftCustomFieldsGrid.cells(customFieldId, 0).getValue();
		cfSort = cftCustomFieldsGrid.cells(customFieldId, 4).getValue();
		cfWidth = parseInt(cftCustomFieldsGrid.cells2(customFieldId, 2).getValue());
		cfIsAllowMultChoice = (cftCustomFieldsGrid.getUserData(thisCFCId, 'isAllowMultChoice').toLowerCase() === "true")
		cfDefVal = cftCustomFieldsGrid.getUserData(customFieldId, 'defaultValue');
		cfIsRequired = GridCboxIsChecked(cftCustomFieldsGrid.cells(customFieldId, 3).getValue());
		cfMinVal = 0;
		cfMaxVal = 0;
		cfDesc = '';
		/*
		if(cfName.indexOf('&') != -1){
			cfName = cfName.replace(ampRegex, '&amp;');
		}
		*/
		if (cfcFormType == 'INT') {
			cfMinVal = cftCustomFieldsGrid.getUserData(customFieldId, 'minValue');
			cfMaxVal = cftCustomFieldsGrid.getUserData(customFieldId, 'maxValue');
		}
		PanteraScript.PanteraScriptService.UpdateCustomFieldTableCustomField(pjqSessionId, customFieldId, cfName, cfDesc, cfSort, cfcFormType, cfDefVal, cfMinVal, cfMaxVal, cfIsAllowMultChoice, cfIsRequired, cfWidth, updateChoices, CustomFieldTableCustomFieldSaved, onScriptError);
	}
	else {
		updateChoices = true;
		cfName = jQuery('#customFieldName').val();
		cfSort = parseInt(jQuery('#customFieldSortOrder').val());
		cfDefVal = jQuery('#customFieldDefaultValue-' + currentCustomFieldType).val();
		cfDefVal = cfDefVal ? cfDefVal : '';
		cfIsRequired = jQuery('#customFieldTablecfRequired').prop('checked');
		cfWidth = parseInt(jQuery('#customFieldTablecfWidthPercent').val());
		cfMinVal = 0;
		cfMaxVal = 0;
		cfDesc = '';
		/*
		if(cfName.indexOf('&') != -1){
			cfName = cfName.replace(ampRegex, '&amp;');
		}
		*/
		if (currentCustomFieldType == 'CHOICE') {
			cfIsAllowMultChoice = jQuery('#customFieldTablecfIsMultChoice').prop('checked');
			cfDefVal = '';
		}
		else if (currentCustomFieldType == 'INT') {
			if (jQuery('#customFieldMinVal').val().length > 0) {
				cfMinVal = jQuery('#customFieldMinVal').val();
			}
			if (jQuery('#customFieldMaxVal').val().length > 0) {
				cfMaxVal = jQuery('#customFieldMaxVal').val();
			}
		}
		else if (currentCustomFieldType == 'DATETIME') {
			cfDefVal = jQuery('#customFieldDefaultValue-DATETIMEDATE').val() + ' ' + jQuery('#customFieldDefaultValue-DATETIMETIME').val();
		}
		else if (currentCustomFieldType == 'FILE') {
			cfIsAllowMultChoice = jQuery('#customFieldTablecfIsMultChoice').prop('checked');
		}

		PanteraScript.PanteraScriptService.UpdateCustomFieldTableCustomField(pjqSessionId, customFieldId, cfName, cfDesc, cfSort, currentCustomFieldType, cfDefVal, cfMinVal, cfMaxVal, cfIsAllowMultChoice, cfIsRequired, cfWidth, updateChoices, CustomFieldTableCustomFieldSaved, onScriptError);
		cftCustomFieldsGrid.cells(customFieldId, 0).setValue(cfName);
		cftCustomFieldsGrid.cells(customFieldId, 1).setValue(currentCustomFieldType);
		cftCustomFieldsGrid.cells(customFieldId, 2).setValue(cfWidth);
		cftCustomFieldsGrid.cells(customFieldId, 3).setValue(cfIsRequired);
		ChangeRowSortOrder(cftCustomFieldsGrid, customFieldId, 4, cfSort);
		cftCustomFieldsGrid.cells(customFieldId, 4).setValue(cfSort);
		cftCustomFieldsGrid.setUserData(customFieldId, 'isAllowMultChoice', cfIsAllowMultChoice.toString());
		cftCustomFieldsGrid.setUserData(customFieldId, 'defaultValue', cfDefVal);
		cftCustomFieldsGrid.setUserData(customFieldId, 'minValue', cfMinVal);
		cftCustomFieldsGrid.setUserData(customFieldId, 'maxValue', cfMaxVal);
	}

}

function CustomFieldTableCustomFieldSaved(response) {
	var customFieldTableCFResult = jQuery.parseJSON(response);
	var cfChoiceName;
	var cfChoiceSort;
	var cfId = customFieldTableCFResult.RowId;
	var currentCFRowId = customFieldTableCFResult.CurrentRowId;
	var currentCFCRowId;
	var currentRowIndex;
	if (currentCFRowId != null) {
		currentRowIndex = cftCustomFieldsGrid.getRowIndex(currentCFRowId);
		cftCustomFieldsGrid.setRowId(currentRowIndex, cfId);
	}
	if (customFieldTableCFResult.FieldType == 'CHOICE' && customFieldTableCFResult.UpdateChoices == true) {
		AddUpdateCustomFieldTableCustomFieldChoices(cfId);
	}
	try {
		customFieldDialog.dialog('destroy');
	} catch (err) {
	}

}

var customFieldTableCustomFieldChoicesGrid, tbCustomFieldTableCustomFieldChoicesGrid,
	customFieldTableCustomFieldChoicesGridMenu;

function GetCustomFieldTableCustomFieldChoices(customFieldId) {
	customFieldTableCustomFieldChoicesGridMenu = new dhtmlXMenuObject('gridMenu');
	customFieldTableCustomFieldChoicesGridMenu.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/");
	customFieldTableCustomFieldChoicesGridMenu.renderAsContextMenu();
	customFieldTableCustomFieldChoicesGridMenu.attachEvent("onClick", function (id, zoneId) {
		onGridMenuButtonClick(customFieldTableCustomFieldChoicesGrid, zoneId, id);
	});
	customFieldTableCustomFieldChoicesGridMenu.loadXMLString(menuXML);

	customFieldTableCustomFieldChoicesGrid = new dhtmlXGridObject('customFieldTableCFChoicesGrid');
	customFieldTableCustomFieldChoicesGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	customFieldTableCustomFieldChoicesGrid.setSkin(pjqGridTheme);
	customFieldTableCustomFieldChoicesGrid.enableAutoHeight(true);
	//projectCustomFieldChoicesGrid.enableAutoWidth(true);
	customFieldTableCustomFieldChoicesGrid.enableDragAndDrop(true);
	customFieldTableCustomFieldChoicesGrid.setDragBehavior('complex');
	customFieldTableCustomFieldChoicesGrid.enableMultiselect(true);
	customFieldTableCustomFieldChoicesGrid.enableContextMenu(customFieldTableCustomFieldChoicesGridMenu);
	customFieldTableCustomFieldChoicesGrid.load("/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=CustomFieldTableCustomFieldChoices&customFieldid=" + customFieldId, "xml");
	customFieldTableCustomFieldChoicesGrid.init();
	customFieldTableCustomFieldChoicesGrid.attachEvent("onRowSelect", function (id, ind) {
		EnableToolBarButton(tbCustomFieldTableCustomFieldChoicesGrid, 'delete');
	});
	customFieldTableCustomFieldChoicesGrid.attachEvent("onXLE", function (grid_obj, count) {
		jQuery('#customFieldTableCFChoicesGridContainer').removeClass(pjqHidden);
		UpdateCustomFieldChoicesDefaultValueDropDown(cftCustomFieldsGrid, customFieldTableCustomFieldChoicesGrid, customFieldId);
	});
	customFieldTableCustomFieldChoicesGrid.attachEvent("onEditCell", function (stage, rId, cInd, nValue, oValue) {
		if (stage == 2) {
			return UpdateCustomFieldChoicesDefaultValueDropDown(cftCustomFieldsGrid, customFieldTableCustomFieldChoicesGrid, customFieldId);
		}
	});
	customFieldTableCustomFieldChoicesGrid.attachEvent("onBeforeContextMenu", function (id, ind, obj) {
		customFieldTableCustomFieldChoicesGrid.selectRowById(id, false, false, true);
		return true;
	});
	customFieldTableCustomFieldChoicesGrid.attachEvent("onDrop", function (id, ind, obj) {
		ChangeSortByOrder(customFieldTableCustomFieldChoicesGrid, 1);
	});
	customFieldTableCustomFieldChoicesGrid.attachEvent("onEnter", function (rid, cInd) {
		customFieldTableCustomFieldChoicesGrid.editStop();
	});


	tbCustomFieldTableCustomFieldChoicesGrid = new dhtmlXToolbarObject("customFieldTableCFChoicesToolbar");
	tbCustomFieldTableCustomFieldChoicesGrid.setSkin("dhx_web");
	tbCustomFieldTableCustomFieldChoicesGrid.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
	tbCustomFieldTableCustomFieldChoicesGrid.addButton('add', 0, 'Add', "new.gif", "new_dis.gif");
	tbCustomFieldTableCustomFieldChoicesGrid.addButton('delete', 4, 'Delete', "Delete.png", "DeleteD.png");
	tbCustomFieldTableCustomFieldChoicesGrid.disableItem('delete');
	tbCustomFieldTableCustomFieldChoicesGrid.attachEvent("onClick", function (id) {
		switch (id) {
			case 'add':
				AddNewGridRow(customFieldTableCustomFieldChoicesGrid);
				break;
			case 'delete':
				var selRow = customFieldTableCustomFieldChoicesGrid.getSelectedRowId();
				var customFieldTableCFCName;
				var deleteType;
				if (selRow.indexOf(',') == -1 && selRow.indexOf('newRow') == -1) {
					cfChoiceDeleteArray.push(selRow);
				}
				else {
					tempCFArray = selRow.split(',');
					for (i = 0; i < tempCFArray.length; i++) {
						if (tempCFArray[i].indexOf('newRow') == -1) {
							cfChoiceDeleteArray.push(tempCFArray[i]);
						}
					}
				}
				DeleteGridRow(customFieldTableCustomFieldChoicesGrid, selRow, false);
				break;
		}
	});
}


function AddUpdateCustomFieldTableCustomFieldChoices(customFieldId) {
	if (customFieldTableCustomFieldChoicesGrid) {

		for (i = 0; i < customFieldTableCustomFieldChoicesGrid.getRowsNum(); i++) {
			currentCFCRowId = customFieldTableCustomFieldChoicesGrid.getRowId(i);
			cfChoiceName = customFieldTableCustomFieldChoicesGrid.cells2(i, 0).getValue();
			cfChoiceSort = customFieldTableCustomFieldChoicesGrid.cells2(i, 1).getValue();
			/*
            if(cfChoiceName.indexOf('&') != -1){
                cfChoiceName = cfChoiceName.replace(ampRegex, '&amp;');
            }
            */
			if (currentCFCRowId.indexOf('new') != -1) {
				PanteraScript.PanteraScriptService.AddCustomFieldTableCustomFieldChoice(pjqSessionId, customFieldId, currentCFCRowId, cfChoiceName, cfChoiceSort, CustomFieldTableCustomFieldChoiceSaved, onScriptError);
			}
			else {
				PanteraScript.PanteraScriptService.UpdateCustomFieldTableCustomFieldChoice(pjqSessionId, parseInt(customFieldId), parseInt(currentCFCRowId), cfChoiceName, parseInt(cfChoiceSort), CustomFieldTableCustomFieldChoiceSaved, onScriptError);
			}
		}
		customFieldTableCustomFieldChoicesGrid.destructor();
	}
	ResetCustomFieldForm();
}

function CustomFieldTableCustomFieldChoiceSaved(response) {
	var customFieldTableCFCResult = jQuery.parseJSON(response);
	var defaultValueId = jQuery('#customFieldDefaultValue-CHOICE').val();
	if (defaultValueId == customFieldTableCFCResult.CurrentRowId) {
		cftCustomFieldGrid.setUserData(customFieldTableCFCResult.CustomFieldId, 'defaultValue', customFieldTableCFCResult.RowId);
		PanteraScript.PanteraScriptService.UpdateCustomFieldTableCustomFieldDefaultValue(pjqSessionId, customFieldTableCFCResult.CustomFieldId, customFieldTableCFCResult.RowId, SettingSavedCallback, onScriptError);
	}
}

var customFieldInfo = null;
function GetFieldReportCustomFieldInfoC(response) {
	var customFieldInfoTemp = jQuery.parseJSON(response);
	customFieldInfo = [];
	for (var i = 0; i < customFieldInfoTemp.length; i++) {

		if (lastCustomFieldId != customFieldInfoTemp[i].FieldReportCustomFieldId) {
			if (customFieldInfoTemp[i].FieldType == 'BOOL' || customFieldInfoTemp[i].FieldType == 'CHOICE')
				customFieldInfo.push(customFieldInfoTemp[i]);
		}
	}

	if (customFieldInfo.length == 0) {
		InitNotifyDialog(null, 'Please add at least one Yes/No or Choice field before using this feature.', 'No Fields Available');
		return;
	}

	newRowCounter++;
	var rowData = ['', ''];
	var newRowId = 'newRow' + newRowCounter;
	customFieldConstraintsGrid.addRow(newRowId, rowData);
	EditGridCell(customFieldConstraintsGrid, null, 0);
}

function GetFieldReportCustomFieldInfo2C(response) {
	var customFieldInfoTemp = jQuery.parseJSON(response);
	customFieldInfo = [];

	var combo = customFieldConstraintsGrid.getCombo(0);
	combo.clear();
	combo.put('', 'Select...');

	for (var i = 0; i < customFieldInfoTemp.length; i++) {

		if (lastCustomFieldId != customFieldInfoTemp[i].FieldReportCustomFieldId) {
			if (customFieldInfoTemp[i].FieldType == 'BOOL' || customFieldInfoTemp[i].FieldType == 'CHOICE') {
				customFieldInfo.push(customFieldInfoTemp[i]);
				combo.put(customFieldInfoTemp[i].FieldReportCustomFieldId.toString(), customFieldInfoTemp[i].FieldName);
			}
		}
	}

}

function boolToInt(value) {
	return value == true ? 1 : 0;
}

var userSeatsAdminGrid, userSeatsVendorGrid, userSeatsGridLoadCount, userSeatsVendorToolbar;

function GetUserSeatsSettings() {
	userSeatsGridLoadCount = 0;
	userSeatsAdminGrid = new dhtmlXGridObject('gridUserSeatsAdmin');
	userSeatsAdminGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	userSeatsAdminGrid.setSkin(pjqGridTheme);
	userSeatsAdminGrid.enableAutoHeight(true);
	userSeatsAdminGrid.enablePaging(true, 10, 3, "pagingUserSeatsAdmin", true, null);
	userSeatsAdminGrid.setPagingSkin("toolbar", 'dhx_web');
	userSeatsAdminGrid.load("/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=UserSeatsAdmin&customFieldid=0", UserSeatGridLoaded, "xml");
	userSeatsAdminGrid.enableDragAndDrop(true);
	userSeatsAdminGrid.init();

	userSeatsVendorToolbar = new dhtmlXToolbarObject("toolbarUserSeatsVendor");
	userSeatsVendorToolbar.setSkin("dhx_web");
	userSeatsVendorToolbar.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
	userSeatsVendorToolbar.addButton('remove', 0, 'Remove Checked Seats', "Delete.png", "DeleteD.png");
	userSeatsVendorToolbar.disableItem('remove');
	userSeatsVendorToolbar.attachEvent("onClick", function (id) {
		switch (id) {
			case 'remove':
				var id = userSeatsVendorGrid.getCheckedRows(0);
				var type = 'delete';
				if (id.indexOf(',') != -1)
					type = 'deleteMultiple';
				CreateDialog(userSeatsVendorGrid, type, null, id);
				break;
		}
	});

	userSeatsVendorGrid = new dhtmlXGridObject('gridUserSeatsVendor');
	userSeatsVendorGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	userSeatsVendorGrid.setSkin(pjqGridTheme);
	userSeatsVendorGrid.enableAutoHeight(true);
	userSeatsVendorGrid.enablePaging(true, 10, 3, "pagingUserSeatsVendor", true, null);
	userSeatsVendorGrid.setPagingSkin("toolbar", 'dhx_web');
	userSeatsVendorGrid.attachEvent("onCheck", function (rId, cInd, state) {
		UserSeatTotalsCalculate();
	});

	//userSeatsVendorGrid.enableContextMenu(projectStatusGridMenu);
	userSeatsVendorGrid.load("/DesktopModules/PJQSettings/GetSettingsGridXml.aspx?sessionid=" + pjqSessionId + "&gridid=UserSeatsVendor&customFieldid=0", UserSeatGridLoaded, "xml");
	userSeatsVendorGrid.enableDragAndDrop(true);
	userSeatsVendorGrid.init();

}

function UserSeatGridLoaded() {
	userSeatsGridLoadCount++;
	if (userSeatsGridLoadCount >= 2) {
		UserSeatTotalsCalculate();
		jQuery('#planroomUserSeatsTab').removeClass(pjqHidden);
	}
}

function UserSeatTotalsCalculate() {
	var total = userSeatsAdminGrid.getRowsNum() + userSeatsVendorGrid.getRowsNum();
	jQuery('#user-seats-admin').html(userSeatsAdminGrid.getRowsNum().toString() + ' Seats');
	jQuery('#user-seats-vendor').html(userSeatsVendorGrid.getRowsNum().toString() + ' Seats');
	jQuery('#user-seats-total').html('You are currently using ' + total.toString() + ' of ' + settings.UserSeatLimit.toString() + ' Seats');

	if (userSeatsVendorGrid.getCheckedRows(0))
		EnableToolBarButton(userSeatsVendorToolbar, "remove");
	else
		DisableToolBarButton(userSeatsVendorToolbar, "remove");

}

dhtmlXGridObject.prototype._in_header_master_checkbox_vendor_seats = function (a, b, c) {
	a.innerHTML = c[0] + "<input type='checkbox' />" + c[1];
	var d = this;
	a.getElementsByTagName("input")[0].onclick = function (a) {
		d._build_m_order();
		var c = d._m_order ? d._m_order[b] : b,
			g = this.checked ? 1 : 0;
		d.forEachRowA(function (a) {
			var b = this.cells(a, c);
			if (b.isCheckbox() && !b.isDisabled())
				b.setValue(g), b.cell.wasChanged = !0;
			this.callEvent("onEditCell", [1, a, c, g]);
			this.callEvent("onCheckbox", [a, c, g])
		});

		UserSeatTotalsCalculate();

		(a || event).cancelBubble = !0;
	}
};

